const MenorItems = [
    {
        number: 1,
        question: '¿Cuál es el fin principal del hombre?',
        answer: 'El fin principal del hombre es el de glorificar a Dios, y gozar de él para siempre.',
        proofs: [
            {
                ref: 'Salmos 86:9',
                text: 'Todas las naciones que tú has hecho vendrán y adorarán delante de ti, Señor, y glorificarán tu nombre.'
            },
            {
                ref: 'Isaias 60:21',
                text: 'Entonces todos los de tu pueblo serán justos; para siempre poseerán la tierra, vástago de mi plantío, obra de mis manos, para que yo me glorifique.'
            },
            {
                ref: 'Romanos 11:36',
                text: 'Porque de Él, por Él y para Él son todas las cosas. A Él sea la gloria para siempre. Amén.'
            },
            {
                ref: '1 Corintios 6:20',
                text: 'Pues por precio habéis sido comprados; por tanto, glorificad a Dios en vuestro cuerpo y en vuestro espíritu, los cuales son de Dios.'
            },
            {
                ref: '1 Corintios 10:31',
                text: 'Entonces, ya sea que comáis, que bebáis, o que hagáis cualquier otra cosa, hacedlo todo para la gloria de Dios.'
            },
            {
                ref: 'Apocalipsis 4:11',
                text: 'Digno eres, Señor y Dios nuestro, de recibir la gloria y el honor y el poder, porque tú creaste todas las cosas, y por tu voluntad existen y fueron creadas.'
            },
            {
                ref: 'Salmos 16:5–11',
                text: 'El Señor es la porción de mi herencia y de mi copa; tú sustentas mi suerte. Las cuerdas cayeron para mí en lugares agradables; en verdad mi herencia es hermosa para mí. Bendeciré al Señor que me aconseja; en verdad, en las noches mi corazón me instruye. Al Señor he puesto continuamente delante de mí; porque está a mi diestra, permaneceré firme. Por tanto, mi corazón se alegra y mi alma se regocija; también mi carne morará segura, pues tú no abandonarás mi alma en el Seol, ni permitirás a tu Santo ver corrupción. Me darás a conocer la senda de la vida; en tu presencia hay plenitud de gozo; en tu diestra, deleites para siempre.'
            },
            {
                ref: 'Salmos 144:15',
                text: 'Bienaventurado el pueblo a quien así le sucede; bienaventurado el pueblo cuyo Dios es el Señor.'
            },
            {
                ref: 'Isaias 12:2',
                text: 'He aquí, Dios es mi salvador, confiaré y no temeré; porque mi fortaleza y mi canción es el Señor Dios, Él ha sido mi salvación.'
            },
            {
                ref: 'Lucas 2:10',
                text: 'Mas el ángel les dijo: No temáis, porque he aquí, os traigo buenas nuevas de gran gozo que serán para todo el pueblo;'
            },
            {
                ref: 'Filipenses 4:4',
                text: 'Regocijaos en el Señor siempre. Otra vez lo diré: ¡Regocijaos!'
            },
            {
                ref: 'Apocalipsis 21:3–4',
                text: 'Entonces oí una gran voz que decía desde el trono: He aquí, el tabernáculo de Dios está entre los hombres, y Él habitará entre ellos y ellos serán su pueblo, y Dios mismo estará entre ellos. Él enjugará toda lágrima de sus ojos, y ya no habrá muerte, ni habrá más duelo, ni clamor, ni dolor, porque las primeras cosas han pasado.'
            }
        ]
    },
    {
        number: 2,
        question: '¿Qué regla ha dado Dios para enseñarnos cómo hemos de glorificarle y gozar de él?',
        answer: 'La palabra de Dios que se contiene en las Escrituras del Antiguo y del Nuevo Testamento, es la única regla que ha dado Dios para enseñarnos cómo hemos de glorificarle y gozar de él.',
        proofs: [
            {
                ref: 'Mateo 19:4–5',
                text: 'Y respondiendo Jesús, dijo: ¿No habéis leído que aquel que los creó, desde el principio los hizo varón y hembra, y añadió: «Por esta razón el hombre dejará a su padre y a su madre y se unirá a su mujer, y los dos serán una sola carne»?'
            },
            {
                ref: 'Genesis 2:24',
                text: 'Por tanto el hombre dejará a su padre y a su madre y se unirá a su mujer, y serán una sola carne.'
            },
            {
                ref: 'Lucas 24:27, 44',
                text: 'Y comenzando por Moisés y continuando con todos los profetas, les explicó lo referente a Él en todas las Escrituras. [...] Y les dijo: Esto es lo que yo os decía cuando todavía estaba con vosotros: que era necesario que se cumpliera todo lo que sobre mí está escrito en la ley de Moisés, en los profetas y en los salmos.'
            },
            {
                ref: '1 Corintios 2:13',
                text: 'de lo cual también hablamos, no con palabras enseñadas por sabiduría humana, sino con las enseñadas por el Espíritu, combinando pensamientos espirituales con palabras espirituales.'
            },
            {
                ref: '1 Corintios 14:37',
                text: 'Si alguno piensa que es profeta o espiritual, reconozca que lo que os escribo es mandamiento del Señor.'
            },
            {
                ref: '2 Pedro 1:20–21',
                text: 'Pero ante todo sabed esto, que ninguna profecía de la Escritura es asunto de interpretación personal, pues ninguna profecía fue dada jamás por un acto de voluntad humana, sino que hombres inspirados por el Espíritu Santo hablaron de parte de Dios.'
            },
            {
                ref: '2 Pedro 3:2,15–16',
                text: 'para que recordéis las palabras dichas de antemano por los santos profetas, y el mandamiento del Señor y Salvador declarado por vuestros apóstoles. [...] y considerad la paciencia de nuestro Señor como salvación, tal como os escribió también nuestro amado hermano Pablo, según la sabiduría que le fue dada. Asimismo en todas sus cartas habla en ellas de esto; en las cuales hay algunas cosas difíciles de entender, que los ignorantes e inestables tuercen—como también tuercen el resto de las Escrituras—para su propia perdición.'
            },
            {
                ref: 'Deuteronomio 4:2 ',
                text: 'No añadiréis nada a la palabra que yo os mando, ni quitaréis nada de ella, para que guardéis los mandamientos del Señor vuestro Dios que yo os mando.'
            },
            {
                ref: 'Salmos 19:7–11',
                text: 'La ley del Señor es perfecta, que restaura el alma; el testimonio del Señor es seguro, que hace sabio al sencillo. Los preceptos del Señor son rectos, que alegran el corazón; el mandamiento del Señor es puro, que alumbra los ojos. El temor del Señor es limpio, que permanece para siempre; los juicios del Señor son verdaderos, todos ellos justos; deseables más que el oro; sí, más que mucho oro fino, más dulces que la miel y que el destilar del panal. Además, tu siervo es amonestado por ellos; en guardarlos hay gran recompensa.'
            },
            {
                ref: 'Isaias 8:20',
                text: '¡A la ley y al testimonio! Si no hablan conforme a esta palabra, es porque no hay para ellos amanecer.'
            },
            {
                ref: 'Juan 15:11',
                text: 'Estas cosas os he hablado, para que mi gozo esté en vosotros, y vuestro gozo sea perfecto.'
            },
            {
                ref: 'Juan 20:30–31',
                text: 'Y muchas otras señales hizo también Jesús en presencia de sus discípulos, que no están escritas en este libro; pero estas se han escrito para que creáis que Jesús es el Cristo, el Hijo de Dios; y para que al creer, tengáis vida en su nombre.'
            },
            {
                ref: 'Hechos 17:11',
                text: 'Estos eran más nobles que los de Tesalónica, pues recibieron la palabra con toda solicitud, escudriñando diariamente las Escrituras, para ver si estas cosas eran así.'
            },
            {
                ref: '2 Timoteo 3:15–17',
                text: 'y que desde la niñez has sabido las Sagradas Escrituras, las cuales te pueden dar la sabiduría que lleva a la salvación mediante la fe en Cristo Jesús. Toda Escritura es inspirada por Dios y útil para enseñar, para reprender, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, equipado para toda buena obra.'
            },
            {
                ref: '1 Juan 1:4',
                text: 'Os escribimos estas cosas para que nuestro gozo sea completo.'
            }
        ]
    },
    {
        number: 3,
        question: '¿Qué es lo que principalmente enseñan las Escrituras?',
        answer: 'Lo que principalmente enseñan las Escrituras es lo que el hombre ha de creer respecto a Dios y los deberes que Dios impone al hombre.',
        proofs: [
            {
                ref: 'Genesis 1:1',
                text: 'En el principio creó Dios los cielos y la tierra.'
            },
            {
                ref: 'Juan 5:39',
                text: 'Examináis las Escrituras porque vosotros pensáis que en ellas tenéis vida eterna; y ellas son las que dan testimonio de mí;'
            },
            {
                ref: 'Juan 20:31',
                text: 'pero estas se han escrito para que creáis que Jesús es el Cristo, el Hijo de Dios; y para que al creer, tengáis vida en su nombre.'
            },
            {
                ref: 'Romanos 10:17',
                text: 'Así que la fe viene del oír, y el oír, por la palabra de Cristo.'
            },
            {
                ref: '2 Timoteo 3:15',
                text: 'y que desde la niñez has sabido las Sagradas Escrituras, las cuales te pueden dar la sabiduría que lleva a la salvación mediante la fe en Cristo Jesús.'
            },
            {
                ref: 'Deuteronomio 10:12–13',
                text: 'Y ahora, Israel, ¿qué requiere de ti el Señor tu Dios, sino que temas al Señor tu Dios, que andes en todos sus caminos, que le ames y que sirvas al Señor tu Dios con todo tu corazón y con toda tu alma, y que guardes los mandamientos del Señor y sus estatutos que yo te ordeno hoy para tu bien?'
            },
            {
                ref: 'Josue 1:8',
                text: 'Este libro de la ley no se apartará de tu boca, sino que meditarás en él día y noche, para que cuides[a] de hacer todo lo que en él está escrito; porque entonces harás prosperar tu camino y tendrás éxito.'
            },
            {
                ref: 'Salmos 119:105',
                text: 'Lámpara es a mis pies tu palabra, y luz para mi camino.'
            },
            {
                ref: 'Miqueas 6:8',
                text: 'Él te ha declarado, oh hombre, lo que es bueno. ¿Y qué es lo que demanda el Señor de ti, sino solo practicar la justicia, amar la misericordia, y andar humildemente con tu Dios?'
            },
            {
                ref: '2 Timoteo 3:16–17',
                text: 'Toda Escritura es inspirada por Dios y útil para enseñar, para reprender, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, equipado para toda buena obra.'
            }
        ]
    },
    {
        number: 4,
        question: '¿Qué es Dios?',
        answer: 'Dios es un Espíritu, infinito, eterno e inmutable en Su ser, sabiduría, poder, santidad, bondad, justicia y verdad.',
        proofs: [
            {
                "ref": "Deuteronomio 4:15–19",
                "text": "Así que guardaos bien, ya que no visteis ninguna figura el día en que el Señor os habló en Horeb de en medio del fuego; no sea que os corrompáis y hagáis para vosotros una imagen tallada semejante a cualquier figura: semejanza de varón o hembra, semejanza de cualquier animal que está en la tierra, semejanza de cualquier ave que vuela en el cielo, semejanza de cualquier animal que se arrastra sobre la tierra, semejanza de cualquier pez que hay en las aguas debajo de la tierra. No sea que levantes los ojos al cielo y veas el sol, la luna, las estrellas y todo el ejército del cielo, y seas impulsado a adorarlos y servirlos, cosas que el Señor tu Dios ha concedido a todos los pueblos debajo de todos los cielos."
            },
            {
                "ref": "Lucas 24:39",
                "text": "Mirad mis manos y mis pies, que soy yo mismo; palpadme y ved, porque un espíritu no tiene carne ni huesos como veis que yo tengo."
            },
            {
                "ref": "Juan 1:18",
                "text": "Nadie ha visto jamás a Dios; el unigénito Dios, que está en el seno del Padre, Él le ha dado a conocer."
            },
            {
                "ref": "Juan 4:24",
                "text": "Dios es espíritu, y los que le adoran deben adorarle en espíritu y en verdad."
            },
            {
                "ref": "Hechos 17:29",
                "text": "Siendo, pues, linaje de Dios, no debemos pensar que la naturaleza divina sea semejante a oro, plata o piedra, esculpidos por el arte y el pensamiento humano."
            },
            {
                "ref": "1 Reyes 8:27",
                "text": "Pero, ¿morará verdaderamente Dios sobre la tierra? He aquí, los cielos y los cielos de los cielos no te pueden contener, cuánto menos esta casa que yo he edificado."
            },
            {
                "ref": "Salmos 139:7–10",
                "text": "¿Adónde me iré de tu Espíritu, o adónde huiré de tu presencia? Si subo a los cielos, he aquí, allí estás tú; si en el Seol preparo mi lecho, allí estás tú. Si tomo las alas del alba, y si habito en lo más remoto del mar, aun allí me guiará tu mano, y me asirá tu diestra."
            },
            {
                "ref": "Salmos 145:3",
                "text": "Grande es el Señor, y digno de ser alabado en gran manera; y su grandeza es inescrutable."
            },
            {
                "ref": "Salmos 147:5",
                "text": "Grande es nuestro Señor, y muy poderoso; su entendimiento es infinito."
            },
            {
                "ref": "Jeremias 23:24",
                "text": "¿Podrá alguno esconderse en escondites de modo que yo no lo vea? —declara el Señor. ¿No lleno yo los cielos y la tierra? —declara el Señor."
            },
            {
                "ref": "Romanos 11:33–36",
                "text": "¡Oh, profundidad de las riquezas y de la sabiduría y del conocimiento de Dios! ¡Cuán insondables son sus juicios e inescrutables sus caminos! Pues, ¿quién ha conocido la mente del Señor?, ¿o quién llego a ser su consejero?, ¿o quién le ha dado a Él primero para que se le tenga que recompensar? Porque de Él, por Él y para Él son todas las cosas. A Él sea la gloria para siempre. Amén."
            },
            {
                "ref": "Deuteronomio 33:27",
                "text": "El eterno Dios es tu refugio, y debajo están los brazos eternos. El echó al enemigo delante de ti, y dijo: «¡Destruye!»."
            },
            {
                "ref": "Salmos 90:2",
                "text": "Antes que los montes fueran engendrados, y nacieran la tierra y el mundo, desde la eternidad y hasta la eternidad, tú eres Dios."
            },
            {
                "ref": "Salmos 102:12",
                "text": "Mas tú, Señor, permaneces para siempre, y tu nombre por todas las generaciones."
            },
            {
                "ref": "Salmos 102:24–27",
                "text": "Dije: Dios mío, no me lleves en la mitad de mis días; tus años son por todas las generaciones. Desde la antigüedad tú fundaste la tierra, y los cielos son la obra de tus manos. Ellos perecerán, pero tú permaneces; y todos ellos como una vestidura se desgastarán, como vestido los mudarás, y serán cambiados. Pero tú eres el mismo, y tus años no tendrán fin."
            },
            {
                "ref": "Apocalipsis 1:4",
                "text": "Juan, a las siete iglesias que están en Asia: Gracia a vosotros y paz, de aquel que es y que era y que ha de venir, y de los siete Espíritus que están delante de su trono,"
            },
            {
                "ref": "Apocalipsis 1:8",
                "text": "Yo soy el Alfa y la Omega —dice el Señor Dios— el que es y que era y que ha de venir, el Todopoderoso."
            },
            {
                "ref": "Salmos 33:11",
                "text": "El consejo del Señor permanece para siempre, los designios de su corazón de generación en generación."
            },
            {
                "ref": "Malaquias 3:6",
                "text": "Porque yo, el Señor, no cambio; por eso vosotros, oh hijos de Jacob, no habéis sido consumidos."
            },
            {
                "ref": "Hebreos 1:12",
                "text": "y como un manto los enrollarás; como una vestidura serán mudados. Pero tú eres el mismo, y tus años no tendrán fin."
            },
            {
                "ref": "Hebreos 6:17–18",
                "text": "Por lo cual Dios, deseando mostrar más plenamente a los herederos de la promesa la inmutabilidad de su propósito, interpuso un juramento, a fin de que por dos cosas inmutables, en las cuales es imposible que Dios mienta, los que hemos buscado refugio seamos grandemente animados para asirnos de la esperanza puesta delante de nosotros,"
            },
            {
                "ref": "Hebreos 13:8",
                "text": "Jesucristo es el mismo ayer y hoy y por los siglos."
            },
            {
                "ref": "Santiago 1:17",
                "text": "Toda buena dádiva y todo don perfecto viene de lo alto, desciende del Padre de las luces, con el cual no hay cambio ni sombra de variación."
            },
            {
                "ref": "Exodo 3:14",
                "text": "Y dijo Dios a Moisés: YO SOY EL QUE SOY. Y añadió: Así dirás a los hijos de Israel: «YO SOY me ha enviado a vosotros»."
            },
            {
                "ref": "Salmos 115:2–3",
                "text": "¿Por qué han de decir las naciones: ¿Dónde está ahora su Dios? Nuestro Dios está en los cielos; Él hace lo que le place."
            },
            {
                "ref": "1 Timoteo 1:17",
                "text": "Por tanto, al Rey eterno, inmortal, invisible, único Dios, a Él sea honor y gloria por los siglos de los siglos. Amén."
            },
            {
                "ref": "1 Timoteo 6:15–16",
                "text": "la cual manifestará a su debido tiempo el bienaventurado y único Soberano, el Rey de reyes y Señor de señores; el único que tiene inmortalidad y habita en luz inaccesible; a quien ningún hombre ha visto ni puede ver. A Él sea la honra y el dominio eterno. Amén."
            },
            {
                "ref": "Salmos 104:24",
                "text": "¡Cuán numerosas son tus obras, oh Señor! Con sabiduría las has hecho todas; llena está la tierra de tus posesiones."
            },
            {
                "ref": "Romanos 11:33–34",
                "text": "¡Oh, profundidad de las riquezas y de la sabiduría y del conocimiento de Dios! ¡Cuán insondables son sus juicios e inescrutables sus caminos! Pues, ¿quién ha conocido la mente del Señor?, ¿o quién llego a ser su consejero?,"
            },
            {
                "ref": "Hebreos 4:13",
                "text": "Y no hay cosa creada oculta a su vista, sino que todas las cosas están al descubierto y desnudas ante los ojos de aquel a quien tenemos que dar cuenta."
            },
            {
                "ref": "1 Juan 3:20",
                "text": "en cualquier cosa en que nuestro corazón nos condene; porque Dios es mayor que nuestro corazón y sabe todas las cosas."
            },
            {
                "ref": "Genesis 17:1",
                "text": "Cuando Abram tenía noventa y nueve años, el Señor se le apareció, y le dijo: Yo soy el Dios Todopoderoso; anda delante de mí, y sé perfecto."
            },
            {
                "ref": "Mateo 19:26",
                "text": "Pero Jesús, mirándolos, les dijo: Para los hombres eso es imposible, pero para Dios todo es posible."
            },
            {
                "ref": "Apocalipsis 1:8",
                "text": "Yo soy el Alfa y la Omega —dice el Señor Dios— el que es y que era y que ha de venir, el Todopoderoso."
            },
            {
                "ref": "Habakuk 1:13",
                "text": "Muy limpios son tus ojos para mirar el mal, y no puedes contemplar la opresión. ¿Por qué miras con agrado a los que proceden pérfidamente, y callas cuando el impío traga al que es más justo que él?"
            },
            {
                "ref": "1 Pedro 1:15–16",
                "text": "sino que así como aquel que os llamó es santo, así también sed vosotros santos en toda vuestra manera de vivir; porque escrito está: Sed santos, porque Yo soy santo."
            },
            {
                "ref": "1 Juan 3:3",
                "text": "Y todo el que tiene esta esperanza puesta en Él, se purifica, así como Él es puro."
            },
            {
                "ref": "1 Juan 3:5",
                "text": "Y vosotros sabéis que Él se manifestó a fin de quitar los pecados, y en Él no hay pecado."
            },
            {
                "ref": "Apocalipsis 15:4",
                "text": "¡Oh Señor! ¿Quién no temerá y glorificará tu nombre? Pues solo tú eres santo; porque todas las naciones vendrán y adorarán en tu presencia, pues tus justos juicios han sido revelados."
            },
            {
                "ref": "Genesis 18:25",
                "text": "Lejos de ti hacer tal cosa: matar al justo con el impío, de modo que el justo y el impío sean tratados de la misma manera. ¡Lejos de ti! El Juez de toda la tierra, ¿no hará justicia?"
            },
            {
                "ref": "Exodo 34:6–7",
                "text": "Entonces pasó el Señor por delante de él y proclamó: El Señor, el Señor, Dios compasivo y clemente, lento para la ira y abundante en misericordia y fidelidad; el que guarda misericordia a millares, el que perdona la iniquidad, la transgresión y el pecado, y que no tendrá por inocente al culpable; el que castiga la iniquidad de los padres sobre los hijos y sobre los hijos de los hijos hasta la tercera y cuarta generación."
            },
            {
                "ref": "Deuteronomio 32:4",
                "text": "¡La Roca! Su obra es perfecta, porque todos sus caminos son justos; Dios de fidelidad y sin injusticia, justo y recto es Él."
            },
            {
                "ref": "Romanos 3:5",
                "text": "Y si nuestra injusticia hace resaltar la justicia de Dios, ¿qué diremos? ¿Acaso es injusto el Dios que expresa su ira? (Hablo en términos humanos)."
            },
            {
                "ref": "Romanos 3:26",
                "text": "para demostrar en este tiempo su justicia, a fin de que Él sea justo y sea el que justifica al que tiene fe en Jesús."
            },
            {
                "ref": "Salmos 103:5",
                "text": "el que colma de bienes tus años, para que tu juventud se renueve como el águila."
            },
            {
                "ref": "Salmos 107:8",
                "text": "Den gracias al Señor por su misericordia y por sus maravillas para con los hijos de los hombres."
            },
            {
                "ref": "Mateo 19:17",
                "text": "Y Él le dijo: ¿Por qué me preguntas acerca de lo bueno? Solo Uno es bueno; pero si deseas entrar en la vida, guarda los mandamientos."
            },
            {
                "ref": "Romanos 2:4",
                "text": "¿O tienes en poco las riquezas de su bondad, tolerancia y paciencia, ignorando que la bondad de Dios te guía al arrepentimiento?"
            },
            {
                "ref": "Exodo 34:6",
                "text": "Entonces pasó el Señor por delante de él y proclamó: El Señor, el Señor, Dios compasivo y clemente, lento para la ira y abundante en misericordia y fidelidad;"
            },
            {
                "ref": "Deuteronomio 32:4",
                "text": "¡La Roca! Su obra es perfecta, porque todos sus caminos son justos; Dios de fidelidad y sin injusticia, justo y recto es Él."
            },
            {
                "ref": "Salmos 86:15",
                "text": "Mas tú, Señor, eres un Dios compasivo y lleno de piedad, lento para la ira y abundante en misericordia y fidelidad."
            },
            {
                "ref": "Salmos 117:2",
                "text": "Porque grande es su misericordia para con nosotros, y la fidelidad del Señor es eterna. ¡Aleluya!"
            },
            {
                "ref": "Hebreos 6:18",
                "text": "a fin de que por dos cosas inmutables, en las cuales es imposible que Dios mienta, los que hemos buscado refugio seamos grandemente animados para asirnos de la esperanza puesta delante de nosotros,"
            }
        ]
    },
    {
        number: 5,
        question: '¿Hay más de un Dios?',
        answer: 'No hay sino uno solo, el Dios Vivo y verdadero.',
        proofs: [
            {
                "ref": "Deuteronomio 6:4",
                "text": "Escucha, oh Israel, el Señor es nuestro Dios, el Señor uno es."
            },
            {
                "ref": "Isaias 44:6",
                "text": "Así dice el Señor, el Rey de Israel, y su Redentor, el Señor de los ejércitos: «Yo soy el primero y yo soy el último, y fuera de mí no hay Dios."
            },
            {
                "ref": "Isaias 45:21–22",
                "text": "Declarad y presentad vuestro caso; sí, que deliberen juntos: ¿Quién ha anunciado esto desde la antigüedad y lo ha declarado desde entonces? ¿No soy yo, el Señor? No hay más Dios que yo, un Dios justo y salvador; no hay ninguno fuera de mí. Volveos a mí y sed salvos, todos los términos de la tierra; porque yo soy Dios, y no hay ningún otro."
            },
            {
                "ref": "1 Corintios 8:4–6",
                "text": "Por tanto, en cuanto a comer de lo sacrificado a los ídolos, sabemos que un ídolo no es nada en el mundo, y que no hay sino un solo Dios. Porque aunque haya algunos llamados dioses, ya sea en el cielo o en la tierra, como por cierto hay muchos dioses y muchos señores, sin embargo, para nosotros hay un solo Dios, el Padre, de quien proceden todas las cosas y nosotros somos para Él; y un Señor, Jesucristo, por quien son todas las cosas y por medio del cual existimos nosotros."
            },
            {
                "ref": "Jeremias 10:10",
                "text": "Pero el Señor es el Dios verdadero; Él es el Dios vivo y el Rey eterno. Ante su enojo tiembla la tierra, y las naciones son impotentes ante su indignación."
            },
            {
                "ref": "Juan 17:3",
                "text": "Y esta es la vida eterna: que te conozcan a ti, el único Dios verdadero, y a Jesucristo, a quien has enviado."
            },
            {
                "ref": "1 Tesalonicenses 1:9",
                "text": "Pues ellos mismos cuentan acerca de nosotros, de la acogida que tuvimos por parte de vosotros, y de cómo os convertisteis de los ídolos a Dios para servir al Dios vivo y verdadero,"
            },
            {
                "ref": "1 Juan 5:20",
                "text": "Y sabemos que el Hijo de Dios ha venido y nos ha dado entendimiento a fin de que conozcamos al que es verdadero; y nosotros estamos en aquel que es verdadero, en su Hijo Jesucristo. Este es el verdadero Dios y la vida eterna."
            }
        ]
    },
    {
        number: 6,
        question: '¿Cuántas personas hay en la Deidad?',
        answer: 'Hay tres personas en la Deidad; el Padre, el Hijo y el Espíritu Santo; y estos tres son un solo Dios, el mismo en sustancia, igual en poder y gloria.',
        proofs: [
            {
                "ref": "Mateo 3:16–17",
                "text": "Después de ser bautizado, Jesús salió del agua inmediatamente; y he aquí, los cielos se abrieron, y él vio al Espíritu de Dios que descendía como una paloma y venía sobre Él. Y he aquí, se oyó una voz de los cielos que decía: Este es mi Hijo amado en quien me he complacido."
            },
            {
                "ref": "Mateo 28:19",
                "text": "Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo,"
            },
            {
                "ref": "2 Corintios 13:14",
                "text": "La gracia del Señor Jesucristo, el amor de Dios y la comunión del Espíritu Santo sean con todos vosotros."
            },
            {
                "ref": "1 Pedro 1:2",
                "text": "según el previo conocimiento de Dios Padre, por la obra santificadora del Espíritu, para obedecer a Jesucristo y ser rociados con su sangre: Que la gracia y la paz os sean multiplicadas."
            },
            {
                "ref": "Salmos 45:6",
                "text": "Tu trono, oh Dios, es eterno y para siempre; cetro de equidad es el cetro de tu reino."
            },
            {
                "ref": "Juan 1:1",
                "text": "En el principio existía el Verbo, y el Verbo estaba con Dios, y el Verbo era Dios."
            },
            {
                "ref": "Juan 17:5",
                "text": "Y ahora, glorifícame tú, Padre, junto a ti, con la gloria que tenía contigo antes que el mundo existiera."
            },
            {
                "ref": "Hechos 5:3–4",
                "text": "Mas Pedro dijo: Ananías, ¿por qué ha llenado Satanás tu corazón para mentir al Espíritu Santo, y quedarte con parte del precio del terreno? Mientras estaba sin venderse, ¿no te pertenecía? Y después de vendida, ¿no estaba bajo tu poder? ¿Por qué concebiste este asunto en tu corazón? No has mentido a los hombres sino a Dios."
            },
            {
                "ref": "Romanos 9:5",
                "text": "de quienes son los patriarcas, y de quienes, según la carne, procede el Cristo, el cual está sobre todas las cosas, Dios bendito por los siglos. Amén."
            },
            {
                "ref": "Colosenses 2:9",
                "text": "Porque toda la plenitud de la Deidad reside corporalmente en Él,"
            },
            {
                "ref": "Judas 24–25",
                "text": "Y a aquel que es poderoso para guardaros sin caída y para presentaros sin mancha en presencia de su gloria con gran alegría, al único Dios nuestro Salvador, por medio de Jesucristo nuestro Señor, sea gloria, majestad, dominio y autoridad, antes de todo tiempo, y ahora y por todos los siglos. Amén."
            }
        ]
    },
    {
        number: 7,
        question: '¿Qué son los decretos de Dios?',
        answer: 'Los decretos de Dios son su propósito eterno, de acuerdo con el consejo de su voluntad, por el cual, para su propia gloria, ha preordenado todo lo que sucede.',
        proofs: [
            {
                "ref": "Salmos 33:11",
                "text": "El consejo del Señor permanece para siempre, los designios de su corazón de generación en generación."
            },
            {
                "ref": "Isaias 14:24",
                "text": "Ha jurado el Señor de los ejércitos, diciendo: Ciertamente, tal como lo había pensado, así ha sucedido; tal como lo había planeado, así se cumplirá:"
            },
            {
                "ref": "Hechos 2:23",
                "text": "a este, entregado por el plan predeterminado y el previo conocimiento de Dios, clavasteis en una cruz por manos de impíos y le matasteis,"
            },
            {
                "ref": "Efesios 1:11–12",
                "text": "también hemos obtenido herencia, habiendo sido predestinados según el propósito de aquel que obra todas las cosas conforme al consejo de su voluntad, a fin de que nosotros, que fuimos los primeros en esperar en Cristo, seamos para alabanza de su gloria."
            }
        ]
    },
    {
        number: 8,
        question: '¿Cómo ejecuta Dios sus decretos?',
        answer: 'Dios ejecuta sus decretos en las obras de creación y de providencia.',
        proofs: [
            {
                "ref": "Salmos 148:8",
                "text": "fuego y granizo, nieve y bruma; viento tempestuoso que cumple su palabra;"
            },
            {
                "ref": "Isaias 40:26",
                "text": "Alzad a lo alto vuestros ojos y ved quién ha creado estos astros: el que hace salir en orden a su ejército, y a todos llama por su nombre. Por la grandeza de su fuerza y la fortaleza de su poder no falta ni uno."
            },
            {
                "ref": "Daniel 4:35",
                "text": "Y todos los habitantes de la tierra son considerados como nada, mas Él actúa conforme a su voluntad en el ejército del cielo y entre los habitantes de la tierra; nadie puede detener su mano, ni decirle: «¿Qué has hecho?»."
            },
            {
                "ref": "Hechos 4:24–28",
                "text": "Al oír ellos esto, unánimes alzaron la voz a Dios y dijeron: Oh, Señor, tú eres el que hiciste el cielo y la tierra, el mar y todo lo que en ellos hay, el que por el Espíritu Santo, por boca de nuestro padre David, tu siervo, dijiste: ¿Por que se enfurecieron los gentiles, y los pueblos tramaron cosas vanas? Se presentaron los reyes de la tierra, y los gobernantes se juntaron a una contra el Señor y contra su Cristo. Porque en verdad, en esta ciudad se unieron tanto Herodes como Poncio Pilato, juntamente con los gentiles y los pueblos de Israel, contra tu santo siervo Jesús, a quien tú ungiste, para hacer cuanto tu mano y tu propósito habían predestinado que sucediera."
            },
            {
                "ref": "Apocalipsis 4:11",
                "text": "Digno eres, Señor y Dios nuestro, de recibir la gloria y el honor y el poder, porque tú creaste todas las cosas, y por tu voluntad existen y fueron creadas."
            }
        ]
    },
    {
        number: 9,
        question: '¿Qué es la obra de creación?',
        answer: 'La obra de creación consiste en el haber hecho Dios todas las cosas de la nada, por su poderosa palabra, en el espacio de seis días y todas muy buenas.',
        proofs: [
            {
                "ref": "Genesis 1:1",
                "text": "En el principio creó Dios los cielos y la tierra."
            },
            {
                "ref": "Salmos 33:6",
                "text": "Por la palabra del Señor fueron hechos los cielos, y todo su ejército por el aliento de su boca."
            },
            {
                "ref": "Salmos 33:9",
                "text": "Porque Él habló, y fue hecho; Él mandó, y todo se confirmó."
            },
            {
                "ref": "Hebreos 11:3",
                "text": "Por la fe entendemos que el universo fue preparado por la palabra de Dios, de modo que lo que se ve no fue hecho de cosas visibles."
            },
            {
                "ref": "Genesis 1:31",
                "text": "Y vio Dios todo lo que había hecho, y he aquí que era bueno en gran manera. Y fue la tarde y fue la mañana: el sexto día."
            }
        ]
    },
    {
        number: 10,
        question: '¿Cómo creó Dios al hombre?',
        answer: 'Dios creó al hombre, varón y hembra, según su propia imagen, en ciencia, justicia y santidad, con dominio sobre todas las criaturas.',
        proofs: [
            {
                "ref": "Genesis 1:27",
                "text": "Creó, pues, Dios al hombre a imagen suya, a imagen de Dios lo creó; varón y hembra los creó."
            },
            {
                "ref": "Colosenses 3:10",
                "text": "y os habéis vestido del nuevo hombre, el cual se va renovando hacia un verdadero conocimiento, conforme a la imagen de aquel que lo creó;"
            },
            {
                "ref": "Efesios 4:24",
                "text": "y os vistáis del nuevo hombre, el cual, en la semejanza de Dios, ha sido creado en la justicia y santidad de la verdad."
            },
            {
                "ref": "Genesis 1:28",
                "text": "Y los bendijo Dios y les dijo: Sed fecundos y multiplicaos, y llenad la tierra y sojuzgadla; ejerced dominio sobre los peces del mar, sobre las aves del cielo y sobre todo ser viviente que se mueve sobre la tierra."
            },
            {
                "ref": "Salmos 8",
                "text": "¡Oh Señor, Señor nuestro, cuán glorioso es tu nombre en toda la tierra, que has desplegado tu gloria sobre los cielos! Por boca de los infantes y de los niños de pecho has establecido tu fortaleza, por causa de tus adversarios, para hacer cesar al enemigo y al vengativo. Cuando veo tus cielos, obra de tus dedos, la luna y las estrellas que tú has establecido, digo: ¿Qué es el hombre para que de él te acuerdes, y el hijo del hombre para que lo cuides? ¡Sin embargo, lo has hecho un poco menor que los ángeles, y lo coronas de gloria y majestad! Tú le haces señorear sobre las obras de tus manos; todo lo has puesto bajo sus pies: ovejas y bueyes, todos ellos, y también las bestias del campo, las aves de los cielos y los peces del mar, cuanto atraviesa las sendas de los mares. ¡Oh Señor, Señor nuestro, cuán glorioso es tu nombre en toda la tierra!"
            }
        ]
    },
    {
        number: 11,
        question: '¿Cuáles son las obras de providencia de Dios?',
        answer: 'Las obras de providencia de Dios son aquellas con que santa, sabia y poderosamente, preserva y gobierna a todas sus criaturas y todas las acciones de éstas.',
        proofs: [
            {
                "ref": "Salmos 145:17",
                "text": "Justo es el Señor en todos sus caminos, y bondadoso en todos sus hechos."
            },
            {
                "ref": "Salmos 104:24",
                "text": "¡Cuán numerosas son tus obras, oh Señor! Con sabiduría las has hecho todas; llena está la tierra de tus posesiones."
            },
            {
                "ref": "Hebreos 1:3",
                "text": "Él es el resplandor de su gloria y la expresión exacta de su naturaleza, y sostiene todas las cosas por la palabra de su poder. Después de llevar a cabo la purificación de los pecados, se sentó a la diestra de la Majestad en las alturas,"
            },
            {
                "ref": "Nehemías 9:6",
                "text": "Solo tú eres el Señor. Tú hiciste los cielos, los cielos de los cielos con todo su ejército, la tierra y todo lo que en ella hay, los mares y todo lo que en ellos hay. Tú das vida a todos ellos y el ejército de los cielos se postra ante ti."
            },
            {
                "ref": "Efesios 1:19–22",
                "text": "y cuál es la extraordinaria grandeza de su poder para con nosotros los que creemos, conforme a la eficacia de la fuerza de su poder, el cual obró en Cristo cuando le resucitó de entre los muertos y le sentó a su diestra en los lugares celestiales, muy por encima de todo principado, autoridad, poder, dominio y de todo nombre que se nombra, no solo en este siglo sino también en el venidero. Y todo sometió bajo sus pies, y a Él lo dio por cabeza sobre todas las cosas a la iglesia,"
            },
            {
                "ref": "Salmos 36:6",
                "text": "Tu justicia es como los montes de Dios; tus juicios son como profundo abismo. Tú preservas, oh Señor, al hombre y al animal."
            },
            {
                "ref": "Proverbios 16:33",
                "text": "La suerte se echa en el regazo, mas del Señor viene toda decisión."
            },
            {
                "ref": "Mateo 10:30",
                "text": "Y hasta los cabellos de vuestra cabeza están todos contados."
            }
        ]
    },
    {
        number: 12,
        question: '¿Qué acto particular de providencia ejecutó Dios respecto del hombre en el estado en el que éste fue creado?',
        answer: 'Cuando Dios hubo creado al hombre, hizo con él un pacto de vida bajo condición de perfecta obediencia, prohibiéndole comer del árbol del conocimiento del bien y del mal sobre pena de muerte.',
        proofs: [
            {
                "ref": "Genesis 2:16–17",
                "text": "Y ordenó el Señor Dios al hombre, diciendo: De todo árbol del huerto podrás comer, pero del árbol del conocimiento del bien y del mal no comerás, porque el día que de él comas, ciertamente morirás."
            },
            {
                "ref": "Santiago 2:10",
                "text": "Porque cualquiera que guarda toda la ley, pero tropieza en un punto, se ha hecho culpable de todos."
            }
        ]
    },
    {
        number: 13,
        question: '¿Permanecieron nuestros primeros padres en el estado en que fueron creados?',
        answer: 'Nuestros primeros padres, dejados a su propio libre albedrío, cayeron del estado en que fueron creados, pecando contra Dios.',
        proofs: [
            {
                "ref": "Genesis 3:6–8",
                "text": "Cuando la mujer vio que el árbol era bueno para comer, y que era agradable a los ojos, y que el árbol era deseable para alcanzar sabiduría, tomó de su fruto y comió; y dio también a su marido que estaba con ella, y él comió. Entonces fueron abiertos los ojos de ambos, y conocieron que estaban desnudos; y cosieron hojas de higuera y se hicieron delantales. Y oyeron al Señor Dios que se paseaba en el huerto al fresco del día; y el hombre y su mujer se escondieron de la presencia del Señor Dios entre los árboles del huerto."
            },
            {
                "ref": "Genesis 3:13",
                "text": "Entonces el Señor Dios dijo a la mujer: ¿Qué es esto que has hecho? Y la mujer respondió: La serpiente me engañó, y yo comí."
            },
            {
                "ref": "2 Corintios 11:3",
                "text": "Pero temo que, así como la serpiente con su astucia engañó a Eva, vuestras mentes sean desviadas de la sencillez y pureza de la devoción a Cristo."
            }
        ]
    },
    {
        number: 14,
        question: '¿Qué es el pecado?',
        answer: 'El pecado es cualquier falta de conformidad con la ley de Dios, o transgresión de ella.',
        proofs: [
            {
                "ref": "Levítico 5:17",
                "text": "Si alguno peca y hace cualquiera de las cosas que el Señor ha mandado que no se hagan, aunque no se dé cuenta, será culpable y llevará su castigo."
            },
            {
                "ref": "Santiago 4:17",
                "text": "A aquel, pues, que sabe hacer lo bueno y no lo hace, le es pecado."
            },
            {
                "ref": "1 Juan 3:4",
                "text": "Todo el que practica el pecado, practica también la infracción de la ley, pues el pecado es infracción de la ley."
            }
        ]
    },
    {
        number: 15,
        question: 'Cuál fue el pecado por el cual nuestros primeros padres cayeron del estado en que fueron creados?',
        answer: 'El pecado por el cual nuestros primeros padres cayeron del estado en que fueron creados fue el comer del fruto prohibido.',
        proofs: [
            {
                "ref": "Génesis 3:6",
                "text": "Cuando la mujer vio que el árbol era bueno para comer, y que era agradable a los ojos, y que el árbol era deseable para alcanzar sabiduría, tomó de su fruto y comió; y dio también a su marido que estaba con ella, y él comió."
            }
        ]
    },
    {
        number: 16,
        question: '¿Cayó todo el género humano en la primera transgresión de Adán?',
        answer: 'Habiéndose hecho el pacto con Adán, no sólo para él, sino también para su posteridad, todo el género humano descendiendo de él por generación ordinaria, pecó en él y cayó con él en su primera transgresión.',
        proofs: [
            {
                "ref": "Genesis 2:16–17",
                "text": "Y ordenó el Señor Dios al hombre, diciendo: De todo árbol del huerto podrás comer, pero del árbol del conocimiento del bien y del mal no comerás, porque el día que de él comas, ciertamente morirás."
            },
            {
                "ref": "Santiago 2:10",
                "text": "Porque cualquiera que guarda toda la ley, pero tropieza en un punto, se ha hecho culpable de todos."
            },
            {
                "ref": "Romanos 5:12–21",
                "text": "Por tanto, tal como el pecado entró en el mundo por un hombre, y la muerte por el pecado, así también la muerte se extendió a todos los hombres, porque todos pecaron; pues antes de la ley había pecado en el mundo, pero el pecado no se imputa cuando no hay ley. Sin embargo, la muerte reinó desde Adán hasta Moisés, aun sobre los que no habían pecado con una transgresión semejante a la de Adán, el cual es figura del que había de venir. Pero no sucede con la dádiva como con la transgresión. Porque si por la transgresión de uno murieron los muchos, mucho más, la gracia de Dios y el don por la gracia de un hombre, Jesucristo, abundaron para los muchos. Tampoco sucede con el don como con lo que vino por medio de aquel que pecó; porque ciertamente el juicio surgió a causa de una transgresión, resultando en condenación; pero la dádiva surgió a causa de muchas transgresiones resultando en justificación. Porque si por la transgresión de uno, por este reinó la muerte, mucho más reinarán en vida por medio de uno, Jesucristo, los que reciben la abundancia de la gracia y del don de la justicia. Así pues, tal como por una transgresión resultó la condenación de todos los hombres, así también por un acto de justicia resultó la justificación de vida para todos los hombres. Porque así como por la desobediencia de un hombre los muchos fueron constituidos pecadores, así también por la obediencia de uno los muchos serán constituidos justos. Y la ley se introdujo para que abundara la transgresión, pero donde el pecado abundó, sobreabundó la gracia, para que así como el pecado reinó en la muerte, así también la gracia reine por medio de la justicia para vida eterna, mediante Jesucristo nuestro Señor."
            },
            {
                "ref": "1 Corintios 15:22",
                "text": "Porque así como en Adán todos mueren, también en Cristo todos serán vivificados."
            }
        ]
    },
    {
        number: 17,
        question: '¿A qué estado redujo la caída al hombre?',
        answer: 'La caída redujo al hombre a un estado de pecado y de miseria.',
        proofs: [
            {
                "ref": "Genesis 3:16-19",
                "text": "A la mujer dijo: En gran manera multiplicaré tu dolor en el parto, con dolor darás a luz los hijos; y con todo, tu deseo será para tu marido, y él tendrá dominio sobre ti. Entonces dijo a Adán: Por cuanto has escuchado la voz de tu mujer y has comido del árbol del cual te ordené, diciendo: «No comerás de él», maldita será la tierra por tu causa; con trabajo comerás de ella todos los días de tu vida. Espinos y abrojos te producirá, y comerás de las plantas del campo. Con el sudor de tu rostro comerás el pan hasta que vuelvas a la tierra, porque de ella fuiste tomado; pues polvo eres, y al polvo volverás."
            },
            {
                "ref": "Genesis 3:23",
                "text": "Y el Señor Dios lo echó del huerto del Edén, para que labrara la tierra de la cual fue tomado."
            },
            {
                "ref": "Romanos 3:16",
                "text": "destrucción y miseria hay en sus caminos,"
            },
            {
                "ref": "Romanos 5:12",
                "text": "Por tanto, tal como el pecado entró en el mundo por un hombre, y la muerte por el pecado, así también la muerte se extendió a todos los hombres, porque todos pecaron;"
            },
            {
                "ref": "Efesios 2:1",
                "text": "Y Él os dio vida a vosotros, que estabais muertos en vuestros delitos y pecados,"
            }
        ]
    },
    {
        number: 18,
        question: '¿En qué consiste lo pecaminoso del estado en que cayó el hombre?',
        answer: 'Lo pecaminoso del estado en que cayó el hombre consiste en la culpabilidad del primer pecado de Adán, la falta de justicia original y la depravación de toda su naturaleza, llamada comúnmente pecado original, con todas las transgresiones actuales que de ella dimanan.',
        proofs: [
            {
                "ref": "Romanos 5:12",
                "text": "Por tanto, tal como el pecado entró en el mundo por un hombre, y la muerte por el pecado, así también la muerte se extendió a todos los hombres, porque todos pecaron;"
            },
            {
                "ref": "Romanos 5:19",
                "text": "Porque así como por la desobediencia de un hombre los muchos fueron constituidos pecadores, así también por la obediencia de uno los muchos serán constituidos justos."
            },
            {
                "ref": "Romanos 3:10",
                "text": "como está escrito: No hay justo, ni aun uno;"
            },
            {
                "ref": "Colosenses 3:10",
                "text": "y os habéis vestido del nuevo hombre, el cual se va renovando hacia un verdadero conocimiento, conforme a la imagen de aquel que lo creó;"
            },
            {
                "ref": "Efesios 4:24",
                "text": "y os vistáis del nuevo hombre, el cual, en la semejanza de Dios, ha sido creado en la justicia y santidad de la verdad."
            },
            {
                "ref": "Salmos 51:5",
                "text": "He aquí, yo nací en iniquidad, y en pecado me concibió mi madre."
            },
            {
                "ref": "Juan 3:6",
                "text": "Lo que es nacido de la carne, carne es, y lo que es nacido del Espíritu, espíritu es."
            },
            {
                "ref": "Romanos 3:18",
                "text": "No hay temor de Dios delante de sus ojos."
            },
            {
                "ref": "Romanos 8:7–8",
                "text": "ya que la mente puesta en la carne es enemiga de Dios, porque no se sujeta a la ley de Dios, pues ni siquiera puede hacerlo, y los que están en la carne no pueden agradar a Dios."
            },
            {
                "ref": "Efesios 2:3",
                "text": "entre los cuales también todos nosotros en otro tiempo vivíamos en las pasiones de nuestra carne, satisfaciendo los deseos de la carne y de la mente, y éramos por naturaleza hijos de ira, lo mismo que los demás."
            },
            {
                "ref": "Genesis 6:5",
                "text": "Y el Señor vio que era mucha la maldad de los hombres en la tierra, y que toda intención de los pensamientos de su corazón era solo hacer siempre el mal."
            },
            {
                "ref": "Salmos 53:1–3",
                "text": "El necio ha dicho en su corazón: No hay Dios. Se han corrompido, han cometido injusticias abominables; no hay quien haga el bien. Dios ha mirado desde los cielos sobre los hijos de los hombres para ver si hay alguno que entienda, alguno que busque a Dios. Todos se han desviado, a una se han corrompido; no hay quien haga el bien, no hay ni siquiera uno."
            },
            {
                "ref": "Mateo 15:19",
                "text": "Porque del corazón provienen malos pensamientos, homicidios, adulterios, fornicaciones, robos, falsos testimonios y calumnias."
            },
            {
                "ref": "Romanos 3:10–18",
                "text": "como está escrito: No hay justo, ni aun uno; no hay quien entienda, no hay quien busque a Dios; todos se han desviado, a una se hicieron inútiles; no hay quien haga lo bueno, no hay ni siquiera uno. Sepulcro abierto es su garganta, engañan de continuo con su lengua, veneno de serpientes hay bajo sus labios; llena está su boca de maldición y amargura; sus pies son veloces para derramar sangre; destrucción y miseria hay en sus caminos, y la senda de paz no han conocido. No hay temor de Dios delante de sus ojos."
            },
            {
                "ref": "Romanos 3:23",
                "text": "por cuanto todos pecaron y no alcanzan la gloria de Dios,"
            },
            {
                "ref": "Gálatas. 5:19–21",
                "text": "Ahora bien, las obras de la carne son evidentes, las cuales son: inmoralidad, impureza, sensualidad, idolatría, hechicería, enemistades, pleitos, celos, enojos, rivalidades, disensiones, sectarismos, envidias, borracheras, orgías y cosas semejantes, contra las cuales os advierto, como ya os lo he dicho antes, que los que practican tales cosas no heredarán el reino de Dios."
            },
            {
                "ref": "Santiago 1:14–15",
                "text": "Sino que cada uno es tentado cuando es llevado y seducido por su propia pasión. Después, cuando la pasión ha concebido, da a luz el pecado; y cuando el pecado es consumado, engendra la muerte."
            }
        ]
    },
    {
        number: 19,
        question: '¿En qué consiste la miseria del estado en que cayó el hombre?',
        answer: 'Todo el género humano perdió por su caída, la comunión con Dios, está bajo su ira, y maldición, y expuesto a todas las miserias de esta vida actual, a la muerte misma, y a las penas del infierno para siempre.',
        proofs: [
            {
                "ref": "Juan 8:34",
                "text": "Jesús les respondió: En verdad, en verdad os digo que todo el que comete pecado es esclavo del pecado;"
            },
            {
                "ref": "Juan 8:42",
                "text": "Jesús les dijo: Si Dios fuera vuestro Padre, me amaríais, porque yo salí de Dios y vine de Él, pues no he venido por mi propia iniciativa, sino que Él me envió."
            },
            {
                "ref": "Juan 8:44",
                "text": "Sois de vuestro padre el diablo y queréis hacer los deseos de vuestro padre. Él fue un homicida desde el principio, y no se ha mantenido en la verdad porque no hay verdad en él. Cuando habla mentira, habla de su propia naturaleza, porque es mentiroso y el padre de la mentira."
            },
            {
                "ref": "Efesios 2:12",
                "text": "recordad que en ese tiempo estabais separados de Cristo, excluidos de la ciudadanía de Israel, extraños a los pactos de la promesa, sin tener esperanza, y sin Dios en el mundo."
            },
            {
                "ref": "Efesios 4:18",
                "text": "entenebrecidos en su entendimiento, excluidos de la vida de Dios por causa de la ignorancia que hay en ellos, por la dureza de su corazón;"
            },
            {
                "ref": "Juan 3:36",
                "text": "El que cree en el Hijo tiene vida eterna; pero el que no obedece al Hijo no verá la vida, sino que la ira de Dios permanece sobre él."
            },
            {
                "ref": "Romanos 1:18",
                "text": "Porque la ira de Dios se revela desde el cielo contra toda impiedad e injusticia de los hombres, que con injusticia restringen la verdad;"
            },
            {
                "ref": "Efesios 2:3",
                "text": "entre los cuales también todos nosotros en otro tiempo vivíamos en las pasiones de nuestra carne, satisfaciendo los deseos de la carne y de la mente, y éramos por naturaleza hijos de ira, lo mismo que los demás."
            },
            {
                "ref": "Efesios 5:6",
                "text": "Que nadie os engañe con palabras vanas, pues por causa de estas cosas la ira de Dios viene sobre los hijos de desobediencia."
            },
            {
                "ref": "Galatas. 3:10",
                "text": "Porque todos los que son de las obras de la ley están bajo maldición, pues escrito está: Maldito todo el que no permanece en todas las cosas escritas en el libro de la ley, para hacerlas."
            },
            {
                "ref": "Genesis 3:16–19",
                "text": "A la mujer dijo: En gran manera multiplicaré tu dolor en el parto, con dolor darás a luz los hijos; y con todo, tu deseo será para tu marido, y él tendrá dominio sobre ti. Entonces dijo a Adán: Por cuanto has escuchado la voz de tu mujer y has comido del árbol del cual te ordené, diciendo: «No comerás de él», maldita será la tierra por tu causa; con trabajo comerás de ella todos los días de tu vida. Espinos y abrojos te producirá, y comerás de las plantas del campo. Con el sudor de tu rostro comerás el pan hasta que vuelvas a la tierra, porque de ella fuiste tomado; pues polvo eres, y al polvo volverás."
            },
            {
                "ref": "Job 5:7",
                "text": "porque el hombre nace para la aflicción, como las chispas vuelan hacia arriba."
            },
            {
                "ref": "Eclesiastes 2:22–23",
                "text": "Pues, ¿qué recibe el hombre de todo su trabajo y del esfuerzo de su corazón con que se afana bajo el sol? Porque durante todos sus días su tarea es dolorosa y penosa; ni aun de noche descansa su corazón. También esto es vanidad."
            },
            {
                "ref": "Romanos 8:18–23",
                "text": "Pues considero que los sufrimientos de este tiempo presente no son dignos de ser comparados con la gloria que nos ha de ser revelada. Porque el anhelo profundo de la creación es aguardar ansiosamente la revelación de los hijos de Dios. Porque la creación fue sometida a vanidad, no de su propia voluntad, sino por causa de aquel que la sometió, en la esperanza de que la creación misma será también liberada de la esclavitud de la corrupción a la libertad de la gloria de los hijos de Dios. Pues sabemos que la creación entera a una gime y sufre dolores de parto hasta ahora. Y no solo ella, sino que también nosotros mismos, que tenemos las primicias del Espíritu, aun nosotros mismos gemimos en nuestro interior, aguardando ansiosamente la adopción como hijos, la redención de nuestro cuerpo."
            },
            {
                "ref": "Ezequiel 18:4",
                "text": "He aquí, todas las almas son mías; tanto el alma del padre como el alma del hijo mías son. El alma que peque, esa morirá."
            },
            {
                "ref": "Romanos 5:12",
                "text": "Por tanto, tal como el pecado entró en el mundo por un hombre, y la muerte por el pecado, así también la muerte se extendió a todos los hombres, porque todos pecaron;"
            },
            {
                "ref": "Romanos 6:23",
                "text": "Porque la paga del pecado es muerte, pero la dádiva de Dios es vida eterna en Cristo Jesús Señor nuestro."
            },
            {
                "ref": "Mateo 25:41",
                "text": "Entonces dirá también a los de su izquierda: «Apartaos de mí, malditos, al fuego eterno que ha sido preparado para el diablo y sus ángeles."
            },
            {
                "ref": "Mateo 25:46",
                "text": "Y estos irán al castigo eterno, pero los justos a la vida eterna."
            },
            {
                "ref": "2 Tesalonicenses 1:9",
                "text": "Estos sufrirán el castigo de eterna destrucción, excluidos de la presencia del Señor y de la gloria de su poder,"
            },
            {
                "ref": "Apocalipsis 14:9–11",
                "text": "Entonces los siguió otro ángel, el tercero, diciendo a gran voz: Si alguno adora a la bestia y a su imagen, y recibe una marca en su frente o en su mano, él también beberá del vino del furor de Dios, que está preparado puro en el cáliz de su ira; y será atormentado con fuego y azufre delante de los santos ángeles y en presencia del Cordero. Y el humo de su tormento asciende por los siglos de los siglos; y no tienen reposo, ni de día ni de noche, los que adoran a la bestia y a su imagen, y cualquiera que reciba la marca de su nombre."
            }
        ]
    },
    {
        number: 20,
        question: '¿Dejó Dios a todo el género humano perecer en su estado de pecado y de miseria?',
        answer: 'Habiendo Dios, de su propia soberana voluntad, elegido desde el principio a los que han de gozar de la vida eterna, entró en un pacto de gracia para libertarles de su estado de pecado y de miseria, e introducirles en un estado de salvación, por medio de un Redentor.',
        proofs: [
            {
                "ref": "Hechos 13:48",
                "text": "Oyendo esto los gentiles, se regocijaban y glorificaban la palabra del Señor; y creyeron cuantos estaban ordenados a vida eterna."
            },
            {
                "ref": "Efesios 1:4–5",
                "text": "según nos escogió en Él antes de la fundación del mundo, para que fuéramos santos y sin mancha delante de Él. En amor nos predestinó para adopción como hijos para sí mediante Jesucristo, conforme al beneplácito de su voluntad,"
            },
            {
                "ref": "2 Tesalonicenses 2:13–14",
                "text": "Pero nosotros siempre tenemos que dar gracias a Dios por vosotros, hermanos amados por el Señor, porque Dios os ha escogido desde el principio para salvación mediante la santificación por el Espíritu y la fe en la verdad. Y fue para esto que Él os llamó mediante nuestro evangelio, para que alcancéis la gloria de nuestro Señor Jesucristo."
            },
            {
                "ref": "Genesis 3:15",
                "text": "Y pondré enemistad entre tú y la mujer, y entre tu simiente y su simiente; él te herirá en la cabeza, y tú lo herirás en el calcañar."
            },
            {
                "ref": "Genesis 17:7",
                "text": "Y estableceré mi pacto contigo y con tu descendencia después de ti, por todas sus generaciones, por pacto eterno, de ser Dios tuyo y de toda tu descendencia después de ti."
            },
            {
                "ref": "Exodo 19:5–6",
                "text": "Ahora pues, si en verdad escucháis mi voz y guardáis mi pacto, seréis mi especial tesoro entre todos los pueblos, porque mía es toda la tierra; y vosotros seréis para mí un reino de sacerdotes y una nación santa». Estas son las palabras que dirás a los hijos de Israel."
            },
            {
                "ref": "Jeremias 31:31–34",
                "text": "He aquí, vienen días —declara el Señor— en que haré con la casa de Israel y con la casa de Judá un nuevo pacto, no como el pacto que hice con sus padres el día que los tomé de la mano para sacarlos de la tierra de Egipto, mi pacto que ellos rompieron, aunque fui un esposo para ellos —declara el Señor; porque este es el pacto que haré con la casa de Israel después de aquellos días —declara el Señor—. Pondré mi ley dentro de ellos, y sobre sus corazones la escribiré; y yo seré su Dios y ellos serán mi pueblo. Y no tendrán que enseñar más cada uno a su prójimo y cada cual a su hermano, diciendo: «Conoce al Señor», porque todos me conocerán, desde el más pequeño de ellos hasta el más grande —declara el Señor— pues perdonaré su maldad, y no recordaré más su pecado."
            },
            {
                "ref": "Mateo 20:28",
                "text": "así como el Hijo del Hombre no vino para ser servido, sino para servir y para dar su vida en rescate por muchos."
            },
            {
                "ref": "1 Corintios 11:25",
                "text": "De la misma manera tomó también la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre; haced esto cuantas veces la bebáis en memoria de mí."
            },
            {
                "ref": "Hebreos 9:15",
                "text": "Y por eso Él es el mediador de un nuevo pacto, a fin de que habiendo tenido lugar una muerte para la redención de las transgresiones que se cometieron bajo el primer pacto, los que han sido llamados reciban la promesa de la herencia eterna."
            }
        ]
    },
    {
        number: 21,
        question: '¿Quién es el Redentor de los elegidos de Dios?',
        answer: 'El único Redentor de los elegidos de Dios es el Señor Jesucristo, quien siendo el Hijo eterno de Dios, se hizo hombre, y así era y permanece para siempre, Dios y hombre en dos naturalezas distintas y una sola persona.',
        proofs: [
            {
                "ref": "Juan 14:6",
                "text": "Jesús le dijo*: Yo soy el camino, y la verdad, y la vida; nadie viene al Padre sino por mí."
            },
            {
                "ref": "Hechos 4:12",
                "text": "Y en ningún otro hay salvación, porque no hay otro nombre bajo el cielo dado a los hombres, en el cual podamos ser salvos."
            },
            {
                "ref": "1 Timeteo 2:5–6",
                "text": "Porque hay un solo Dios, y también un solo mediador entre Dios y los hombres, Cristo Jesús hombre, quien se dio a sí mismo en rescate por todos, testimonio dado a su debido tiempo"
            },
            {
                "ref": "Salmos 2:7",
                "text": "Ciertamente anunciaré el decreto del Señor que me dijo: «Mi Hijo eres tú, yo te he engendrado hoy."
            },
            {
                "ref": "Mateo 3:17",
                "text": "Y he aquí, se oyó una voz de los cielos que decía: Este es mi Hijo amado en quien me he complacido."
            },
            {
                "ref": "Mateo 17:5",
                "text": "Mientras estaba aún hablando, he aquí, una nube luminosa los cubrió; y una voz salió de la nube, diciendo: Este es mi Hijo amado en quien me he complacido; a Él oíd."
            },
            {
                "ref": "Juan 1:18",
                "text": "Nadie ha visto jamás a Dios; el unigénito Dios, que está en el seno del Padre, Él le ha dado a conocer."
            },
            {
                "ref": "Isaias 9:6",
                "text": "Porque un niño nos ha nacido, un hijo nos ha sido dado, y la soberanía reposará sobre sus hombros; y se llamará su nombre Admirable Consejero, Dios Poderoso, Padre Eterno, Príncipe de Paz."
            },
            {
                "ref": "Mateo 1:23",
                "text": "He aquí, la virgen concebirá y dara a luz un hijo, y le pondrán por nombre Emmanuel, que traducido significa: Dios con nosotros."
            },
            {
                "ref": "Juan 1:14",
                "text": "Y el Verbo se hizo carne, y habitó entre nosotros, y vimos su gloria, gloria como del unigénito del Padre, lleno de gracia y de verdad."
            },
            {
                "ref": "Galatas 4:4",
                "text": "Pero cuando vino la plenitud del tiempo, Dios envió a su Hijo, nacido de mujer, nacido bajo la ley,"
            },
            {
                "ref": "Hechos 1:11",
                "text": "que les dijeron: Varones galileos, ¿por qué estáis mirando al cielo? Este mismo Jesús, que ha sido tomado de vosotros al cielo, vendrá de la misma manera, tal como le habéis visto ir al cielo."
            },
            {
                "ref": "Hebreos 7:24–25",
                "text": "pero Él conserva su sacerdocio inmutable puesto que permanece para siempre. Por lo cual Él también es poderoso para salvar para siempre a los que por medio de Él se acercan a Dios, puesto que vive perpetuamente para interceder por ellos."
            }
        ]
    },
    {
        number: 22,
        question: '¿Cómo se hizo Cristo hombre siendo como era Hijo de Dios?',
        answer: 'Cristo el Hijo de Dios, se hizo hombre, tomándose un cuerpo verdadero y una alma racional, siendo concebido por obra del Espíritu Santo en el vientre de la virgen María, de la cual nació, mas sin pecado.',
        proofs: [
            {
                "ref": "Filipenses 2:7",
                "text": "sino que se despojó a sí mismo tomando forma de siervo, haciéndose semejante a los hombres."
            },
            {
                "ref": "Hebreos 2:14",
                "text": "Así que, por cuanto los hijos participan de carne y sangre, Él igualmente participó también de lo mismo, para anular mediante la muerte el poder de aquel que tenía el poder de la muerte, es decir, el diablo,"
            },
            {
                "ref": "Lucas 1:27",
                "text": "a una virgen desposada con un hombre que se llamaba José, de los descendientes de David; y el nombre de la virgen era María."
            },
            {
                "ref": "Lucas 1:31",
                "text": "Y he aquí, concebirás en tu seno y darás a luz un hijo, y le pondrás por nombre Jesús."
            },
            {
                "ref": "Lucas 1:35",
                "text": "Respondiendo el ángel, le dijo: El Espíritu Santo vendrá sobre ti, y el poder del Altísimo te cubrirá con su sombra; por eso el santo Niño que nacerá será llamado Hijo de Dios."
            },
            {
                "ref": "2 Corintios 5:21",
                "text": "Al que no conoció pecado, le hizo pecado por nosotros, para que fuéramos hechos justicia de Dios en Él."
            },
            {
                "ref": "Hebreos 4:15",
                "text": "Porque no tenemos un sumo sacerdote que no pueda compadecerse de nuestras flaquezas, sino uno que ha sido tentado en todo como nosotros, pero sin pecado."
            },
            {
                "ref": "Hebreos 7:26",
                "text": "Porque convenía que tuviéramos tal Sumo Sacerdote: santo, inocente, inmaculado, apartado de los pecadores y exaltado más allá de los cielos,"
            },
            {
                "ref": "1 Juan 3:5",
                "text": "Y vosotros sabéis que Él se manifestó a fin de quitar los pecados, y en Él no hay pecado."
            }
        ]
    },
    {
        number: 23,
        question: '¿Qué oficios ejecuta Cristo como Redentor nuestro?',
        answer: 'Cristo, como Redentor nuestro, ejecuta los oficios de Profeta, de Sacerdote y de Rey, tanto en su estado de humillación como en el de exaltación.',
        proofs: [
            {
                "ref": "Deuteronomio 18:18",
                "text": "Un profeta como tú levantaré de entre sus hermanos, y pondré mis palabras en su boca, y él les hablará todo lo que yo le mande."
            },
            {
                "ref": "Hechos 3:22–23",
                "text": "Moisés dijo: El Señor Dios os levantará un profeta como yo de entre vuestros hermanos; a Él prestareis atención en todo cuanto os diga. Y sucederá que todo el que no preste atención a aquel profeta, será totalmente destruido de entre el pueblo."
            },
            {
                "ref": "Hebreos 1:1–2",
                "text": "Dios, habiendo hablado hace mucho tiempo, en muchas ocasiones y de muchas maneras a los padres por los profetas, en estos últimos días nos ha hablado por su Hijo, a quien constituyó heredero de todas las cosas, por medio de quien hizo también el universo."
            },
            {
                "ref": "Hebreos 4:14–15",
                "text": "Teniendo, pues, un gran Sumo Sacerdote que trascendió los cielos, Jesús, el Hijo de Dios, retengamos nuestra fe. Porque no tenemos un sumo sacerdote que no pueda compadecerse de nuestras flaquezas, sino uno que ha sido tentado en todo como nosotros, pero sin pecado."
            },
            {
                "ref": "Hebreos 5:5–6",
                "text": "De la misma manera, Cristo no se glorificó a sí mismo para hacerse Sumo Sacerdote, sino que lo glorificó el que le dijo: Hijo mío eres tú, Yo te he engendrado hoy; como también dice en otro pasaje: Tú eres sacerdote para siempre según el orden de Melquisedec."
            },
            {
                "ref": "Isaias 9:6–7",
                "text": "Porque un niño nos ha nacido, un hijo nos ha sido dado, y la soberanía reposará sobre sus hombros; y se llamará su nombre Admirable Consejero, Dios Poderoso, Padre Eterno, Príncipe de Paz. El aumento de su soberanía y de la paz no tendrán fin sobre el trono de David y sobre su reino, para afianzarlo y sostenerlo con el derecho y la justicia desde entonces y para siempre. El celo del Señor de los ejércitos hará esto."
            },
            {
                "ref": "Lucas 1:32–33",
                "text": "Este será grande y será llamado Hijo del Altísimo; y el Señor Dios le dará el trono de su padre David; y reinará sobre la casa de Jacob para siempre, y su reino no tendrá fin."
            },
            {
                "ref": "Juan 18:37",
                "text": "Pilato entonces le dijo: ¿Así que tú eres rey? Jesús respondió: Tú dices que soy rey. Para esto yo he nacido y para esto he venido al mundo, para dar testimonio de la verdad. Todo el que es de la verdad escucha mi voz."
            },
            {
                "ref": "1 Corintios 15:25",
                "text": "Pues Cristo debe reinar hasta que haya puesto a todos sus enemigos debajo de sus pies."
            }
        ]
    },
    {
        number: 24,
        question: '¿Cómo ejecuta Cristo el oficio de Profeta?',
        answer: 'Cristo ejecuta el oficio de Profeta, revelándonos por su Palabra y Espíritu, la voluntad de Dios para nuestra salvación.',
        proofs: [
            {
                "ref": "Lucas 4:18–19",
                "text": "El Espíritu del Señor está sobre mí, porque me ha ungido para anunciar el evangelio a los pobres. Me ha enviado para proclamar libertad a los cautivos, y la recuperación de la vista a los ciegos; para poner en libertad a los oprimidos; para proclamar el año favorable del Señor."
            },
            {
                "ref": "Hechos 1:1–2",
                "text": "El primer relato que escribí, Teófilo, trató de todo lo que Jesús comenzó a hacer y a enseñar, hasta el día en que fue recibido arriba, después de que por el Espíritu Santo había dado instrucciones a los apóstoles que había escogido."
            },
            {
                "ref": "Hebreos 2:3",
                "text": "¿cómo escaparemos nosotros si descuidamos una salvación tan grande? La cual, después que fue anunciada primeramente por medio del Señor, nos fue confirmada por los que oyeron,"
            },
            {
                "ref": "Juan 15:26–27",
                "text": "Cuando venga el Consolador, a quien yo enviaré del Padre, es decir, el Espíritu de verdad que procede del Padre, Él dará testimonio de mí, y vosotros daréis testimonio también, porque habéis estado conmigo desde el principio."
            },
            {
                "ref": "Hechos 1:8",
                "text": "pero recibiréis poder cuando el Espíritu Santo venga sobre vosotros; y me seréis testigos en Jerusalén, en toda Judea y Samaria, y hasta los confines de la tierra."
            },
            {
                "ref": "1 Pedro 1:11",
                "text": "procurando saber qué persona o tiempo indicaba el Espíritu de Cristo dentro de ellos, al predecir los sufrimientos de Cristo y las glorias que seguirían."
            },
            {
                "ref": "Juan 4:41–42",
                "text": "Y muchos más creyeron por su palabra, y decían a la mujer: Ya no creemos por lo que tú has dicho, porque nosotros mismos le hemos oído, y sabemos que este es en verdad el Salvador del mundo."
            },
            {
                "ref": "Juan 20:30–31",
                "text": "Y muchas otras señales hizo también Jesús en presencia de sus discípulos, que no están escritas en este libro; pero estas se han escrito para que creáis que Jesús es el Cristo, el Hijo de Dios; y para que al creer, tengáis vida en su nombre."
            }
        ]
    },
    {
        number: 25,
        question: '¿Cómo ejecuta Cristo el oficio de Sacerdote?',
        answer: 'Cristo ejecuta el oficio de Sacerdote en haberse ofrecido a sí mismo, una sola vez en sacrificio para satisfacer las demandas de la justicia Divina, reconciliarnos con Dios, y en interceder continuamente por nosotros.',
        proofs: [
            {
                "ref": "Isaias 53",
                "text": "¿Quién ha creído a nuestro mensaje? ¿A quién se ha revelado el brazo del Señor? Creció delante de Él como renuevo tierno, como raíz de tierra seca; no tiene aspecto hermoso ni majestad para que le miremos, ni apariencia para que le deseemos. Fue despreciado y desechado de los hombres, varón de dolores y experimentado en aflicción; y como uno de quien los hombres esconden el rostro, fue despreciado, y no le estimamos. Ciertamente Él llevó nuestras enfermedades, y cargó con nuestros dolores; con todo, nosotros le tuvimos por azotado, por herido de Dios y afligido. Mas Él fue herido por nuestras transgresiones, molido por nuestras iniquidades. El castigo, por nuestra paz, cayó sobre Él, y por sus heridas hemos sido sanados. Todos nosotros nos descarriamos como ovejas, nos apartamos cada cual por su camino; pero el Señor hizo que cayera sobre Él la iniquidad de todos nosotros. Fue oprimido y afligido, pero no abrió su boca; como cordero que es llevado al matadero, y como oveja que ante sus trasquiladores permanece muda, no abrió Él su boca. Por opresión y juicio fue quitado; y en cuanto a su generación, ¿quién tuvo en cuenta que Él fuera cortado de la tierra de los vivientes por la transgresión de mi pueblo, a quien correspondía la herida? Se dispuso con los impíos su sepultura, pero con el rico fue en su muerte, aunque no había hecho violencia, ni había engaño en su boca. Pero quiso el Señor quebrantarle, sometiéndole a padecimiento. Cuando Él se entregue a sí mismo como ofrenda de expiación, verá a su descendencia, prolongará sus días, y la voluntad del Señor en su mano prosperará. Debido a la angustia de su alma, Él lo verá y quedará satisfecho. Por su conocimiento, el Justo, mi Siervo, justificará a muchos, y cargará las iniquidades de ellos. Por tanto, yo le daré parte con los grandes y con los fuertes repartirá despojos, porque derramó su alma hasta la muerte y con los transgresores fue contado, llevando Él el pecado de muchos, e intercediendo por los transgresores."
            },
            {
                "ref": "Hechos 8:32–35",
                "text": "El pasaje de la Escritura que estaba leyendo era este: Como oveja fue llevado al matadero; y como cordero, mudo delante del que lo trasquila, no abre Él su boca. En su humillación no se le hizo justicia; ¿quién contará su generación? Porque su vida es quitada de la tierra. El eunuco respondió a Felipe y dijo: Te ruego que me digas, ¿de quién dice esto el profeta? ¿De sí mismo, o de algún otro? Entonces Felipe abrió su boca, y comenzando desde esta Escritura, le anunció el evangelio de Jesús."
            },
            {
                "ref": "Hebreos 9:26–28",
                "text": "De otra manera le hubiera sido necesario sufrir muchas veces desde la fundación del mundo; pero ahora, una sola vez en la consumación de los siglos, se ha manifestado para destruir el pecado por el sacrificio de sí mismo. Y así como está decretado que los hombres mueran una sola vez, y después de esto, el juicio, así también Cristo, habiendo sido ofrecido una vez para llevar los pecados de muchos, aparecerá por segunda vez, sin relación con el pecado, para salvación de los que ansiosamente le esperan."
            },
            {
                "ref": "Hebreos 10:12",
                "text": "pero Él, habiendo ofrecido un solo sacrificio por los pecados para siempre, se sentó a la diestra de Dios,"
            },
            {
                "ref": "Romanos 5:10–11",
                "text": "Porque si cuando éramos enemigos fuimos reconciliados con Dios por la muerte de su Hijo, mucho más, habiendo sido reconciliados, seremos salvos por su vida. Y no solo esto, sino que también nos gloriamos en Dios por medio de nuestro Señor Jesucristo, por quien ahora hemos recibido la reconciliación."
            },
            {
                "ref": "2 Corintios 5:18",
                "text": "Y todo esto procede de Dios, quien nos reconcilió consigo mismo por medio de Cristo, y nos dio el ministerio de la reconciliación;"
            },
            {
                "ref": "Colosenses 1:21–22",
                "text": "Y aunque vosotros antes estabais alejados y erais de ánimo hostil, ocupados en malas obras, sin embargo, ahora Él os ha reconciliado en su cuerpo de carne, mediante su muerte, a fin de presentaros santos, sin mancha e irreprensibles delante de Él,"
            },
            {
                "ref": "Romanos 8:34",
                "text": "¿Quién es el que condena? Cristo Jesús es el que murió, sí, más aún, el que resucitó, el que además está a la diestra de Dios, el que también intercede por nosotros."
            },
            {
                "ref": "Hebreos 7:25",
                "text": "Por lo cual Él también es poderoso para salvar para siempre a los que por medio de Él se acercan a Dios, puesto que vive perpetuamente para interceder por ellos."
            },
            {
                "ref": "Hebreos 9:24",
                "text": "Porque Cristo no entró en un lugar santo hecho por manos, una representación del verdadero, sino en el cielo mismo, para presentarse ahora en la presencia de Dios por nosotros,"
            }
        ]
    },
    {
        number: 26,
        question: '¿Cómo ejecuta Cristo el oficio de Rey?',
        answer: 'Cristo ejecuta el oficio de Rey sujetándonos a sí mismo, rigiendo y defendiéndonos, y restringiendo y venciendo a todos sus enemigos y los nuestros.',
        proofs: [
            {
                "ref": "Salmos 110:3",
                "text": "Tu pueblo se ofrecerá voluntariamente en el día de tu poder; en el esplendor de la santidad, desde el seno de la aurora; tu juventud es para ti como el rocío."
            },
            {
                "ref": "Mateo 28:18–20",
                "text": "Y acercándose Jesús, les habló, diciendo: Toda autoridad me ha sido dada en el cielo y en la tierra. Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo, enseñándoles a guardar todo lo que os he mandado; y he aquí, yo estoy con vosotros todos los días, hasta el fin del mundo."
            },
            {
                "ref": "Juan 17:2",
                "text": "por cuanto le diste autoridad sobre todo ser humano para que dé vida eterna a todos los que tú le has dado."
            },
            {
                "ref": "Salmos 2:6–9",
                "text": "Pero yo mismo he consagrado a mi Rey sobre Sión, mi santo monte. Ciertamente anunciaré el decreto del Señor que me dijo: «Mi Hijo eres tú, yo te he engendrado hoy. Pídeme, y te daré las naciones como herencia tuya, y como posesión tuya los confines de la tierra. Tú los quebrantarás con vara de hierro; los desmenuzarás como vaso de alfarero»."
            },
            {
                "ref": "Salmos 110:1–2",
                "text": "Dice el Señor a mi Señor: Siéntate a mi diestra, hasta que ponga a tus enemigos por estrado de tus pies. El Señor extenderá desde Sión tu poderoso cetro, diciendo: Domina en medio de tus enemigos."
            },
            {
                "ref": "Mateo 12:28",
                "text": "Pero si yo expulso los demonios por el Espíritu de Dios, entonces el reino de Dios ha llegado a vosotros."
            },
            {
                "ref": "1 Corintios 15:24–26",
                "text": "entonces vendrá el fin, cuando Él entregue el reino al Dios y Padre, después que haya abolido todo dominio y toda autoridad y poder. Pues Cristo debe reinar hasta que haya puesto a todos sus enemigos debajo de sus pies. Y el último enemigo que será abolido es la muerte."
            },
            {
                "ref": "Colosenses 2:15",
                "text": "Y habiendo despojado a los poderes y autoridades, hizo de ellos un espectáculo público, triunfando sobre ellos por medio de Él."
            }
        ]
    },
    {
        number: 27,
        question: '¿En qué consistió la humillación de Cristo?',
        answer: 'La humillación de Cristo consistió en nacer, y eso en una condición humilde, hecho bajo la ley, sufriendo las miserias de esta vida, la ira de Dios y la muerte maldita de la cruz; en ser sepultado, y continuar bajo el poder de la muerte por un tiempo.',
        proofs: [
            {
                "ref": "Lucas 2:7",
                "text": "Y dio a luz a su hijo primogénito; le envolvió en pañales y le acostó en un pesebre, porque no había lugar para ellos en el mesón."
            },
            {
                "ref": "2 Corintios 8:9",
                "text": "Porque conocéis la gracia de nuestro Señor Jesucristo, que siendo rico, sin embargo por amor a vosotros se hizo pobre, para que vosotros por medio de su pobreza llegarais a ser ricos."
            },
            {
                "ref": "Galatas 4:4",
                "text": "Pero cuando vino la plenitud del tiempo, Dios envió a su Hijo, nacido de mujer, nacido bajo la ley,"
            },
            {
                "ref": "Isaias 53:3",
                "text": "Fue despreciado y desechado de los hombres, varón de dolores y experimentado en aflicción; y como uno de quien los hombres esconden el rostro, fue despreciado, y no le estimamos."
            },
            {
                "ref": "Lucas 9:58",
                "text": "Y Jesús le dijo: Las zorras tienen madrigueras y las aves del cielo nidos, pero el Hijo del Hombre no tiene dónde recostar la cabeza."
            },
            {
                "ref": "Juan 4:6",
                "text": "y allí estaba el pozo de Jacob. Entonces Jesús, cansado del camino, se sentó junto al pozo. Era como la hora sexta."
            },
            {
                "ref": "Juan 11:35",
                "text": "Jesús lloró."
            },
            {
                "ref": "Hebreos 2:18",
                "text": "Pues por cuanto Él mismo fue tentado en el sufrimiento, es poderoso para socorrer a los que son tentados."
            },
            {
                "ref": "Salmos 22:1",
                "text": "Dios mío, Dios mío, ¿por qué me has abandonado? ¿Por qué estás tan lejos de mi salvación y de las palabras de mi clamor?"
            },
            {
                "ref": "Mateo 27:46",
                "text": "Y alrededor de la hora novena, Jesús exclamó a gran voz, diciendo: Elí, Elí, ¿lema sabactani? Esto es: Dios mío, Dios mío, ¿por qué me has abandonado?"
            },
            {
                "ref": "Isaias 53:10",
                "text": "Pero quiso el Señor quebrantarle, sometiéndole a padecimiento. Cuando Él se entregue a sí mismo como ofrenda de expiación, verá a su descendencia, prolongará sus días, y la voluntad del Señor en su mano prosperará."
            },
            {
                "ref": "1 Juan 2:2",
                "text": "Él mismo es la propiciación por nuestros pecados, y no solo por los nuestros, sino también por los del mundo entero."
            },
            {
                "ref": "Galatas 3:13",
                "text": "Cristo nos redimió de la maldición de la ley, habiéndose hecho maldición por nosotros (porque escrito está: Maldito todo el que cuelga de un madero),"
            },
            {
                "ref": "Filipenses 2:8",
                "text": "Y hallándose en forma de hombre, se humilló a sí mismo, haciéndose obediente hasta la muerte, y muerte de cruz."
            },
            {
                "ref": "Mateo 12:40",
                "text": "porque como estuvo Jonás en el vientre del monstruo marino tres días y tres noches, así estará el Hijo del Hombre tres días y tres noches en el corazón de la tierra."
            },
            {
                "ref": "1 Corintios 15:3–4",
                "text": "Porque yo os entregué en primer lugar lo mismo que recibí: que Cristo murió por nuestros pecados, conforme a las Escrituras; que fue sepultado y que resucitó al tercer día, conforme a las Escrituras;"
            }
        ]
    },
    {
        number: 28,
        question: '¿En qué consiste la exaltación de Cristo?',
        answer: 'La exaltación de Cristo consiste en haber resucitado de entre los muertos al tercer día, en haber ascendido al cielo, en estar sentado a la diestra de Dios Padre y en venir, el último día para juzgar al mundo.',
        proofs: [
            {
                "ref": "1 Corintios 15:4",
                "text": "que fue sepultado y que resucitó al tercer día, conforme a las Escrituras;"
            },
            {
                "ref": "Salmos 68:18",
                "text": "Tú has ascendido a lo alto, has llevado en cautividad a tus cautivos; has recibido dones entre los hombres, y aun entre los rebeldes, para que el Señor Dios habite entre ellos."
            },
            {
                "ref": "Hechos 1:11",
                "text": "que les dijeron: Varones galileos, ¿por qué estáis mirando al cielo? Este mismo Jesús, que ha sido tomado de vosotros al cielo, vendrá de la misma manera, tal como le habéis visto ir al cielo."
            },
            {
                "ref": "Efesios 4:8",
                "text": "Por tanto, dice: Cuando ascendió a lo alto, llevó cautiva una hueste de cautivos, y dio dones a los hombres."
            },
            {
                "ref": "Salmos 110:1",
                "text": "Dice el Señor a mi Señor: Siéntate a mi diestra, hasta que ponga a tus enemigos por estrado de tus pies."
            },
            {
                "ref": "Hechos 2:33–34",
                "text": "Así que, exaltado a la diestra de Dios, y habiendo recibido del Padre la promesa del Espíritu Santo, ha derramado esto que vosotros veis y oís. Porque David no ascendió a los cielos, pero él mismo dice: Dijo el Señor a mi Señor: «Siéntate a mi diestra,"
            },
            {
                "ref": "Hebreos 1:3",
                "text": "Él es el resplandor de su gloria y la expresión exacta de su naturaleza, y sostiene todas las cosas por la palabra de su poder. Después de llevar a cabo la purificación de los pecados, se sentó a la diestra de la Majestad en las alturas,"
            },
            {
                "ref": "Mateo 16:27",
                "text": "Porque el Hijo del Hombre ha de venir en la gloria de su Padre con sus ángeles, y entonces recompensara a cada uno según su conducta."
            },
            {
                "ref": "Hechos 17:31",
                "text": "porque Él ha establecido un día en el cual juzgará al mundo en justicia, por medio de un Hombre a quien ha designado, habiendo presentado pruebas a todos los hombres al resucitarle de entre los muertos."
            }
        ]
    },
    {
        number: 29,
        question: '¿Cómo somos hechos partícipes de la redención comprada por Cristo?',
        answer: 'Somos hechos partícipes de la redención comprada por Cristo, por la aplicación eficaz que de ella nos hace el Espíritu Santo.',
        proofs: [
            {
                "ref": "Tito 3:5-7",
                "text": "Él nos salvó, no por obras de justicia que nosotros hubiéramos hecho, sino conforme a su misericordia, por medio del lavamiento de la regeneración y la renovación por el Espíritu Santo, que Él derramó sobre nosotros abundantemente por medio de Jesucristo nuestro Salvador, para que justificados por su gracia fuésemos hechos herederos según la esperanza de la vida eterna."
            },
            {
                "ref": "Juan 1:11-12",
                "text": "A lo suyo vino, y los suyos no le recibieron. Pero a todos los que le recibieron, les dio el derecho de llegar a ser hijos de Dios, es decir, a los que creen en su nombre,"
            }
        ]
    },
    {
        number: 30,
        question: '¿Cómo nos aplica el Espíritu Santo la redención comprada por Cristo?',
        answer: 'El Espíritu Santo nos aplica la redención comprada por Cristo, obrando fe en nosotros, y uniéndonos así a Cristo por nuestro llamamiento eficaz.',
        proofs: [
            {
                "ref": "Romanos 10:17",
                "text": "Así que la fe viene del oír, y el oír, por la palabra de Cristo."
            },
            {
                "ref": "1 Corintios 2:12–16",
                "text": "Y nosotros hemos recibido, no el espíritu del mundo, sino el Espíritu que viene de Dios, para que conozcamos lo que Dios nos ha dado gratuitamente, de lo cual también hablamos, no con palabras enseñadas por sabiduría humana, sino con las enseñadas por el Espíritu, combinando pensamientos espirituales con palabras espirituales. Pero el hombre natural no acepta las cosas del Espíritu de Dios, porque para él son necedad; y no las puede entender, porque se disciernen espiritualmente. En cambio, el que es espiritual juzga todas las cosas; pero él no es juzgado por nadie. Porque ¿quién ha conocido la mente del Señor, para que le instruya? Mas nosotros tenemos la mente de Cristo."
            },
            {
                "ref": "Efesios 2:8",
                "text": "Porque por gracia habéis sido salvados por medio de la fe, y esto no de vosotros, sino que es don de Dios;"
            },
            {
                "ref": "Filipenses 1:29",
                "text": "Porque a vosotros se os ha concedido por amor de Cristo, no solo creer en Él, sino también sufrir por Él,"
            },
            {
                "ref": "Juan 15:5",
                "text": "Yo soy la vid, vosotros los sarmientos; el que permanece en mí y yo en él, ese da mucho fruto, porque separados de mí nada podéis hacer."
            },
            {
                "ref": "1 Corintios 1:9",
                "text": "Fiel es Dios, por medio de quien fuisteis llamados a la comunión con su Hijo Jesucristo, Señor nuestro."
            },
            {
                "ref": "Efesios 3:17",
                "text": "de manera que Cristo more por la fe en vuestros corazones; y que arraigados y cimentados en amor,"
            }
        ]
    },
    {
        number: 31,
        question: '¿Qué es llamamiento eficaz?',
        answer: 'Llamamiento eficaz es la obra del Espíritu de Dios por la cual, convenciéndonos de nuestro pecado y de nuestra miseria, ilustrando nuestras mentes con el conocimiento de Cristo y renovando nuestras voluntades, nos persuade a abrazar a Cristo, que nos ha sido ofrecido gratuitamente en el Evangelio, y nos pone en capacidad de hacerlo.',
        proofs: [
            {
                "ref": "Hechos 26:18 ",
                "text": "para que abras sus ojos a fin de que se vuelvan de la oscuridad a la luz, y del dominio de Satanás a Dios, para que reciban, por la fe en mí, el perdón de pecados y herencia entre los que han sido santificados»."
            },
            {
                "ref": "1 Corintios 2:10",
                "text": "Pero Dios nos las reveló por medio del Espíritu, porque el Espíritu todo lo escudriña, aun las profundidades de Dios."
            },
            {
                "ref": "1 Corintios 2:12 ",
                "text": "Y nosotros hemos recibido, no el espíritu del mundo, sino el Espíritu que viene de Dios, para que conozcamos lo que Dios nos ha dado gratuitamente,"
            },
            {
                "ref": "2 Corintios 4:6 ",
                "text": "Pues Dios, que dijo que de las tinieblas resplandeciera la luz, es el que ha resplandecido en nuestros corazones, para iluminación del conocimiento de la gloria de Dios en la faz de Cristo."
            },
            {
                "ref": "Efesios 1:17–18 ",
                "text": "pidiendo que el Dios de nuestro Señor Jesucristo, el Padre de gloria, os dé espíritu de sabiduría y de revelación en un mejor conocimiento de Él. Mi oración es que los ojos de vuestro corazón sean iluminados, para que sepáis cuál es la esperanza de su llamamiento, cuáles son las riquezas de la gloria de su herencia en los santos,"
            },
            {
                "ref": "Deuteronomio 30:6 ",
                "text": "Además, el Señor tu Dios circuncidará tu corazón y el corazón de tus descendientes, para que ames al Señor tu Dios con todo tu corazón y con toda tu alma, a fin de que vivas."
            },
            {
                "ref": "Ezekiel 36:26–27 ",
                "text": "Además, os daré un corazón nuevo y pondré un espíritu nuevo dentro de vosotros; quitaré de vuestra carne el corazón de piedra y os daré un corazón de carne. Pondré dentro de vosotros mi espíritu y haré que andéis en mis estatutos, y que cumpláis cuidadosamente mis ordenanzas."
            },
            {
                "ref": "Juan 3:5 ",
                "text": "Jesús respondió: En verdad, en verdad te digo que el que no nace de agua y del Espíritu no puede entrar en el reino de Dios."
            },
            {
                "ref": "Tito 3:5 ",
                "text": "Él nos salvó, no por obras de justicia que nosotros hubiéramos hecho, sino conforme a su misericordia, por medio del lavamiento de la regeneración y la renovación por el Espíritu Santo,"
            },
            {
                "ref": "Juan 6:44–45 ",
                "text": "Nadie puede venir a mí si no lo trae el Padre que me envió, y yo lo resucitaré en el día final. Escrito está en los profetas: «Y todos serán enseñados por Dios». Todo el que ha oído y aprendido del Padre, viene a mí."
            },
            {
                "ref": "Hechos 16:14 ",
                "text": "Y estaba escuchando cierta mujer llamada Lidia, de la ciudad de Tiatira, vendedora de telas de púrpura, que adoraba a Dios; y el Señor abrió su corazón para que recibiera lo que Pablo decía."
            },
            {
                "ref": "Isaias 45:22 ",
                "text": "Volveos a mí y sed salvos, todos los términos de la tierra; porque yo soy Dios, y no hay ningún otro."
            },
            {
                "ref": "Mateo 11:28–30 ",
                "text": "Venid a mí, todos los que estáis cansados y cargados, y yo os haré descansar. Tomad mi yugo sobre vosotros y aprended de mí, que soy manso y humilde de corazón, y hallareis descanso para vuestras almas. Porque mi yugo es fácil y mi carga ligera."
            },
            {
                "ref": "Apocalipsis 22:17",
                "text": "Y el Espíritu y la esposa dicen: Ven. Y el que oye, diga: Ven. Y el que tiene sed, venga; y el que desea, que tome gratuitamente del agua de la vida."
            }
        ]
    },
    {
        number: 32,
        question: '¿De qué beneficio participan en esta vida los que son eficazmente llamados?',
        answer: 'Los que son eficazmente llamados participan en esta vida de la justificación, de la adopción de la santificación y de los varios beneficios que en esta vida acompañan a éstas, o se derivan de ellas.',
        proofs: [
            {
                "ref": "Romanos 8:30",
                "text": "y a los que predestinó, a esos también llamó; y a los que llamó, a esos también justificó; y a los que justificó, a esos también glorificó."
            },
            {
                "ref": "1 Corintios 1:30",
                "text": "Mas por obra suya estáis vosotros en Cristo Jesús, el cual se hizo para nosotros sabiduría de Dios, y justificación, y santificación, y redención,"
            },
            {
                "ref": "1 Corintios 6:11",
                "text": "Y esto erais algunos de vosotros; pero fuisteis lavados, pero fuisteis santificados, pero fuisteis justificados en el nombre del Señor Jesucristo y en el Espíritu de nuestro Dios."
            },
            {
                "ref": "Efesios 1:5",
                "text": "nos predestinó para adopción como hijos para sí mediante Jesucristo, conforme al beneplácito de su voluntad,"
            }
        ]
    },
    {
        number: 33,
        question: '¿Qué es la justificación?',
        answer: 'La justificación es un acto de la libre gracia de Dios, por el cual él perdona todos nuestros pecados y nos acepta como justos delante de él: mas esto solamente en virtud de la justicia de Cristo, la cual nos es imputada, y que recibimos por la fe únicamente.',
        proofs: [
            {
                "ref": "Romanos 3:24",
                "text": "siendo justificados gratuitamente por su gracia por medio de la redención que es en Cristo Jesús,"
            },
            {
                "ref": "Romanos 4:6–8",
                "text": "Como también David habla de la bendición que viene sobre el hombre a quien Dios atribuye justicia aparte de las obras: Bienaventurados aquellos cuyas iniquidades han sido perdonadas, y cuyos pecados han sido cubiertos. Bienaventurado el hombre cuyo pecado el Señor no tomará en cuenta."
            },
            {
                "ref": "2 Corintios 5:19",
                "text": "a saber, que Dios estaba en Cristo reconciliando al mundo consigo mismo, no tomando en cuenta a los hombres sus transgresiones, y nos ha encomendado a nosotros la palabra de la reconciliación."
            },
            {
                "ref": "2 Corintios 5:21",
                "text": "Al que no conoció pecado, le hizo pecado por nosotros, para que fuéramos hechos justicia de Dios en Él."
            },
            {
                "ref": "Romanos 4:6",
                "text": "Como también David habla de la bendición que viene sobre el hombre a quien Dios atribuye justicia aparte de las obras:"
            },
            {
                "ref": "Romanos 4:11",
                "text": "y recibió la señal de la circuncisión como sello de la justicia de la fe que tenía mientras aún era incircunciso, para que fuera padre de todos los que creen sin ser circuncidados, a fin de que la justicia también a ellos les fuera imputada;"
            },
            {
                "ref": "Romanos 5:19",
                "text": "Porque así como por la desobediencia de un hombre los muchos fueron constituidos pecadores, así también por la obediencia de uno los muchos serán constituidos justos."
            },
            {
                "ref": "Galatas 2:16",
                "text": "sin embargo, sabiendo que el hombre no es justificado por las obras de la ley, sino mediante la fe en Cristo Jesús, también nosotros hemos creído en Cristo Jesús, para que seamos justificados por la fe en Cristo, y no por las obras de la ley; puesto que por las obras de la ley nadie será justificado."
            },
            {
                "ref": "Filipenses 3:9",
                "text": "y ser hallado en Él, no teniendo mi propia justicia derivada de la ley, sino la que es por la fe en Cristo, la justicia que procede de Dios sobre la base de la fe,"
            }
        ]
    },
    {
        number: 34,
        question: '¿Qué es la adopción?',
        answer: 'La adopción es un acto de la libre gracia de Dios, por el cual somos recibidos en el número, y tenemos derecho, a todos los privilegios de los hijos de Dios.',
        proofs: [
            {
                "ref": "1 Juan 3:1",
                "text": "Mirad cuán gran amor nos ha otorgado el Padre, para que seamos llamados hijos de Dios; y eso somos. Por esto el mundo no nos conoce, porque no le conoció a Él."
            },
            {
                "ref": "Juan 1:12",
                "text": "Pero a todos los que le recibieron, les dio el derecho de llegar a ser hijos de Dios, es decir, a los que creen en su nombre,"
            },
            {
                "ref": "Romanos 8:17",
                "text": "y si hijos, también herederos; herederos de Dios y coherederos con Cristo, si en verdad padecemos con Él a fin de que también seamos glorificados con Él."
            }
        ]
    },
    {
        number: 35,
        question: '¿Qué es la santificación?',
        answer: 'La santificación es aquella obra de la libre gracia de Dios por la cual somos completamente restablecidos a la imagen de Dios, y puestos en capacidad de morir más y más al pecado y de vivir píamente.',
        proofs: [
            {
                "ref": "Ezekiel 36:27",
                "text": "Pondré dentro de vosotros mi espíritu y haré que andéis en mis estatutos, y que cumpláis cuidadosamente mis ordenanzas."
            },
            {
                "ref": "Filipenses 2:13",
                "text": "porque Dios es quien obra en vosotros tanto el querer como el hacer, para su beneplácito."
            },
            {
                "ref": "2 Tesalonicenses 2:13",
                "text": "Pero nosotros siempre tenemos que dar gracias a Dios por vosotros, hermanos amados por el Señor, porque Dios os ha escogido desde el principio para salvación mediante la santificación por el Espíritu y la fe en la verdad."
            },
            {
                "ref": "2 Corintios 5:17",
                "text": "De modo que si alguno está en Cristo, nueva criatura es; las cosas viejas pasaron; he aquí, son hechas nuevas."
            },
            {
                "ref": "Efesios 4:23–24",
                "text": "y que seáis renovados en el espíritu de vuestra mente, y os vistáis del nuevo hombre, el cual, en la semejanza de Dios, ha sido creado en la justicia y santidad de la verdad."
            },
            {
                "ref": "1 Tesalonicenses 5:23",
                "text": "Y que el mismo Dios de paz os santifique por completo; y que todo vuestro ser, espíritu, alma y cuerpo, sea preservado irreprensible para la venida de nuestro Señor Jesucristo."
            },
            {
                "ref": "Ezekiel 36:25–27",
                "text": "Entonces os rociaré con agua limpia y quedaréis limpios; de todas vuestras inmundicias y de todos vuestros ídolos os limpiaré. Además, os daré un corazón nuevo y pondré un espíritu nuevo dentro de vosotros; quitaré de vuestra carne el corazón de piedra y os daré un corazón de carne. Pondré dentro de vosotros mi espíritu y haré que andéis en mis estatutos, y que cumpláis cuidadosamente mis ordenanzas."
            },
            {
                "ref": "Romanos 6:4",
                "text": "Por tanto, hemos sido sepultados con Él por medio del bautismo para muerte, a fin de que como Cristo resucitó de entre los muertos por la gloria del Padre, así también nosotros andemos en novedad de vida."
            },
            {
                "ref": "Romanos 6:6",
                "text": "sabiendo esto, que nuestro viejo hombre fue crucificado con Él, para que nuestro cuerpo de pecado fuera destruido, a fin de que ya no seamos esclavos del pecado;"
            },
            {
                "ref": "Romanos 6:12-14",
                "text": "Por tanto, no reine el pecado en vuestro cuerpo mortal para que no obedezcáis sus lujurias; ni presentéis los miembros de vuestro cuerpo al pecado como instrumentos de iniquidad, sino presentaos vosotros mismos a Dios como vivos de entre los muertos, y vuestros miembros a Dios como instrumentos de justicia. Porque el pecado no tendrá dominio sobre vosotros, pues no estáis bajo la ley sino bajo la gracia."
            },
            {
                "ref": "2 Corintios 7:1",
                "text": "Por tanto, amados, teniendo estas promesas, limpiémonos de toda inmundicia de la carne y del espíritu, perfeccionando la santidad en el temor de Dios."
            },
            {
                "ref": "1 Pedro 2:24",
                "text": "y Él mismo llevó nuestros pecados en su cuerpo sobre la cruz, a fin de que muramos al pecado y vivamos a la justicia, porque por sus heridas fuisteis sanados."
            }
        ]
    },
    {
        number: 36,
        question: '¿Cuáles son los beneficios que en esta vida acompañan a la justificación, la adopción y la santificación, o que se derivan de ellas?',
        answer: 'Los beneficios que en esta vida acompañan a la justificación, la adopción y la santificación o que se derivan de ellas, son la seguridad del amor de Dios, la tranquilidad de conciencia, el gozo en el Espíritu Santo, el crecimiento en gracia y la perseverancia en ella hasta el fin.',
        proofs: [
            {
                "ref": "Romanos 5:5",
                "text": "y la esperanza no desilusiona, porque el amor de Dios ha sido derramado en nuestros corazones por medio del Espíritu Santo que nos fue dado."
            },
            {
                "ref": "Romanos 5:1",
                "text": "Por tanto, habiendo sido justificados por la fe, tenemos paz para con Dios por medio de nuestro Señor Jesucristo,"
            },
            {
                "ref": "Romanos 14:17",
                "text": "Porque el reino de Dios no es comida ni bebida, sino justicia y paz y gozo en el Espíritu Santo."
            },
            {
                "ref": "2 Pedro 3:18",
                "text": "antes bien, creced en la gracia y el conocimiento de nuestro Señor y Salvador Jesucristo. A Él sea la gloria ahora y hasta el día de la eternidad. Amén."
            },
            {
                "ref": "Filipenses 1:6",
                "text": "estando convencido precisamente de esto: que el que comenzó en vosotros la buena obra, la perfeccionará hasta el día de Cristo Jesús."
            },
            {
                "ref": "1 Pedro 1:5",
                "text": "que sois protegidos por el poder de Dios mediante la fe, para la salvación que está preparada para ser revelada en el último tiempo."
            }
        ]
    },
    {
        number: 37,
        question: '¿Qué beneficios reciben de Cristo los creyentes, después de la muerte?',
        answer: 'Las almas de los creyentes son hechas después de la muerte, perfectas en santidad y pasan inmediatamente a la gloria, y sus cuerpos, estando todavía unidos a Cristo reposan en sus tumbas hasta la resurrección.',
        proofs: [
            {
                "ref": "Hebreos 12:23",
                "text": "a la asamblea general e iglesia de los primogénitos que están inscritos en los cielos, y a Dios, el Juez de todos, y a los espíritus de los justos hechos ya perfectos,"
            },
            {
                "ref": "Lucas 23:43",
                "text": "Entonces Él le dijo: En verdad te digo: hoy estarás conmigo en el paraíso."
            },
            {
                "ref": "2 Corintios 5:6",
                "text": "Por tanto, animados siempre y sabiendo que mientras habitamos en el cuerpo, estamos ausentes del Señor"
            },
            {
                "ref": "2 Corintios 5:8",
                "text": "pero cobramos ánimo y preferimos más bien estar ausentes del cuerpo y habitar con el Señor."
            },
            {
                "ref": "Filipenses 1:23",
                "text": "pues de ambos lados me siento apremiado, teniendo el deseo de partir y estar con Cristo, pues eso es mucho mejor;"
            },
            {
                "ref": "1 Tesalonicenses 4:14",
                "text": "Porque si creemos que Jesús murió y resucitó, así también Dios traerá con Él a los que durmieron en Jesús."
            },
            {
                "ref": "Daniel 12:2",
                "text": "Y muchos de los que duermen en el polvo de la tierra despertarán, unos para la vida eterna, y otros para la ignominia, para el desprecio eterno."
            },
            {
                "ref": "Juan 5:28–29",
                "text": "No os admiréis de esto, porque viene la hora en que todos los que están en los sepulcros oirán su voz, y saldrán: los que hicieron lo bueno, a resurrección de vida, y los que practicaron lo malo, a resurrección de juicio."
            },
            {
                "ref": "Hechos 24:15",
                "text": "teniendo la misma esperanza en Dios que estos también abrigan, de que ciertamente habrá una resurrección tanto de los justos como de los impíos."
            }
        ]
    },
    {
        number: 38,
        question: '¿Qué beneficios reciben de Cristo los creyentes, después de la resurrección?',
        answer: 'Los creyentes, levantándose en gloria en la resurrección, serán públicamente reconocidos y absueltos en el día del juicio, y entrarán en una perfecta bienaventuranza en el pleno goce de Dios por toda la eternidad.',
        proofs: [
            {
                "ref": "1 Corintios 15:42–43",
                "text": "Así es también la resurrección de los muertos. Se siembra un cuerpo corruptible, se resucita un cuerpo incorruptible; se siembra en deshonra, se resucita en gloria; se siembra en debilidad, se resucita en poder;"
            },
            {
                "ref": "Mateo 25:33–34",
                "text": "Y pondrá las ovejas a su derecha y los cabritos a su izquierda. Entonces el Rey dirá a los de su derecha: «Venid, benditos de mi Padre, heredad el reino preparado para vosotros desde la fundación del mundo."
            },
            {
                "ref": "Mateo 25:46",
                "text": "Y estos irán al castigo eterno, pero los justos a la vida eterna."
            },
            {
                "ref": "Romanos 8:29",
                "text": "Porque a los que de antemano conoció, también los predestinó a ser hechos conforme a la imagen de su Hijo, para que Él sea el primogénito entre muchos hermanos;"
            },
            {
                "ref": "1 Juan 3:2",
                "text": "Amados, ahora somos hijos de Dios y aún no se ha manifestado lo que habremos de ser. Pero sabemos que cuando Él se manifieste, seremos semejantes a Él porque le veremos como Él es."
            },
            {
                "ref": "Salmos 16:11",
                "text": "Me darás a conocer la senda de la vida; en tu presencia hay plenitud de gozo; en tu diestra, deleites para siempre."
            },
            {
                "ref": "1 Tesalonicenses 4:17",
                "text": "Entonces nosotros, los que estemos vivos y que permanezcamos, seremos arrebatados juntamente con ellos en las nubes al encuentro del Señor en el aire, y así estaremos con el Señor siempre."
            }
        ]
    },
    {
        number: 39,
        question: '¿Cuál es el deber que Dios exige al hombre?',
        answer: 'El deber que Dios exige al hombre, es la obediencia a su voluntad revelada.',
        proofs: [
            {
                "ref": "Deuteronomio 29:29",
                "text": "Las cosas secretas pertenecen al Señor nuestro Dios, mas las cosas reveladas nos pertenecen a nosotros y a nuestros hijos para siempre, a fin de que guardemos todas las palabras de esta ley."
            },
            {
                "ref": "Miqueas 6:8",
                "text": "Él te ha declarado, oh hombre, lo que es bueno. ¿Y qué es lo que demanda el Señor de ti, sino solo practicar la justicia, amar la misericordia, y andar humildemente con tu Dios?"
            },
            {
                "ref": "1 Juan 5:2–3",
                "text": "En esto sabemos que amamos a los hijos de Dios: cuando amamos a Dios y guardamos sus mandamientos. Porque este es el amor de Dios: que guardemos sus mandamientos, y sus mandamientos no son gravosos."
            }
        ]
    },
    {
        number: 40,
        question: '¿Cuál fue la primera regla que Dios reveló al hombre como guía de obediencia?',
        answer: 'La primera regla que Dios reveló al hombre como guía de obediencia, fue la "ley moral"',
        proofs: [
            {
                "ref": "Romanos 2:14–15",
                "text": "Porque cuando los gentiles, que no tienen la ley, cumplen por instinto los dictados de la ley, ellos, no teniendo la ley, son una ley para sí mismos, ya que muestran la obra de la ley escrita en sus corazones, su conciencia dando testimonio, y sus pensamientos acusándolos unas veces y otras defendiéndolos,"
            },
            {
                "ref": "Romanos 10:5",
                "text": "Porque Moisés escribe que el hombre que practica la justicia que es de la ley, vivirá por ella."
            }
        ]
    },
    {
        number: 41,
        question: '¿En qué se halla comprendida sumariamente la ley moral?',
        answer: 'La ley moral se halla comprendida sumariamente en los diez mandamientos.',
        proofs: [
            {
                "ref": "Deuteronomio 4:13",
                "text": "Y Él os declaró su pacto, el cual os mandó poner por obra: esto es, los diez mandamientos, y los escribió en dos tablas de piedra."
            },
            {
                "ref": "Mateo 19:17–19",
                "text": "Y Él le dijo: ¿Por qué me preguntas acerca de lo bueno? Solo Uno es bueno; pero si deseas entrar en la vida, guarda los mandamientos. Él le dijo*: ¿Cuáles? Y Jesús respondió: No matarás; no cometerás adulterio; no hurtarás; no darás falso testimonio; honra a tu padre y a tu madre; y amarás a tu prójimo como a ti mismo."
            }
        ]
    },
    {
        number: 42,
        question: '¿Cuál es el resumen de los diez mandamientos?',
        answer: 'El resumen de los diez mandamientos es: Amar al Señor nuestro Dios de todo nuestro corazón, de toda nuestra alma, de todas nuestras fuerzas y de todo nuestro entendimiento y a nuestro prójimo como a nosotros mismos.',
        proofs: [
            {
                "ref": "Mateo 22:37–40",
                "text": "Y Él le dijo: Amarás al Señor tu Dios con todo tu corazón, y con toda tu alma, y con toda tu mente. Este es el grande y el primer mandamiento. Y el segundo es semejante a este: Amarás a tu prójimo como a ti mismo. De estos dos mandamientos dependen toda la ley y los profetas."
            }
        ]
    },
    {
        number: 43,
        question: '¿Cuál es el prefacio de los diez mandamientos?',
        answer: 'El prefacio de los diez mandamientos es: "Yo soy el Señor tu Dios, que te saqué de la tierra de Egipto, de la casa de servidumbre."',
        proofs: [
            {
                "ref": "Exodo 20:2",
                "text": "Yo soy el Señor tu Dios, que te saqué de la tierra de Egipto, de la casa de servidumbre."
            },
            {
                "ref": "Deuteronomio 5:6",
                "text": "«Yo soy el Señor tu Dios, que te saqué de la tierra de Egipto, de la casa de servidumbre."
            }
        ]
    },
    {
        number: 44,
        question: '¿Qué nos enseña el prefacio de los diez mandamientos?',
        answer: 'El prefacio de los diez mandamientos nos enseña que siendo Dios el Señor y nuestro Dios y Redentor, estamos por tanto, obligados a guardar todos sus mandamientos.',
        proofs: [
            {
                "ref": "Lucas 1:74–75",
                "text": "concedernos que, librados de la mano de nuestros enemigos, le sirvamos sin temor en santidad y justicia delante de Él, todos nuestros días."
            },
            {
                "ref": "1 Pedro 1:14–19",
                "text": "Como hijos obedientes, no os conforméis a los deseos que antes teníais en vuestra ignorancia, sino que así como aquel que os llamó es santo, así también sed vosotros santos en toda vuestra manera de vivir; porque escrito está: Sed santos, porque Yo soy santo. Y si invocáis como Padre a aquel que imparcialmente juzga según la obra de cada uno, conducíos en temor durante el tiempo de vuestra peregrinación; sabiendo que no fuisteis redimidos de vuestra vana manera de vivir heredada de vuestros padres con cosas perecederas como oro o plata, sino con sangre preciosa, como de un cordero sin tacha y sin mancha, la sangre de Cristo."
            }
        ]
    },
    {
        number: 45,
        question: '¿Cuál es el primer mandamiento?',
        answer: 'El primer mandamiento es: "No tendrás otros dioses delante de mí.',
        proofs: [
            {
                "ref": "Exodo 20:3",
                "text": "No tendrás otros dioses delante de mí."
            },
            {
                "ref": "Deuteronomio 5:7",
                "text": "»No tendrás otros dioses delante de mí."
            }
        ]
    },
    {
        number: 46,
        question: '¿Qué se ordena en el primer mandamiento?',
        answer: 'El primer mandamiento nos ordenan que conozcamos y confesemos a Dios como nuestro único y verdadero Dios, y que en consecuencia, le adoremos y le glorifiquemos.',
        proofs: [
            {
                "ref": "1 Cronicas 28:9",
                "text": "En cuanto a ti, Salomón, hijo mío, reconoce al Dios de tu padre, y sírvele de todo corazón y con ánimo dispuesto; porque el Señor escudriña todos los corazones, y entiende todo intento de los pensamientos. Si le buscas, Él te dejará encontrarle; pero si le abandonas, Él te rechazará para siempre."
            },
            {
                "ref": "Isaias 45:20–25",
                "text": "Reuníos y venid; juntos acercaos, fugitivos de las naciones. No tienen conocimiento los que llevan su ídolo de madera y suplican a un dios que no puede salvar. Declarad y presentad vuestro caso; sí, que deliberen juntos: ¿Quién ha anunciado esto desde la antigüedad y lo ha declarado desde entonces? ¿No soy yo, el Señor? No hay más Dios que yo, un Dios justo y salvador; no hay ninguno fuera de mí. Volveos a mí y sed salvos, todos los términos de la tierra; porque yo soy Dios, y no hay ningún otro. Por mí mismo he jurado, ha salido de mi boca en justicia una palabra que no será revocada: Que ante mí se doblará toda rodilla, y toda lengua jurará lealtad. De mí dirán: «Solo en el Señor hay justicia y fuerza». A Él vendrán y serán avergonzados todos los que contra Él se enojaron. En el Señor será justificada y se gloriará toda la descendencia de Israel."
            },
            {
                "ref": "Mateo 4:10",
                "text": "Entonces Jesús le dijo*: ¡Vete, Satanás! Porque escrito está: «Al Señor tu Dios adorarás, y solo a Él servirás»."
            }
        ]
    },
    {
        number: 47,
        question: '¿Qué se prohíbe en el primer mandamiento?',
        answer: 'El primer mandamiento nos prohíbe que neguemos a Dios o que dejemos de adorarle y glorificarle como el verdadero Dios y el nuestro, o que rindamos a ningún otro ser la adoración y gloria que a él sólo son debidas.',
        proofs: [
            {
                "ref": "Salmo 14:1",
                "text": "El necio ha dicho en su corazón: No hay Dios. Se han corrompido, han cometido hechos abominables; no hay quien haga el bien."
            },
            {
                "ref": "Romanos 1:20–21",
                "text": "Porque desde la creación del mundo, sus atributos invisibles, su eterno poder y divinidad, se han visto con toda claridad, siendo entendidos por medio de lo creado, de manera que no tienen excusa. Pues aunque conocían a Dios, no le honraron como a Dios ni le dieron gracias, sino que se hicieron vanos en sus razonamientos y su necio corazón fue entenebrecido."
            },
            {
                "ref": "Salmo 81:10–11",
                "text": "Yo, el Señor, soy tu Dios, que te saqué de la tierra de Egipto; abre bien tu boca y la llenaré. Pero mi pueblo no escuchó mi voz; Israel no me obedeció."
            },
            {
                "ref": "Ezekiel 8:16–18",
                "text": "Entonces me llevó al atrio interior de la casa del Señor. Y he aquí, a la entrada del templo del Señor, entre el pórtico y el altar, había unos veinticinco hombres de espaldas al templo del Señor y de cara al oriente, y se postraban hacia el oriente, hacia el sol. Y Él me dijo: ¿Has visto, hijo de hombre? ¿Le parece poco a la casa de Judá cometer las abominaciones que aquí han cometido, que han llenado la tierra de violencia y me han provocado repetidas veces? Porque he aquí, se llevan el ramo a la nariz. Por tanto, yo ciertamente obraré con furor. Mi ojo no tendrá piedad, ni yo perdonaré; y aunque griten a mis oídos con gran voz, no los escucharé."
            },
            {
                "ref": "Romanos 1:25",
                "text": "porque cambiaron la verdad de Dios por la mentira, y adoraron y sirvieron a la criatura en lugar del Creador, quien es bendito por los siglos. Amén."
            }
        ]
    },
    {
        number: 48,
        question: '¿Qué cosa especial se nos enseña con estas palabras "delante de mí", contenidas en el primer mandamiento?',
        answer: 'En estas palabras, "delante de mí", contenidas en el primer mandamiento, se nos enseña que Dios, que todo lo ve, se percibe del pecado de rendir culto a otro cualquiera y se ofende de ello.',
        proofs: [
            {
                "ref": "Deuteronomio 30:17–18",
                "text": "Pero si tu corazón se desvía y no escuchas, sino que te dejas arrastrar y te postras ante otros dioses y los sirves, yo os declaro hoy que ciertamente pereceréis. No prolongaréis vuestros días en la tierra adonde tú vas, cruzando el Jordán para entrar en ella y poseerla."
            },
            {
                "ref": "Salmo 44:20–21",
                "text": "Si nos hubiéramos olvidado del nombre de nuestro Dios, o extendido nuestras manos a un dios extraño, ¿no se habría dado cuenta Dios de esto? Pues Él conoce los secretos del corazón."
            },
            {
                "ref": "Ezekiel 8:12",
                "text": "Me dijo entonces: Hijo de hombre, ¿has visto lo que hacen en la oscuridad los ancianos de la casa de Israel, cada uno en su cámara de imágenes grabadas? Porque ellos dicen: «El Señor no nos ve; el Señor ha abandonado la tierra»."
            }
        ]
    },
    {
        number: 49,
        question: '¿Cuál es el segundo mandamiento?',
        answer: 'El segundo mandamiento, es: "No te harás ídolo, ni semejanza alguna de lo que está arriba en el cielo, ni abajo en la tierra, ni en las aguas debajo de la tierra. No los adorarás ni los servirás; porque yo, el Señor tu Dios, soy Dios celoso, que castigo la iniquidad de los padres sobre los hijos hasta la tercera y cuarta generación de los que me aborrecen, y muestro misericordia a millares, a los que me aman y guardan mis mandamientos."',
        proofs: [
            {
                "ref": "Exodo 20:4–6",
                "text": "No te harás ídolo, ni semejanza alguna de lo que está arriba en el cielo, ni abajo en la tierra, ni en las aguas debajo de la tierra. No los adorarás ni los servirás; porque yo, el Señor tu Dios, soy Dios celoso, que castigo la iniquidad de los padres sobre los hijos hasta la tercera y cuarta generación de los que me aborrecen, y muestro misericordia a millares, a los que me aman y guardan mis mandamientos."
            },
            {
                "ref": "Deuteronomio 5:8–10",
                "text": "»No te harás ningún ídolo, ni semejanza alguna de lo que está arriba en el cielo, ni abajo en la tierra, ni en las aguas debajo de la tierra. No los adorarás ni los servirás; porque yo, el Señor tu Dios, soy Dios celoso, que castigo la iniquidad de los padres sobre los hijos, y sobre la tercera y la cuarta generación de los que me aborrecen, pero que muestro misericordia a millares, a los que me aman y guardan mis mandamientos."
            }
        ]
    },
    {
        number: 50,
        question: '¿Qué se ordena en el segundo mandamiento?',
        answer: 'En el segundo mandamiento se ordena que recibamos, observemos y guardemos puros y completos, todos actos de culto y todas las leyes que Dios ha establecido en su palabra.',
        proofs: [
            {
                "ref": "Deuteronomio 12:32",
                "text": "Cuidarás de hacer todo lo que te mando; nada le añadirás ni le quitarás."
            },
            {
                "ref": "Mateo 28:20",
                "text": "enseñándoles a guardar todo lo que os he mandado; y he aquí, yo estoy con vosotros todos los días, hasta el fin del mundo."
            }
        ]
    },
    {
        number: 51,
        question: '¿Qué se prohíbe en el segundo mandamiento?',
        answer: 'El segundo mandamiento prohíbe que rindamos culto a Dios por medio de imágenes o por cualquiera otro medio que no esté autorizado por su palabra.',
        proofs: [
            {
                "ref": "Deuteronomio 4:15–19",
                "text": "Así que guardaos bien, ya que no visteis ninguna figura el día en que el Señor os habló en Horeb de en medio del fuego; no sea que os corrompáis y hagáis para vosotros una imagen tallada semejante a cualquier figura: semejanza de varón o hembra, semejanza de cualquier animal que está en la tierra, semejanza de cualquier ave que vuela en el cielo, semejanza de cualquier animal que se arrastra sobre la tierra, semejanza de cualquier pez que hay en las aguas debajo de la tierra. No sea que levantes los ojos al cielo y veas el sol, la luna, las estrellas y todo el ejército del cielo, y seas impulsado a adorarlos y servirlos, cosas que el Señor tu Dios ha concedido a todos los pueblos debajo de todos los cielos."
            },
            {
                "ref": "Romanos 1:22–23",
                "text": "Profesando ser sabios, se volvieron necios, y cambiaron la gloria del Dios incorruptible por una imagen en forma de hombre corruptible, de aves, de cuadrúpedos y de reptiles."
            },
            {
                "ref": "Levítico 10:1–2",
                "text": "Nadab y Abiú, hijos de Aarón, tomaron sus respectivos incensarios, y después de poner fuego en ellos y echar incienso sobre él, ofrecieron delante del Señor fuego extraño, que Él no les había ordenado. Y de la presencia del Señor salió fuego que los consumió, y murieron delante del Señor."
            },
            {
                "ref": "Jeremias 19:4–5",
                "text": "Porque me han abandonado, han hecho extraño este lugar y han ofrecido sacrificios en él a otros dioses, que ni ellos, ni sus padres, ni los reyes de Judá habían conocido, y han llenado este lugar de sangre de inocentes, y han edificado los lugares altos de Baal para quemar a sus hijos en el fuego como holocaustos a Baal, cosa que nunca mandé, ni de la cual hablé, ni me pasó por la mente;"
            },
            {
                "ref": "Colosenses 2:18–23",
                "text": "Nadie os defraude de vuestro premio deleitándose en la humillación de sí mismo y en la adoración de los ángeles, basándose en las visiones que ha visto, hinchado sin causa por su mente carnal, pero no asiéndose a la Cabeza, de la cual todo el cuerpo, nutrido y unido por las coyunturas y ligamentos, crece con un crecimiento que es de Dios. Si habéis muerto con Cristo a los principios elementales del mundo, ¿por qué, como si aún vivierais en el mundo, os sometéis a preceptos tales como: no manipules, no gustes, no toques (todos los cuales se refieren a cosas destinadas a perecer con el uso), según los preceptos y enseñanzas de los hombres? Tales cosas tienen a la verdad, la apariencia de sabiduría en una religión humana, en la humillación de sí mismo y en el trato severo del cuerpo, pero carecen de valor alguno contra los apetitos de la carne."
            }
        ]
    },
    {
        number: 52,
        question: '¿Cuáles son las razones determinantes del segundo mandamiento?',
        answer: 'Las razones determinantes del segundo mandamiento, son: la soberanía y dominio de Dios sobre nosotros, y el celo que él tiene por su propio culto.',
        proofs: [
            {
                "ref": "Salmo 95:2–3",
                "text": "Vengamos ante su presencia con acción de gracias; aclamémosle con salmos. Porque Dios grande es el Señor, y Rey grande sobre todos los dioses,"
            },
            {
                "ref": "Salmo 95:6–7",
                "text": "Venid, adoremos y postrémonos; doblemos la rodilla ante el Señor nuestro Hacedor. Porque Él es nuestro Dios, y nosotros el pueblo de su prado y las ovejas de su mano. Si oís hoy su voz,"
            },
            {
                "ref": "Salmo 96:9–10",
                "text": "Adorad al Señor en vestiduras santas; temblad ante su presencia, toda la tierra. Decid entre las naciones: El Señor reina; ciertamente el mundo está bien afirmado, será inconmovible; Él juzgará a los pueblos con equidad."
            },
            {
                "ref": "Exodo 19:5",
                "text": "Ahora pues, si en verdad escucháis mi voz y guardáis mi pacto, seréis mi especial tesoro entre todos los pueblos, porque mía es toda la tierra;"
            },
            {
                "ref": "Salmo 45:11",
                "text": "Entonces el rey deseará tu hermosura; inclínate ante él, porque él es tu señor."
            },
            {
                "ref": "Isaias 54:5",
                "text": "Porque tu esposo es tu Hacedor, el Señor de los ejércitos es su nombre; y tu Redentor es el Santo de Israel, que se llama Dios de toda la tierra."
            },
            {
                "ref": "Exodo 34:14",
                "text": "(pues no adorarás a ningún otro dios, ya que el Señor, cuyo nombre es Celoso, es Dios celoso)"
            },
            {
                "ref": "1 Corintios 10:22",
                "text": "¿O provocaremos a celos al Señor? ¿Somos, acaso, más fuertes que Él?"
            }
        ]
    },
    {
        number: 53,
        question: '¿Cuál es el tercer mandamiento?',
        answer: 'El tercer mandamiento es: "No tomarás el nombre del Señor tu Dios en vano, porque el Señor no tendrá por inocente al que tome su nombre en vano."',
        proofs: [
            {
                "ref": "Exodo 20:7",
                "text": "No tomarás el nombre del Señor tu Dios en vano, porque el Señor no tendrá por inocente al que tome su nombre en vano."
            },
            {
                "ref": "Deuteronomio 5:11",
                "text": "»No tomarás en vano el nombre del Señor tu Dios, porque el Señor no tendrá por inocente a quien tome su nombre en vano."
            }
        ]
    },
    {
        number: 54,
        question: '¿Qué se exige en el tercer mandamiento?',
        answer: 'El tercer mandamiento exige el usar santa y reverentemente de los nombres, de los títulos, los atributos, las ordenanzas, la palabra y las obras de Dios.',
        proofs: [
            {
                "ref": "Deuteronomio 10:20",
                "text": "Temerás al Señor tu Dios; le servirás, te allegarás a Él y solo en su nombre jurarás."
            },
            {
                "ref": "Salmo 29:2",
                "text": "Tributad al Señor la gloria debida a su nombre; adorad al Señor en la majestad de la santidad."
            },
            {
                "ref": "1 Cronicas 29:10–13",
                "text": "Y bendijo David al Señor en presencia de toda la asamblea. Y David dijo: Bendito eres, oh Señor, Dios de Israel, nuestro padre por los siglos de los siglos. Tuya es, oh Señor, la grandeza y el poder y la gloria y la victoria y la majestad, en verdad, todo lo que hay en los cielos y en la tierra; tuyo es el dominio, oh Señor, y tú te exaltas como soberano sobre todo. De ti proceden la riqueza y el honor; tú reinas sobre todo y en tu mano están el poder y la fortaleza, y en tu mano está engrandecer y fortalecer a todos. Ahora pues, Dios nuestro, te damos gracias y alabamos tu glorioso nombre."
            },
            {
                "ref": "Apocalipsis 15:3–4",
                "text": "Y cantaban* el cántico de Moisés, siervo de Dios, y el cántico del Cordero, diciendo: ¡Grandes y maravillosas son tus obras, oh Señor Dios, Todopoderoso! ¡Justos y verdaderos son tus caminos, oh Rey de las naciones! ¡Oh Señor! ¿Quién no temerá y glorificará tu nombre? Pues solo tú eres santo; porque todas las naciones vendrán y adorarán en tu presencia, pues tus justos juicios han sido revelados."
            },
            {
                "ref": "Hechos 2:42",
                "text": "Y se dedicaban continuamente a las enseñanzas de los apóstoles, a la comunión, al partimiento del pan y a la oración."
            },
            {
                "ref": "1 Corintios 11:27–28",
                "text": "De manera que el que coma el pan o beba la copa del Señor indignamente, será culpable del cuerpo y de la sangre del Señor. Por tanto, examínese cada uno a sí mismo, y entonces coma del pan y beba de la copa."
            },
            {
                "ref": "Salmo 138:2",
                "text": "Me postraré hacia tu santo templo, y daré gracias a tu nombre por tu misericordia y tu fidelidad; porque has engrandecido tu palabra conforme a todo tu nombre."
            },
            {
                "ref": "Apocalipsis 22:18–19",
                "text": "Yo testifico a todos los que oyen las palabras de la profecía de este libro: Si alguno añade a ellas, Dios traerá sobre él las plagas que están escritas en este libro; y si alguno quita de las palabras del libro de esta profecía, Dios quitará su parte del árbol de la vida y de la ciudad santa descritos en este libro."
            },
            {
                "ref": "Salmo 107:21–22",
                "text": "Den gracias al Señor por su misericordia y por sus maravillas para con los hijos de los hombres. Ofrezcan también sacrificios de acción de gracias y pregonen sus obras con cantos de júbilo."
            },
            {
                "ref": "Apocalipsis 4:11",
                "text": "Digno eres, Señor y Dios nuestro, de recibir la gloria y el honor y el poder, porque tú creaste todas las cosas, y por tu voluntad existen y fueron creadas."
            }
        ]
    },
    {
        number: 55,
        question: '¿Qué prohíbe el tercer mandamiento?',
        answer: 'El tercer mandamiento prohíbe toda profanación o abuso de cualquier cosa por la cual Dios se da a conocer.',
        proofs: [
            {
                "ref": "Levítico 19:12",
                "text": "Y no juraréis en falso por mi nombre, profanando así el nombre de tu Dios; yo soy el Señor."
            },
            {
                "ref": "Mateo 5:33–37",
                "text": "También habéis oído que se dijo a los antepasados: «No jurarás falsamente, sino que cumplirás tus juramentos al Señor». Pero yo os digo: no juréis de ninguna manera; ni por el cielo, porque es el trono de Dios; ni por la tierra, porque es el estrado de sus pies; ni por Jerusalén, porque es la ciudad del gran Rey. Ni jurarás por tu cabeza, porque no puedes hacer blanco o negro ni un solo cabello. Antes bien, sea vuestro hablar: «Sí, sí» o «No, no»; y lo que es más de esto, procede del mal."
            },
            {
                "ref": "Santiago 5:12",
                "text": "Y sobre todo, hermanos míos, no juréis, ni por el cielo, ni por la tierra, ni con ningún otro juramento; antes bien, sea vuestro sí, sí, y vuestro no, no, para que no caigáis bajo juicio."
            }
        ]
    },
    {
        number: 56,
        question: '¿Cuál es la razón determinante del tercer mandamiento?',
        answer: 'La razón determinante del tercer mandamiento es, que por más que eviten los infractores de este mandamiento el castigo humano, el  Señor nuestro Dios no les dejará escapar de su justo juicio.',
        proofs: [
            {
                "ref": "Deuteronomio 28:58–59",
                "text": "Si no cuidas de poner en práctica todas las palabras de esta ley que están escritas en este libro, temiendo este nombre glorioso y temible, el Señor tu Dios, entonces el Señor hará horribles tus plagas y las plagas de tus descendientes, plagas severas y duraderas, y enfermedades perniciosas y crónicas."
            },
            {
                "ref": "1 Samuel 3:13",
                "text": "Porque le he hecho saber que estoy a punto de juzgar su casa para siempre a causa de la iniquidad que él conocía, pues sus hijos trajeron sobre sí una maldición, y él no los reprendió."
            },
            {
                "ref": "1 Samuel 4:11",
                "text": "El arca de Dios fue capturada, y murieron los dos hijos de Elí, Ofni y Finees."
            }
        ]
    },
    {
        number: 57,
        question: '¿Cuál es el Cuarto Mandamiento?',
        answer: 'El cuarto mandamiento, es: "Acuérdate del día de Reposo para santificarlo. Seis días trabajarás y harás toda tu obra, mas el séptimo día será Reposo para Jehová tu Dios, no hagas en él obra alguna, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu criada, ni tu bestia, ni tu extranjero que está dentro de tus puertas, porque en seis días hizo Jehová los cielos y la tierra, la mar y todas las cosas que en ellos hay, y reposó en el séptimo día, por tanto Jehová bendijo el día del Reposo y lo santificó".',
        proofs: [
            {
                "ref": "Exodo 20:8–11",
                "text": "Acuérdate del día de reposo para santificarlo. Seis días trabajarás y harás toda tu obra, mas el séptimo día es día de reposo para el Señor tu Dios; no harás en él obra alguna, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu sierva, ni tu ganado, ni el extranjero que está contigo. Porque en seis días hizo el Señor los cielos y la tierra, el mar y todo lo que en ellos hay, y reposó en el séptimo día; por tanto, el Señor bendijo el día de reposo y lo santificó."
            },
            {
                "ref": "Deuteronomio 5:12–15",
                "text": "»Guardarás el día de reposo para santificarlo, como el Señor tu Dios lo ha mandado. Seis días trabajarás y harás todo tu trabajo, mas el séptimo día es día de reposo para el Señor tu Dios; no harás en él ningún trabajo, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu sierva, ni tu buey, ni tu asno, ni ninguno de tus animales, ni el forastero que está contigo, para que tu siervo y tu sierva también descansen como tú. Y acuérdate que fuiste esclavo en la tierra de Egipto, y que el Señor tu Dios te sacó de allí con mano fuerte y brazo extendido; por lo tanto, el Señor tu Dios te ha ordenado que guardes el día de reposo."
            }
        ]
    },
    {
        number: 58,
        question: '¿Qué exige el cuarto mandamiento?',
        answer: 'El cuarto mandamiento exige que consagremos a Dios todo el tiempo que él ha señalado en su palabra, y especialmente un día entero en cada siete, como un descanso santificado a él.',
        proofs: [
            {
                "ref": "Exodo 31:13",
                "text": "Habla, pues, tú a los hijos de Israel, diciendo: «De cierto guardaréis mis días de reposo, porque esto es una señal entre yo y vosotros por todas vuestras generaciones, a fin de que sepáis que yo soy el Señor que os santifico."
            },
            {
                "ref": "Exodo 31:16–17",
                "text": "Los hijos de Israel guardarán, pues, el día de reposo, celebrándolo por todas sus generaciones como pacto perpetuo». Es una señal entre yo y los hijos de Israel para siempre; pues en seis días el Señor hizo los cielos y la tierra, y en el séptimo día cesó de trabajar y reposó."
            }
        ]
    },
    {
        number: 59,
        question: '¿Cuál día de los siete ha señalado Dios para el descanso semanal?',
        answer: 'Desde la creación del mundo hasta la resurrección de Cristo, Dios señaló el séptimo día de la semana para ser el descanso semanal, mas desde entonces ha señalado el primer día de la semana para que sea el día de reposo, el cual ha de continuar hasta el fin del mundo y es el descanso cristiano.',
        proofs: [
            {
                "ref": "Genesis 2:2–3",
                "text": "Y en el séptimo día completó Dios la obra que había hecho, y reposó en el día séptimo de toda la obra que había hecho. Y bendijo Dios el séptimo día y lo santificó, porque en él reposó de toda la obra que Él había creado y hecho."
            },
            {
                "ref": "Éxodo 20:11",
                "text": "Porque en seis días hizo el Señor los cielos y la tierra, el mar y todo lo que en ellos hay, y reposó en el séptimo día; por tanto, el Señor bendijo el día de reposo y lo santificó."
            },
            {
                "ref": "Marcos 2:27–28",
                "text": "Y Él les decía: El día de reposo se hizo para el hombre, y no el hombre para el día de reposo. Por tanto, el Hijo del Hombre es Señor aun del día de reposo."
            },
            {
                "ref": "Hechos 20:7",
                "text": "Y el primer día de la semana, cuando estábamos reunidos para partir el pan, Pablo les hablaba, pensando partir al día siguiente, y prolongó su discurso hasta la medianoche."
            },
            {
                "ref": "1 Corintios 16:2",
                "text": "Que el primer día de la semana, cada uno de vosotros aparte y guarde según haya prosperado, para que cuando yo vaya no se recojan entonces ofrendas."
            },
            {
                "ref": "Apocalipsis 1:10",
                "text": "Estaba yo en el Espíritu en el día del Señor, y oí detrás de mí una gran voz, como sonido de trompeta,"
            }
        ]
    },
    {
        number: 60,
        question: '¿Cómo ha de santificarse el día de reposo?',
        answer: 'Hemos de santificar el día de reposo absteniéndonos en todo este día, aún de aquellos empleos o recreaciones mundanales que son lícitos en los demás días, y ocupando todo el tiempo en los ejercicios públicos y privados del culto de Dios salvo aquella parte que se emplee en hacer obras de necesidad o de misericordia.',
        proofs: [
            {
                "ref": "Éxodo 20:10",
                "text": "mas el séptimo día es día de reposo para el Señor tu Dios; no harás en él obra alguna, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu sierva, ni tu ganado, ni el extranjero que está contigo."
            },
            {
                "ref": "Nehemías 13:15–22",
                "text": "En aquellos días vi en Judá a algunos que pisaban los lagares en el día de reposo, y traían haces de trigo y los cargaban en asnos, y también vino, uvas, higos y toda clase de carga, y los traían a Jerusalén en el día de reposo. Y les amonesté por el día en que vendían los víveres. También habitaban allí, en Jerusalén, tirios, que importaban pescado y toda clase de mercancías, y los vendían a los hijos de Judá en el día de reposo. Entonces reprendí a los nobles de Judá, y les dije: ¿Qué acción tan mala es esta que cometéis profanando el día de reposo? ¿No hicieron lo mismo vuestros padres, y nuestro Dios trajo sobre nosotros y sobre esta ciudad toda esta aflicción? Vosotros, pues, aumentáis su furor contra Israel al profanar el día de reposo. Y aconteció que cuando iba oscureciendo a las puertas de Jerusalén, antes del día de reposo, ordené que se cerraran las puertas y que no las abrieran hasta después del día de reposo. Entonces puse algunos de mis siervos a las puertas para que no entrara ninguna carga en día de reposo. Pero una o dos veces, los mercaderes y vendedores de toda clase de mercancía pasaron la noche fuera de Jerusalén. Entonces les advertí, y les dije: ¿Por qué pasáis la noche delante de la muralla? Si lo hacéis de nuevo, usaré fuerza contra vosotros. Desde entonces no vinieron más en el día de reposo. Y ordené a los levitas que se purificaran y que vinieran a guardar las puertas para santificar el día de reposo. Por esto también acuérdate de mí, Dios mío, y ten piedad de mí conforme a la grandeza de tu misericordia."
            },
            {
                "ref": "Isaias 58:13–14",
                "text": "Si por causa del día de reposo apartas tu pie para no hacer lo que te plazca en mi día santo, y llamas al día de reposo delicia, al día santo del Señor, honorable, y lo honras, no siguiendo tus caminos, ni buscando tu placer, ni hablando de tus propios asuntos, entonces te deleitarás en el Señor, y yo te haré cabalgar sobre las alturas de la tierra, y te alimentaré con la heredad de tu padre Jacob; porque la boca del Señor ha hablado."
            },
            {
                "ref": "Éxodo 20:8",
                "text": "Acuérdate del día de reposo para santificarlo."
            },
            {
                "ref": "Levítico 23:3",
                "text": "Seis días se trabajará, pero el séptimo día será día de completo reposo, santa convocación en que no haréis trabajo alguno; es día de reposo al Señor dondequiera que habitéis."
            },
            {
                "ref": "Lucas 4:16",
                "text": "Llegó a Nazaret, donde se había criado, y según su costumbre, entró en la sinagoga el día de reposo, y se levantó a leer."
            },
            {
                "ref": "Hechos 20:7",
                "text": "Y el primer día de la semana, cuando estábamos reunidos para partir el pan, Pablo les hablaba, pensando partir al día siguiente, y prolongó su discurso hasta la medianoche."
            },
            {
                "ref": "Mateo 12:1–13",
                "text": "Por aquel tiempo Jesús pasó por entre los sembrados en el día de reposo; sus discípulos tuvieron hambre, y empezaron a arrancar espigas y a comer. Y cuando lo vieron los fariseos, le dijeron: Mira, tus discípulos hacen lo que no es lícito hacer en el día de reposo. Pero Él les dijo: ¿No habéis leído lo que hizo David cuando él y sus compañeros tuvieron hambre, cómo entró en la casa de Dios y comieron los panes consagrados, que no les era lícito comer, ni a él ni a los que estaban con él, sino solo a los sacerdotes? ¿O no habéis leído en la ley, que en los días de reposo los sacerdotes en el templo profanan el día de reposo y están sin culpa? Pues os digo que algo mayor que el templo está aquí. Pero si hubierais sabido lo que esto significa: «Misericordia quiero y no sacrificio», no hubierais condenado a los inocentes. Porque el Hijo del Hombre es Señor del día de reposo. Pasando de allí, entró en la sinagoga de ellos. Y he aquí, había allí un hombre que tenía una mano seca. Y para poder acusarle, le preguntaron, diciendo: ¿Es lícito sanar en el día de reposo? Y Él les dijo: ¿Qué hombre habrá de vosotros que tenga una sola oveja, si esta se le cae en un hoyo en día de reposo, no le echa mano y la saca? Pues, ¡cuánto más vale un hombre que una oveja! Por tanto, es lícito hacer bien en el día de reposo. Entonces dijo* al hombre: Extiende tu mano. Y él la extendió, y le fue restaurada, sana como la otra."
            }
        ]
    },
    {
        number: 61,
        question: '¿Qué se prohíbe en el cuarto mandamiento?',
        answer: 'El cuarto mandamiento prohíbe la omisión o cumplimiento negligente de los deberes exigidos: la profanación del día por la ociosidad, o por hacer lo que es en sí pecaminoso, o por innecesarios pensamientos, palabras u obras respecto a nuestros empleos o recreaciones mundanas.',
        proofs: [
            {
                "ref": "Nehemías 13:15–22",
                "text": "En aquellos días vi en Judá a algunos que pisaban los lagares en el día de reposo, y traían haces de trigo y los cargaban en asnos, y también vino, uvas, higos y toda clase de carga, y los traían a Jerusalén en el día de reposo. Y les amonesté por el día en que vendían los víveres. También habitaban allí, en Jerusalén, tirios, que importaban pescado y toda clase de mercancías, y los vendían a los hijos de Judá en el día de reposo. Entonces reprendí a los nobles de Judá, y les dije: ¿Qué acción tan mala es esta que cometéis profanando el día de reposo? ¿No hicieron lo mismo vuestros padres, y nuestro Dios trajo sobre nosotros y sobre esta ciudad toda esta aflicción? Vosotros, pues, aumentáis su furor contra Israel al profanar el día de reposo. Y aconteció que cuando iba oscureciendo a las puertas de Jerusalén, antes del día de reposo, ordené que se cerraran las puertas y que no las abrieran hasta después del día de reposo. Entonces puse algunos de mis siervos a las puertas para que no entrara ninguna carga en día de reposo. Pero una o dos veces, los mercaderes y vendedores de toda clase de mercancía pasaron la noche fuera de Jerusalén. Entonces les advertí, y les dije: ¿Por qué pasáis la noche delante de la muralla? Si lo hacéis de nuevo, usaré fuerza contra vosotros. Desde entonces no vinieron más en el día de reposo. Y ordené a los levitas que se purificaran y que vinieran a guardar las puertas para santificar el día de reposo. Por esto también acuérdate de mí, Dios mío, y ten piedad de mí conforme a la grandeza de tu misericordia."
            },
            {
                "ref": "Isaias 58:13–14",
                "text": "Si por causa del día de reposo apartas tu pie para no hacer lo que te plazca en mi día santo, y llamas al día de reposo delicia, al día santo del Señor, honorable, y lo honras, no siguiendo tus caminos, ni buscando tu placer, ni hablando de tus propios asuntos, entonces te deleitarás en el Señor, y yo te haré cabalgar sobre las alturas de la tierra, y te alimentaré con la heredad de tu padre Jacob; porque la boca del Señor ha hablado."
            },
            {
                "ref": "Amós 8:4–6",
                "text": "Oíd esto, los que pisoteáis a los menesterosos, y queréis exterminar a los pobres de la tierra, diciendo: ¿Cuándo pasará la luna nueva para vender el grano, y el día de reposo para abrir el mercado de trigo, achicar el efa, aumentar el siclo y engañar con balanzas falsas; para comprar por dinero a los desvalidos y a los pobres por un par de sandalias, y vender los desechos del trigo?"
            }
        ]
    },
    {
        number: 62,
        question: '¿Cuáles son las razones determinantes del cuarto mandamiento?',
        answer: 'Las razones determinantes del cuarto mandamiento, son: el habernos concedido Dios seis días de la semana para nuestras propias ocupaciones, el haberse reservado para sí mismo una propiedad especial sobre el séptimo, el haber bendecido el día de descanso, y finalmente su propio ejemplo.',
        proofs: [
            {
                "ref": "Éxodo 20:9",
                "text": "Seis días trabajarás y harás toda tu obra,"
            },
            {
                "ref": "Éxodo 31:15",
                "text": "Durante seis días se trabajará, pero el séptimo día será día de completo reposo, santo al Señor. Cualquiera que haga obra alguna en el día de reposo morirá irremisiblemente."
            },
            {
                "ref": "Levítico 23:3",
                "text": "Seis días se trabajará, pero el séptimo día será día de completo reposo, santa convocación en que no haréis trabajo alguno; es día de reposo al Señor dondequiera que habitéis."
            },
            {
                "ref": "Genesis 2:2–3",
                "text": "Y en el séptimo día completó Dios la obra que había hecho, y reposó en el día séptimo de toda la obra que había hecho. Y bendijo Dios el séptimo día y lo santificó, porque en él reposó de toda la obra que Él había creado y hecho."
            },
            {
                "ref": "Éxodo 20:11",
                "text": "Porque en seis días hizo el Señor los cielos y la tierra, el mar y todo lo que en ellos hay, y reposó en el séptimo día; por tanto, el Señor bendijo el día de reposo y lo santificó."
            },
            {
                "ref": "Éxodo 31:17",
                "text": "Es una señal entre yo y los hijos de Israel para siempre; pues en seis días el Señor hizo los cielos y la tierra, y en el séptimo día cesó de trabajar y reposó."
            }
        ]
    },
    {
        number: 63,
        question: '¿Cuál es el quinto mandamiento?',
        answer: 'El quinto mandamiento, es: "Honra a tu padre y a tu madre, para que tus días se alarguen en la tierra que Jehová tu Dios te da".',
        proofs: [
            {
                "ref": "Éxodo 20:12",
                "text": "Honra a tu padre y a tu madre, para que tus días sean prolongados en la tierra que el Señor tu Dios te da."
            },
            {
                "ref": "Deuteronomio 5:16",
                "text": "»Honra a tu padre y a tu madre, como el Señor tu Dios te ha mandado, para que tus días sean prolongados y te vaya bien en la tierra que el Señor tu Dios te da."
            }
        ]
    },
    {
        number: 64,
        question: '¿Qué se exige en el quinto mandamiento?',
        answer: 'El quinto mandamiento exige que rindamos el debido honor y cumplamos con nuestras obligaciones para con toda persona en su respectivo puesto o relación como superior, inferior o igual.',
        proofs: [
            {
                "ref": "Romanos 13:1",
                "text": "Sométase toda persona a las autoridades que gobiernan; porque no hay autoridad sino de Dios, y las que existen, por Dios son constituidas."
            },
            {
                "ref": "Romanos 13:7",
                "text": "Pagad a todos lo que debáis: al que impuesto, impuesto; al que tributo, tributo; al que temor, temor; al que honor, honor."
            },
            {
                "ref": "Efesios 5:21–22",
                "text": "sometiéndoos unos a otros en el temor de Cristo. Las mujeres estén sometidas a sus propios maridos como al Señor."
            },
            {
                "ref": "Efesios 5:24",
                "text": "Pero así como la iglesia está sujeta a Cristo, también las mujeres deben estarlo a sus maridos en todo."
            },
            {
                "ref": "Efesios 6:1",
                "text": "Hijos, obedeced a vuestros padres en el Señor, porque esto es justo."
            },
            {
                "ref": "Efesios 6:4-5",
                "text": "Y vosotros, padres, no provoquéis a ira a vuestros hijos, sino criadlos en la disciplina e instrucción del Señor. Siervos, obedeced a vuestros amos en la tierra, con temor y temblor, con la sinceridad de vuestro corazón, como a Cristo;"
            },
            {
                "ref": "Efesios 6:9",
                "text": "Y vosotros, amos, haced lo mismo con ellos, y dejad las amenazas, sabiendo que el Señor de ellos y de vosotros está en los cielos, y que para Él no hay acepción de personas."
            },
            {
                "ref": "1 Pedro 2:17",
                "text": "Honrad a todos, amad a los hermanos, temed a Dios, honrad al rey."
            }
        ]
    },
    {
        number: 65,
        question: '¿Qué se prohíbe en el quinto mandamiento?',
        answer: 'El quinto mandamiento prohíbe que descuidemos o rebajemos el honor o el servicio que corresponde a cada uno en el puesto o relación que ocupa.',
        proofs: [
            {
                "ref": "Mateo 15:4–6",
                "text": "Porque Dios dijo: «Honra a tu padre y a tu madre», y: «Quien hable mal de su padre o de su madre, que muera». Pero vosotros decís: «Cualquiera que diga a su padre o a su madre: “Es ofrenda a Dios todo lo mío con que pudieras ser ayudado”, no necesitará más honrar a su padre o a su madre». Y así invalidasteis la palabra de Dios por causa de vuestra tradición."
            }
        ]

    },
    {
        number: 66,
        question: '¿Cuál es la razón determinante del quinto mandamiento?',
        answer: 'La razón determinante del quinto mandamiento es la promesa de larga vida y de prosperidad, (en cuanto sirve al bien humano y a la gloria de Dios), hecha a todos los que guarden este mandamiento.',
        proofs: [
            {
                "ref": "Éxodo 20:12",
                "text": "Honra a tu padre y a tu madre, para que tus días sean prolongados en la tierra que el Señor tu Dios te da."
            },
            {
                "ref": "Deuteronomio 5:16",
                "text": "»Honra a tu padre y a tu madre, como el Señor tu Dios te ha mandado, para que tus días sean prolongados y te vaya bien en la tierra que el Señor tu Dios te da."
            },
            {
                "ref": "Efesios 6:2–3",
                "text": "Honra a tu padre y a tu madre (que es el primer mandamiento con promesa), para que te vaya bien, y para que tengas larga vida sobre la tierra."
            }
        ]
    },
    {
        number: 67,
        question: '¿Cuál es el sexto mandamiento?',
        answer: 'El sexto mandamiento es: "No matarás".',
        proofs: [
            {
                "ref": "Éxodo 20:13",
                "text": "No matarás."
            },
            {
                "ref": "Deuteronomio 5:17",
                "text": "»No matarás."
            }
        ]
    },
    {
        number: 68,
        question: '¿Qué se exige en el sexto mandamiento?',
        answer: 'El sexto mandamiento exige que hagamos todos los esfuerzos legítimos para preservar nuestra vida y la de otros.',
        proofs: [
            {
                "ref": "Efesios 5:28–29",
                "text": "Así también deben amar los maridos a sus mujeres, como a sus propios cuerpos. El que ama a su mujer, a sí mismo se ama. Porque nadie aborreció jamás su propio cuerpo, sino que lo sustenta y lo cuida, así como también Cristo a la iglesia;"
            },
            {
                "ref": "1 Reyes 18:4",
                "text": "pues sucedió que cuando Jezabel destruyó a los profetas del Señor, Abdías tomó a cien profetas y los escondió de cincuenta en cincuenta en una cueva, y los sustentó con pan y agua.)"
            }
        ]
    },
    {
        number: 69,
        question: '¿Qué se prohíbe en el sexto mandamiento?',
        answer: 'El sexto mandamiento prohíbe el destruir nuestra propia vida o el quitar injustamente la de nuestro prójimo, así como también todo lo que tiende a este resultado.',
        proofs: [
            {
                "ref": "Genesis 9:6",
                "text": "El que derrame sangre de hombre, por el hombre su sangre será derramada, porque a imagen de Dios hizo Él al hombre."
            },
            {
                "ref": "Mateo 5:22",
                "text": "Pero yo os digo que todo aquel que esté enojado con su hermano será culpable ante la corte; y cualquiera que diga: «Raca» a su hermano, será culpable delante de la corte suprema; y cualquiera que diga: «Idiota», será reo del infierno de fuego."
            },
            {
                "ref": "1 Juan 3:15",
                "text": "Todo el que aborrece a su hermano es homicida, y vosotros sabéis que ningún homicida tiene vida eterna permanente en él."
            }
        ]
    },
    {
        number: 70,
        question: '¿Cuál es el séptimo mandamiento?',
        answer: 'El séptimo mandamiento, es: "No cometerás adulterio".',
        proofs: [
            {
                "ref": "Éxodo 20:14",
                "text": "No cometerás adulterio."
            },
            {
                "ref": "Deuteronomio 5:18",
                "text": "»No cometerás adulterio."
            }
        ]
    },
    {
        number: 71,
        question: '¿Qué se exige en el séptimo mandamiento?',
        answer: 'El séptimo mandamiento exige que preservemos nuestra propia castidad y la de nuestro prójimo, en corazón, palabra y comportamiento.',
        proofs: [
            {
                "ref": "1 Corintios 7:2–3",
                "text": "No obstante, por razón de las inmoralidades, que cada uno tenga su propia mujer, y cada una tenga su propio marido. Que el marido cumpla su deber para con su mujer, e igualmente la mujer lo cumpla con el marido."
            },
            {
                "ref": "1 Corintios 7:5",
                "text": "No os privéis el uno del otro, excepto de común acuerdo y por cierto tiempo, para dedicaros a la oración; volved después a juntaros a fin de que Satanás no os tiente por causa de vuestra falta de dominio propio."
            },
            {
                "ref": "1 Tesalonicenses 4:3–5",
                "text": "Porque esta es la voluntad de Dios: vuestra santificación; es decir, que os abstengáis de inmoralidad sexual; que cada uno de vosotros sepa cómo poseer su propio vaso en santificación y honor, no en pasión de concupiscencia, como los gentiles que no conocen a Dios;"
            }
        ]
    },
    {
        number: 72,
        question: '¿Que se prohíbe en el séptimo mandamiento?',
        answer: 'El séptimo mandamiento prohíbe todo pensamiento, palabra o acción impura.',
        proofs: [
            {
                "ref": "Mateo 5:28",
                "text": "Pero yo os digo que todo el que mire a una mujer para codiciarla ya cometió adulterio con ella en su corazón."
            },
            {
                "ref": "Efesios 5:3,4",
                "text": "Pero que la inmoralidad, y toda impureza o avaricia, ni siquiera se mencionen entre vosotros, como corresponde a los santos; ni obscenidades, ni necedades, ni groserías, que no son apropiadas, sino más bien acciones de gracias."
            }
        ]
    },
    {
        number: 73,
        question: '¿Cuál es el octavo mandamiento?',
        answer: 'El octavo mandamiento, es: "No hurtarás".',
        proofs: [
            {
                "ref": "Éxodo 20:15",
                "text": "No hurtarás."
            },
            {
                "ref": "Deuteronomio 5:19",
                "text": "»No hurtarás."
            }
        ]
    },
    {
        number: 74,
        question: '¿Qué se exige en el octavo mandamiento?',
        answer: 'El octavo mandamiento exige que procuremos y promovamos por todo medio legítimo la prosperidad y bienestar de nosotros mismos y de los demás.',
        proofs: [
            {
                "ref": "Levítico 25:35",
                "text": "»En caso de que un hermano tuyo empobrezca y sus medios para contigo decaigan, tú lo sustentarás como a un forastero o peregrino, para que viva contigo."
            },
            {
                "ref": "Efesios 4:28b",
                "text": "El que roba, no robe más, sino más bien que trabaje, haciendo con sus manos lo que es bueno, a fin de que tenga qué compartir con el que tiene necesidad."
            },
            {
                "ref": "Filipenses 2:4",
                "text": "no buscando cada uno sus propios intereses, sino más bien los intereses de los demás."
            }
        ]
    },
    {
        number: 75,
        question: '¿Qué se prohíbe en el octavo mandamiento?',
        answer: 'El octavo mandamiento  prohíbe todo lo que impide o tiende a impedir  injustamente la prosperidad  y bienestar nuestro o de nuestro prójimo.',
        proofs: [
            {
                "ref": "Proverbios 28:19f",
                "text": "Él que labra su tierra se saciará de pan, pero el que sigue propósitos vanos se llenará de pobreza."
            },
            {
                "ref": "Efesios 4:28a",
                "text": "El que roba, no robe más, sino más bien que trabaje, haciendo con sus manos lo que es bueno, a fin de que tenga qué compartir con el que tiene necesidad."
            },
            {
                "ref": "2 Tesalonicenses 3:10",
                "text": "Porque aun cuando estábamos con vosotros os ordenábamos esto: Si alguno no quiere trabajar, que tampoco coma."
            },
            {
                "ref": "1 Timoteo 5:8",
                "text": "Pero si alguno no provee para los suyos, y especialmente para los de su casa, ha negado la fe y es peor que un incrédulo."
            }
        ]
    },
    {
        number: 76,
        question: '¿Cuál es el noveno mandamiento?',
        answer: 'El noveno mandamiento, es: "No darás falso testimonio contra tu prójimo.',
        proofs: [
            {
                "ref": "Exodo 20:16",
                "text": "No darás falso testimonio contra tu prójimo."
            },
            {
                "ref": "Deuteronomio 5:20",
                "text": "»No darás falso testimonio contra tu prójimo."
            }
        ]
    },
    {
        number: 77,
        question: '¿Qué se exige en el noveno mandamiento?',
        answer: 'El noveno mandamiento exige que sostengamos y promovamos la verdad entre hombre y hombre como también nuestra buena fama y la de nuestro prójimo, especialmente en dar testimonio.',
        proofs: [
            {
                "ref": "Zacarias 8:16",
                "text": "Estas son las cosas que debéis hacer: decid la verdad unos a otros, juzgad con verdad y con juicio de paz en vuestras puertas,"
            },
            {
                "ref": "Hechos 25:10",
                "text": "Entonces Pablo respondió: Ante el tribunal del César estoy, que es donde debo ser juzgado. Ningún agravio he hecho a los judíos, como también tú muy bien sabes."
            },
            {
                "ref": "3 Juan 12",
                "text": "Demetrio tiene buen testimonio de parte de todos y de parte de la verdad misma; también nosotros damos testimonio y tú sabes que nuestro testimonio es verdadero."
            },
            {
                "ref": "Proverbios 14:5",
                "text": "El testigo veraz no mentirá, pero el testigo falso habla mentiras."
            },
            {
                "ref": "Proverbios 14:25",
                "text": "El testigo veraz salva vidas, pero el que habla mentiras es traidor."
            }
        ]
    },
    {
        number: 78,
        question: '¿Qué se prohíbe en el noveno mandamiento?',
        answer: 'El noveno mandamiento prohíbe todo lo que perjudica a la verdad, o que daña a nuestro buen nombre o al de nuestro prójimo.',
        proofs: [
            {
                "ref": "Levítico 19:16",
                "text": "No andarás de calumniador entre tu pueblo; no harás nada contra la vida de tu prójimo; yo soy el Señor."
            },
            {
                "ref": "Salmo 15:3",
                "text": "El que no calumnia con su lengua, no hace mal a su prójimo, ni toma reproche contra su amigo;"
            },
            {
                "ref": "Proverbios 6:16–19",
                "text": "Seis cosas hay que odia el Señor, y siete son abominación para Él: ojos soberbios, lengua mentirosa, manos que derraman sangre inocente, un corazón que maquina planes perversos, pies que corren rápidamente hacia el mal, un testigo falso que dice mentiras, y el que siembra discordia entre hermanos."
            },
            {
                "ref": "Lucas 3:14",
                "text": "También algunos soldados le preguntaban, diciendo: Y nosotros, ¿qué haremos? Y él les dijo: A nadie extorsionéis, ni a nadie acuséis falsamente, y contentaos con vuestro salario."
            }
        ]
    },
    {
        number: 79,
        question: '¿Cuál es el décimo mandamiento?',
        answer: 'El décimo mandamiento, es: "No codiciarás la casa de tu prójimo, no codiciarás la mujer de tu prójimo, ni su siervo, ni su criada, ni su buey, ni su asno, ni cosa alguna de tu prójimo".',
        proofs: [
            {
                "ref": "Éxodo 20:17",
                "text": "No codiciarás la casa de tu prójimo; no codiciarás la mujer de tu prójimo, ni su siervo, ni su sierva, ni su buey, ni su asno, ni nada que sea de tu prójimo."
            },
            {
                "ref": "Deuteronomio 5:21",
                "text": "»No codiciarás la mujer de tu prójimo, y no desearás la casa de tu prójimo, ni su campo, ni su siervo, ni su sierva, ni su buey, ni su asno, ni nada que sea de tu prójimo»."
            }
        ]
    },
    {
        number: 80,
        question: '¿Qué se exige en el décimo mandamiento?',
        answer: 'El décimo mandamiento exige que nos contentemos con nuestra propia condición, y que tengamos siempre una justa caritativa disposición de ánimo respecto de nuestro prójimo y de todo lo que es suyo.',
        proofs: [
            {
                "ref": "Éxodo 20:17",
                "text": "No codiciarás la casa de tu prójimo; no codiciarás la mujer de tu prójimo, ni su siervo, ni su sierva, ni su buey, ni su asno, ni nada que sea de tu prójimo."
            },
            {
                "ref": "Deuteronomio 5:21",
                "text": "»No codiciarás la mujer de tu prójimo, y no desearás la casa de tu prójimo, ni su campo, ni su siervo, ni su sierva, ni su buey, ni su asno, ni nada que sea de tu prójimo»."
            }
        ]
    },
    {
        number: 81,
        question: '¿Qué se prohíbe en el décimo mandamiento?',
        answer: 'El décimo mandamiento prohíbe todo descontento de nuestra propia condición, la envidia, o pesar del  bien de nuestro prójimo, y todo deseo o aflicción desordenada hacia las cosas que son suyas.',
        proofs: [
            {
                "ref": "1 Corintios 10:10",
                "text": "Ni murmuréis, como algunos de ellos murmuraron, y fueron destruidos por el destructor."
            },
            {
                "ref": "Santiago 3:14–16",
                "text": "Pero si tenéis celos amargos y ambición personal en vuestro corazón, no seáis arrogantes y así mintáis contra la verdad. Esta sabiduría no es la que viene de lo alto, sino que es terrenal, natural, diabólica. Porque donde hay celos y ambición personal, allí hay confusión y toda cosa mala."
            },
            {
                "ref": "Galatas 5:26",
                "text": "No nos hagamos vanagloriosos, provocándonos unos a otros, envidiándonos unos a otros."
            },
            {
                "ref": "Colosenses 3:5",
                "text": "Por tanto, considerad los miembros de vuestro cuerpo terrenal como muertos a la fornicación, la impureza, las pasiones, los malos deseos y la avaricia, que es idolatría."
            }
        ]
    },
    {
        number: 82,
        question: '¿Puede algún hombre guardar perfectamente los mandamientos de Dios?',
        answer: 'Ningún mero hombre, desde la caída, puede en esta vida guardar perfectamente los mandamientos de Dios, mas diariamente los quebranta en pensamiento, en palabra y en hecho.',
        proofs: [
            {
                "ref": "Genesis 8:21",
                "text": "Y el Señor percibió el aroma agradable, y dijo el Señor para sí: Nunca más volveré a maldecir la tierra por causa del hombre, porque la intención del corazón del hombre es mala desde su juventud; nunca más volveré a destruir todo ser viviente como lo he hecho."
            },
            {
                "ref": "Romanos 3:9",
                "text": "¿Entonces qué? ¿Somos nosotros mejores que ellos? De ninguna manera; porque ya hemos denunciado que tanto judíos como griegos están todos bajo pecado;"
            },
            {
                "ref": "Romanos 3:23",
                "text": "por cuanto todos pecaron y no alcanzan la gloria de Dios,"
            }
        ]
    },
    {
        number: 83,
        question: '¿Son igualmente detestables todas las transgresiones de la ley?',
        answer: 'Algunas transgresiones en sí, y por razón de circunstancias agravantes son más detestables que otras a la vista de Dios.',
        proofs: [
            {
                "ref": "Ezekiel 8:6",
                "text": "Entonces me dijo: Hijo de hombre, ¿ves lo que hacen estos, las grandes abominaciones que comete aquí la casa de Israel para que me aleje de mi santuario? Pero aún verás mayores abominaciones."
            },
            {
                "ref": "Ezekiel 8:13",
                "text": "Y me dijo: Aún verás que cometen mayores abominaciones."
            },
            {
                "ref": "Ezekiel 8:15",
                "text": "Y me dijo: ¿Has visto, hijo de hombre? Aún verás mayores abominaciones que estas."
            },
            {
                "ref": "Mateo 11:20–24",
                "text": "Entonces comenzó a increpar a las ciudades en las que había hecho la mayoría de sus milagros, porque no se habían arrepentido. ¡Ay de ti, Corazín! ¡Ay de ti, Betsaida! Porque si los milagros que se hicieron en vosotras se hubieran hecho en Tiro y en Sidón, hace tiempo que se hubieran arrepentido en cilicio y ceniza. Por eso os digo que en el día del juicio será más tolerable el castigo para Tiro y Sidón que para vosotras. Y tú, Capernaúm, ¿acaso serás elevada hasta los cielos? ¡Hasta el Hades descenderás! Porque si los milagros que se hicieron en ti se hubieran hecho en Sodoma, esta hubiera permanecido hasta hoy. Sin embargo, os digo que en el día del juicio será más tolerable el castigo para la tierra de Sodoma que para ti."
            },
            {
                "ref": "Juan 19:11",
                "text": "Jesús respondió: Ninguna autoridad tendrías sobre mí si no se te hubiera dado de arriba; por eso el que me entregó a ti tiene mayor pecado."
            }
        ]
    },
    {
        number: 84,
        question: '¿Qué es lo que todo pecado merece?',
        answer: 'Todo pecado merece la ira y maldición de Dios, tanto en esta vida como en la venidera.',
        proofs: [
            {
                "ref": "Mateo 25:41",
                "text": "Entonces dirá también a los de su izquierda: «Apartaos de mí, malditos, al fuego eterno que ha sido preparado para el diablo y sus ángeles."
            },
            {
                "ref": "Galatas 3:10",
                "text": "Porque todos los que son de las obras de la ley están bajo maldición, pues escrito está: Maldito todo el que no permanece en todas las cosas escritas en el libro de la ley, para hacerlas."
            },
            {
                "ref": "Efesios 5:6",
                "text": "Que nadie os engañe con palabras vanas, pues por causa de estas cosas la ira de Dios viene sobre los hijos de desobediencia."
            },
            {
                "ref": "Santiago 2:10",
                "text": "Porque cualquiera que guarda toda la ley, pero tropieza en un punto, se ha hecho culpable de todos."
            }
        ]
    },
    {
        number: 85,
        question: '¿Qué nos exige Dios para que escapemos de la ira y maldición que hemos merecido por el pecado?',
        answer: 'Para que escapemos de la ira y maldición de Dios que hemos merecido por razón del pecado, Dios exige de nosotros la fe en Jesucristo, el arrepentimiento para vida, y el empleo diligente de todos los medios externos, por los cuales Cristo nos comunica los beneficios de redención.',
        proofs: [
            {
                "ref": "Hechos 2:38",
                "text": "Y Pedro les dijo: Arrepentíos y sed bautizados cada uno de vosotros en el nombre de Jesucristo para perdón de vuestros pecados, y recibiréis el don del Espíritu Santo."
            },
            {
                "ref": "1 Corintios 11:24–25",
                "text": "y después de dar gracias, lo partió y dijo: Esto es mi cuerpo que es para vosotros; haced esto en memoria de mí. De la misma manera tomó también la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre; haced esto cuantas veces la bebáis en memoria de mí."
            },
            {
                "ref": "Colosenses 3:16",
                "text": "Que la palabra de Cristo habite en abundancia en vosotros, con toda sabiduría enseñándoos y amonestándoos unos a otros con salmos, himnos y canciones espirituales, cantando a Dios con acción de gracias en vuestros corazones."
            }
        ]
    },
    {
        number: 86,
        question: '¿Qué es la fe en Jesucristo?',
        answer: 'La fe en Jesucristo es una gracia salvadora por la cual recibimos a Cristo como nos es ofrecido en el Evangelio, y confiamos solamente en él para la salvación.',
        proofs: [
            {
                "ref": "Efesios 2:8–9",
                "text": "Porque por gracia habéis sido salvados por medio de la fe, y esto no de vosotros, sino que es don de Dios; no por obras, para que nadie se gloríe."
            },
            {
                "ref": "Romanos 4:16",
                "text": "Por eso es por fe, para que esté de acuerdo con la gracia, a fin de que la promesa sea firme para toda la posteridad, no solo a los que son de la ley, sino también a los que son de la fe de Abraham, el cual es padre de todos nosotros"
            },
            {
                "ref": "Juan 20:30–31",
                "text": "Y muchas otras señales hizo también Jesús en presencia de sus discípulos, que no están escritas en este libro; pero estas se han escrito para que creáis que Jesús es el Cristo, el Hijo de Dios; y para que al creer, tengáis vida en su nombre."
            },
            {
                "ref": "Galatas 2:15–16",
                "text": "Nosotros somos judíos de nacimiento y no pecadores de entre los gentiles; sin embargo, sabiendo que el hombre no es justificado por las obras de la ley, sino mediante la fe en Cristo Jesús, también nosotros hemos creído en Cristo Jesús, para que seamos justificados por la fe en Cristo, y no por las obras de la ley; puesto que por las obras de la ley nadie será justificado."
            },
            {
                "ref": "Filipenses 3:3–11",
                "text": "porque nosotros somos la verdadera circuncisión, que adoramos en el Espíritu de Dios y nos gloriamos en Cristo Jesús, no poniendo la confianza en la carne, aunque yo mismo podría confiar también en la carne. Si algún otro cree tener motivo para confiar en la carne, yo mucho más: circuncidado el octavo día, del linaje de Israel, de la tribu de Benjamín, hebreo de hebreos; en cuanto a la ley, fariseo; en cuanto al celo, perseguidor de la iglesia; en cuanto a la justicia de la ley, hallado irreprensible. Pero todo lo que para mí era ganancia, lo he estimado como pérdida por amor de Cristo. Y aún más, yo estimo como pérdida todas las cosas en vista del incomparable valor de conocer a Cristo Jesús, mi Señor, por quien lo he perdido todo, y lo considero como basura a fin de ganar a Cristo, y ser hallado en Él, no teniendo mi propia justicia derivada de la ley, sino la que es por la fe en Cristo, la justicia que procede de Dios sobre la base de la fe, y conocerle a Él, el poder de su resurrección y la participación en sus padecimientos, llegando a ser como Él en su muerte, a fin de llegar a la resurrección de entre los muertos."
            }
        ]
    },
    {
        number: 87,
        question: '¿Qué es el arrepentimiento para vida?',
        answer: 'El arrepentimiento para vida es una gracia salvadora por la cual el pecador teniendo un verdadero  sentimiento de sus pecados, y conociendo la misericordia de Dios en Cristo, con dolor y odio de sus pecados se convierten de ellos a Dios, con plena determinación de alcanzar una nueva obediencia.',
        proofs: [
            {
                "ref": "Hechos 11:18",
                "text": "Y al oír esto se calmaron, y glorificaron a Dios, diciendo: Así que también a los gentiles ha concedido Dios el arrepentimiento que conduce a la vida."
            },
            {
                "ref": "2 Timoteo 2:25",
                "text": "corrigiendo tiernamente a los que se oponen, por si acaso Dios les da el arrepentimiento que conduce al pleno conocimiento de la verdad,"
            },
            {
                "ref": "Salmos 51:1–4",
                "text": "Ten piedad de mí, oh Dios, conforme a tu misericordia; conforme a lo inmenso de tu compasión, borra mis transgresiones. Lávame por completo de mi maldad, y límpiame de mi pecado. Porque yo reconozco mis transgresiones, y mi pecado está siempre delante de mí. Contra ti, contra ti solo he pecado, y he hecho lo malo delante de tus ojos, de manera que eres justo cuando hablas, y sin reproche cuando juzgas."
            },
            {
                "ref": "Joel 2:13",
                "text": "Rasgad vuestro corazón y no vuestros vestidos; volved ahora al Señor vuestro Dios, porque Él es compasivo y clemente, lento para la ira, abundante en misericordia, y se arrepiente de infligir el mal."
            },
            {
                "ref": "Lucas 15:7",
                "text": "Os digo que de la misma manera, habrá más gozo en el cielo por un pecador que se arrepiente que por noventa y nueve justos que no necesitan arrepentimiento."
            },
            {
                "ref": "Lucas 15:10",
                "text": "De la misma manera, os digo, hay gozo en la presencia de los ángeles de Dios por un pecador que se arrepiente."
            },
            {
                "ref": "Hechos 2:37",
                "text": "Al oír esto, compungidos de corazón, dijeron a Pedro y a los demás apóstoles: Hermanos, ¿qué haremos?"
            },
            {
                "ref": "Jeremias 31:18–19",
                "text": "Ciertamente he oído a Efraín lamentarse: «Me has castigado, y castigado fui como becerro indómito. Hazme volver para que sea restaurado, pues tú, Señor, eres mi Dios. Porque después que me aparté, me arrepentí, y después que comprendí, me di golpes en el muslo; me avergoncé y también me humillé, porque llevaba el oprobio de mi juventud»."
            },
            {
                "ref": "Lucas 1:16–17",
                "text": "Y él hará volver a muchos de los hijos de Israel al Señor su Dios. E irá delante de Él en el espíritu y poder de Elías para hacer volver los corazones de los padres a los hijos, y a los desobedientes a la actitud de los justos, a fin de preparar para el Señor un pueblo bien dispuesto."
            },
            {
                "ref": "1 Tesalonicenses 1:9",
                "text": "Pues ellos mismos cuentan acerca de nosotros, de la acogida que tuvimos por parte de vosotros, y de cómo os convertisteis de los ídolos a Dios para servir al Dios vivo y verdadero,"
            },
            {
                "ref": "2 Cronicas 7:14",
                "text": "y se humilla mi pueblo sobre el cual es invocado mi nombre, y oran, buscan mi rostro y se vuelven de sus malos caminos, entonces yo oiré desde los cielos, perdonaré su pecado y sanaré su tierra."
            },
            {
                "ref": "Salmos 119:57–64",
                "text": "El Señor es mi porción; he prometido guardar tus palabras. Supliqué tu favor con todo mi corazón; ten piedad de mí conforme a tu promesa. Consideré mis caminos, y volví mis pasos a tus testimonios. Me apresuré y no me tardé en guardar tus mandamientos. Los lazos de los impíos me han rodeado, mas no me he olvidado de tu ley. A medianoche me levantaré para darte gracias por tus justas ordenanzas. Compañero soy de todos los que te temen, y de los que guardan tus preceptos. La tierra, oh Señor, está llena de tu misericordia; enséñame tus estatutos."
            },
            {
                "ref": "Mateo 3:8",
                "text": "Por tanto, dad frutos dignos de arrepentimiento;"
            },
            {
                "ref": "2 Corintios 7:10",
                "text": "Porque la tristeza que es conforme a la voluntad de Dios produce un arrepentimiento que conduce a la salvación, sin dejar pesar; pero la tristeza del mundo produce muerte."
            }
        ]
    },
    {
        number: 88,
        question: '¿Cuáles son los medios externos y ordinarios por los cuales Cristo nos comunica los beneficios de la redención?',
        answer: 'Los medios externos y ordinarios por los cuales Cristo nos comunica los beneficios de la redención, son sus ordenanzas, y especialmente, la palabra, los sacramentos y la oración, a todos los cuales hace él eficaces para la salvación de los elegidos.',
        proofs: [
            {
                "ref": "Mateo 28:18–20",
                "text": "Y acercándose Jesús, les habló, diciendo: Toda autoridad me ha sido dada en el cielo y en la tierra. Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo, enseñándoles a guardar todo lo que os he mandado; y he aquí, yo estoy con vosotros todos los días, hasta el fin del mundo."
            },
            {
                "ref": "Hechos 2:41–42",
                "text": "Entonces los que habían recibido su palabra fueron bautizados; y se añadieron aquel día como tres mil almas. Y se dedicaban continuamente a las enseñanzas de los apóstoles, a la comunión, al partimiento del pan y a la oración."
            }
        ]
    },
    {
        number: 89,
        question: '¿Cómo viene la palabra a ser eficaz para la salvación?',
        answer: 'El Espíritu de Dios hace que la lectura, y aún más especialmente la predicación de la palabra, sean medios eficaces de convencer y de convertir a los pecadores, y de edificarles en santidad y consuelo por la  fe, hasta la salvación.',
        proofs: [
            {
                "ref": "Nehemías 8:8–9",
                "text": "Y leyeron en el libro de la ley de Dios, traduciéndolo y dándole el sentido para que entendieran la lectura. Entonces Nehemías, que era el gobernador, y Esdras, el sacerdote y escriba, y los levitas que enseñaban al pueblo, dijeron a todo el pueblo: Este día es santo para el Señor vuestro Dios; no os entristezcáis, ni lloréis; porque todo el pueblo lloraba al oír las palabras de la ley."
            },
            {
                "ref": "Hechos 20:32",
                "text": "Ahora os encomiendo a Dios y a la palabra de su gracia, que es poderosa para edificaros y daros la herencia entre todos los santificados."
            },
            {
                "ref": "Romanos 10:14–17",
                "text": "¿Cómo, pues, invocarán a aquel en quien no han creído? ¿Y cómo creerán en aquel de quien no han oído? ¿Y cómo oirán sin haber quien les predique? ¿Y cómo predicarán si no son enviados? Tal como está escrito: ¡Cuan hermosos son los pies de los que anuncian el evangelio del bien! Sin embargo, no todos hicieron caso al evangelio, porque Isaías dice: Señor, ¿quién ha creído a nuestro anuncio? Así que la fe viene del oír, y el oír, por la palabra de Cristo."
            },
            {
                "ref": "2 Timoteo 3:15–17",
                "text": "y que desde la niñez has sabido las Sagradas Escrituras, las cuales te pueden dar la sabiduría que lleva a la salvación mediante la fe en Cristo Jesús. Toda Escritura es inspirada por Dios y útil para enseñar, para reprender, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, equipado para toda buena obra."
            }
        ]
    },
    {
        number: 90,
        question: '¿Cómo ha de ser leída y escuchada la palabra para que se haga eficaz para la salvación?',
        answer: 'A fin de que la palabra se haga eficaz para nuestra salvación, hemos de prestarle atención con diligencia, preparación de espíritu y  oración, hemos de recibirla con fe y amor, atesorarla en el corazón y practicarla en la vida.',
        proofs: [
            {
                "ref": "Deuteronomio 6:16",
                "text": "No tentaréis al Señor vuestro Dios, como le tentasteis en Masah."
            },
            {
                "ref": "Salmos 119:18",
                "text": "Abre mis ojos, para que vea las maravillas de tu ley."
            },
            {
                "ref": "1 Pedro 2:1–2",
                "text": "Por tanto, desechando toda malicia y todo engaño, e hipocresías, envidias y toda difamación, desead como niños recién nacidos, la leche pura de la palabra, para que por ella crezcáis para salvación,"
            },
            {
                "ref": "Salmos 119:11",
                "text": "En mi corazón he atesorado tu palabra, para no pecar contra ti."
            },
            {
                "ref": "2 Tesalonicenses 2:10",
                "text": "y con todo engaño de iniquidad para los que se pierden, porque no recibieron el amor de la verdad para ser salvos."
            },
            {
                "ref": "Hebreos 4:2",
                "text": "Porque en verdad, a nosotros se nos ha anunciado la buena nueva, como también a ellos; pero la palabra que ellos oyeron no les aprovechó por no ir acompañada por la fe en los que la oyeron."
            },
            {
                "ref": "Santiago 1:22–25",
                "text": "Sed hacedores de la palabra y no solamente oidores que se engañan a sí mismos. Porque si alguno es oidor de la palabra, y no hacedor, es semejante a un hombre que mira su rostro natural en un espejo; pues después de mirarse a sí mismo e irse, inmediatamente se olvida de qué clase de persona es. Pero el que mira atentamente a la ley perfecta, la ley de la libertad, y permanece en ella, no habiéndose vuelto un oidor olvidadizo sino un hacedor eficaz, este será bienaventurado en lo que hace."
            }
        ]
    },
    {
        number: 91,
        question: '¿Cómo se hacen los sacramentos medios eficaces de salvación?',
        answer: 'Los sacramentos vienen a ser medios eficaces de salvación, no porque haya alguna virtud en ellos, o en aquel que los administra, sino solamente por la bendición de Cristo, y la operación de su Espíritu en aquellos que los reciben con fe.',
        proofs: [
            {
                "ref": "1 Corintios 3:7",
                "text": "Así que ni el que planta ni el que riega es algo, sino Dios, que da el crecimiento."
            },
            {
                "ref": "1 Corintios 1:12–17",
                "text": "Me refiero a que cada uno de vosotros dice: Yo soy de Pablo, yo de Apolos, yo de Cefas, yo de Cristo. ¿Está dividido Cristo? ¿Acaso fue Pablo crucificado por vosotros? ¿O fuisteis bautizados en el nombre de Pablo? Doy gracias a Dios que no bauticé a ninguno de vosotros, excepto a Crispo y a Gayo, para que nadie diga que fuisteis bautizados en mi nombre. También bauticé a los de la casa de Estéfanas; por lo demás, no sé si bauticé a algún otro. Pues Cristo no me envió a bautizar, sino a predicar el evangelio, no con palabras elocuentes, para que no se haga vana la cruz de Cristo."
            }
        ]
    },
    {
        number: 92,
        question: '¿Qué es un sacramento?',
        answer: 'Un sacramento es una práctica sagrada instituida por Cristo, la cual, por medio de signos sensibles, representa a Cristo y a los beneficios de la nueva alianza, y los confirma y aplica a los creyentes.',
        proofs: [
            {
                "ref": "Mateo 28:19",
                "text": "Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo,"
            },
            {
                "ref": "Mateo 26:26–28",
                "text": "Mientras comían, Jesús tomó pan, y habiéndolo bendecido, lo partió, y dándoselo a los discípulos, dijo: Tomad, comed; esto es mi cuerpo. Y tomando una copa, y habiendo dado gracias, se la dio, diciendo: Bebed todos de ella; porque esto es mi sangre del nuevo pacto, que es derramada por muchos para el perdón de los pecados."
            },
            {
                "ref": "Marcos 14:22–25",
                "text": "Y mientras comían, tomó pan, y habiéndolo bendecido lo partió, se lo dio a ellos, y dijo: Tomad, esto es mi cuerpo. Y tomando una copa, después de dar gracias, se la dio a ellos, y todos bebieron de ella. Y les dijo: Esto es mi sangre del nuevo pacto, que es derramada por muchos. En verdad os digo: Ya no beberé más del fruto de la vid hasta aquel día cuando lo beba nuevo en el reino de Dios."
            },
            {
                "ref": "Lucas 22:19–20",
                "text": "Y habiendo tomado pan, después de haber dado gracias, lo partió, y les dio, diciendo: Esto es mi cuerpo que por vosotros es dado; haced esto en memoria de mí. De la misma manera tomó la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre, que es derramada por vosotros."
            },
            {
                "ref": "1 Corintios 1:22–26",
                "text": "Porque en verdad los judíos piden señales y los griegos buscan sabiduría; pero nosotros predicamos a Cristo crucificado, piedra de tropiezo para los judíos, y necedad para los gentiles; mas para los llamados, tanto judíos como griegos, Cristo es poder de Dios y sabiduría de Dios. Porque la necedad de Dios es más sabia que los hombres, y la debilidad de Dios es más fuerte que los hombres. Pues considerad, hermanos, vuestro llamamiento; no hubo muchos sabios conforme a la carne, ni muchos poderosos, ni muchos nobles;"
            },
            {
                "ref": "Galatas 3:27",
                "text": "Porque todos los que fuisteis bautizados en Cristo, de Cristo os habéis revestido."
            },
            {
                "ref": "1 Corintios 10:16–17",
                "text": "La copa de bendición que bendecimos, ¿no es la participación en la sangre de Cristo? El pan que partimos, ¿no es la participación en el cuerpo de Cristo? Puesto que el pan es uno, nosotros, que somos muchos, somos un cuerpo; pues todos participamos de aquel mismo pan."
            }
        ]
    },
    {
        number: 93,
        question: '¿Cuáles son los sacramentos del Nuevo Testamento?',
        answer: 'Los sacramentos del Nuevo Testamento son: "El Bautismo y la Cena del Señor."',
        proofs: [
            {
                "ref": "Mateo 28:19",
                "text": "Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo,"
            },
            {
                "ref": "1 Corintios 11:23–26",
                "text": "Porque yo recibí del Señor lo mismo que os he enseñado: que el Señor Jesús, la noche en que fue entregado, tomó pan, y después de dar gracias, lo partió y dijo: Esto es mi cuerpo que es para vosotros; haced esto en memoria de mí. De la misma manera tomó también la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre; haced esto cuantas veces la bebáis en memoria de mí. Porque todas las veces que comáis este pan y bebáis esta copa, la muerte del Señor proclamáis hasta que Él venga."
            }
        ]
    },
    {
        number: 94,
        question: '¿Qué es el Bautismo?',
        answer: 'El bautismo es un sacramento, en el cual, el lavamiento con agua, en nombre del Padre  del Hijo y del Espíritu Santo, significa y sella nuestra unión con Cristo, nuestra participación en los beneficios de la alianza de gracia y nuestro comprometimiento de ser del Señor."',
        proofs: [
            {
                "ref": "Mateo 28:19",
                "text": "Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo,"
            },
            {
                "ref": "Hechos 2:38–42",
                "text": "Y Pedro les dijo: Arrepentíos y sed bautizados cada uno de vosotros en el nombre de Jesucristo para perdón de vuestros pecados, y recibiréis el don del Espíritu Santo. Porque la promesa es para vosotros y para vuestros hijos y para todos los que están lejos, para tantos como el Señor nuestro Dios llame. Y con muchas otras palabras testificaba solemnemente y les exhortaba diciendo: Sed salvos de esta perversa generación. Entonces los que habían recibido su palabra fueron bautizados; y se añadieron aquel día como tres mil almas. Y se dedicaban continuamente a las enseñanzas de los apóstoles, a la comunión, al partimiento del pan y a la oración."
            },
            {
                "ref": "Hechos 22:16",
                "text": "Y ahora, ¿por qué te detienes? Levántate y bautízate, y lava tus pecados invocando su nombre»."
            },
            {
                "ref": "Romanos 6:3–4",
                "text": "¿O no sabéis que todos los que hemos sido bautizados en Cristo Jesús, hemos sido bautizados en su muerte? Por tanto, hemos sido sepultados con Él por medio del bautismo para muerte, a fin de que como Cristo resucitó de entre los muertos por la gloria del Padre, así también nosotros andemos en novedad de vida."
            },
            {
                "ref": "Galatas 3:26–27",
                "text": "pues todos sois hijos de Dios mediante la fe en Cristo Jesús. Porque todos los que fuisteis bautizados en Cristo, de Cristo os habéis revestido."
            },
            {
                "ref": "1 Pedro 3:21",
                "text": "Y correspondiendo a esto, el bautismo ahora os salva (no quitando la suciedad de la carne, sino como una petición a Dios de una buena conciencia) mediante la resurrección de Jesucristo,"
            }
        ]
    },
    {
        number: 95,
        question: '¿A quiénes ha de administrarse el Bautismo?',
        answer: 'El bautismo no debe administrarse a los que están fuera de la iglesia visible hasta que no profesen su fe en Cristo y su obediencia a él, más los párvulos de los que son miembros de la Iglesia visible, han de ser bautizados.',
        proofs: [
            {
                "ref": "Hechos 2:41",
                "text": "Entonces los que habían recibido su palabra fueron bautizados; y se añadieron aquel día como tres mil almas."
            },
            {
                "ref": "Hechos 8:12",
                "text": "Pero cuando creyeron a Felipe, que anunciaba las buenas nuevas del reino de Dios y el nombre de Cristo Jesús, se bautizaban, tanto hombres como mujeres."
            },
            {
                "ref": "Hechos 8:36",
                "text": "Yendo por el camino, llegaron a un lugar donde había agua; y el eunuco dijo*: Mira, agua. ¿Qué impide que yo sea bautizado?"
            },
            {
                "ref": "Hechos 8:38",
                "text": "Y mandó parar el carruaje; ambos descendieron al agua, Felipe y el eunuco, y lo bautizó."
            },
            {
                "ref": "Hechos 18:8",
                "text": "Y Crispo, el oficial de la sinagoga, creyó en el Señor con toda su casa, y muchos de los corintios, al oír, creían y eran bautizados."
            },
            {
                "ref": "Genesis 17:7",
                "text": "Y estableceré mi pacto contigo y con tu descendencia después de ti, por todas sus generaciones, por pacto eterno, de ser Dios tuyo y de toda tu descendencia después de ti."
            },
            {
                "ref": "Genesis 17:9–11",
                "text": "Dijo además Dios a Abraham: Tú, pues, guardarás mi pacto, tú y tu descendencia después de ti, por sus generaciones. Este es mi pacto que guardaréis, entre yo y vosotros y tu descendencia después de ti: Todo varón de entre vosotros será circuncidado. Seréis circuncidados en la carne de vuestro prepucio, y esto será la señal de mi pacto con vosotros."
            },
            {
                "ref": "Hechos 2:38–39",
                "text": "Y Pedro les dijo: Arrepentíos y sed bautizados cada uno de vosotros en el nombre de Jesucristo para perdón de vuestros pecados, y recibiréis el don del Espíritu Santo. Porque la promesa es para vosotros y para vuestros hijos y para todos los que están lejos, para tantos como el Señor nuestro Dios llame."
            },
            {
                "ref": "Hechos 16:32–33",
                "text": "Y le hablaron la palabra del Señor a él y a todos los que estaban en su casa. Y él los tomó en aquella misma hora de la noche, y les lavó las heridas; enseguida fue bautizado, él y todos los suyos."
            },
            {
                "ref": "Colosenses 2:11–12",
                "text": "en Él también fuisteis circuncidados con una circuncisión no hecha por manos, al quitar el cuerpo de la carne mediante la circuncisión de Cristo; habiendo sido sepultados con Él en el bautismo, en el cual también habéis resucitado con Él por la fe en la acción del poder de Dios, que le resucitó de entre los muertos."
            }
        ]
    },
    {
        number: 96,
        question: '¿Qué es la Cena del Señor?',
        answer: 'La Cena del Señor es un Sacramento por el cual, dando y recibiendo pan y vino según la ordenanza de Cristo, se simboliza su muerte, y aquellos que dignamente lo reciben, no son hechos de una manera corporal y carnal,  sino por la fe, partícipes de su cuerpo y sangre, como también de todos los beneficios  consiguientes,  lo cuál conduce a su nutrimiento espiritual y a su crecimiento en la gracia.',
        proofs: [
            {
                "ref": "Lucas 22:19–20",
                "text": "Y habiendo tomado pan, después de haber dado gracias, lo partió, y les dio, diciendo: Esto es mi cuerpo que por vosotros es dado; haced esto en memoria de mí. De la misma manera tomó la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre, que es derramada por vosotros."
            },
            {
                "ref": "1 Corintios 11:23–26",
                "text": "Porque yo recibí del Señor lo mismo que os he enseñado: que el Señor Jesús, la noche en que fue entregado, tomó pan, y después de dar gracias, lo partió y dijo: Esto es mi cuerpo que es para vosotros; haced esto en memoria de mí. De la misma manera tomó también la copa después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre; haced esto cuantas veces la bebáis en memoria de mí. Porque todas las veces que comáis este pan y bebáis esta copa, la muerte del Señor proclamáis hasta que Él venga."
            },
            {
                "ref": "1 Corintios 10:16–17",
                "text": "La copa de bendición que bendecimos, ¿no es la participación en la sangre de Cristo? El pan que partimos, ¿no es la participación en el cuerpo de Cristo? Puesto que el pan es uno, nosotros, que somos muchos, somos un cuerpo; pues todos participamos de aquel mismo pan."
            }
        ]
    },
    {
        number: 97,
        question: '¿Qué se requiere para recibir dignamente la Cena del Señor?',
        answer: 'Para que los participantes reciban dignamente la Cena del Señor, es necesario que hagan un examen del conocimiento que tienen para discernir el cuerpo del Señor, de su fe para alimentarse en él, de su arrepentimiento, amor y nueva obediencia, para que no sea, que recibiendo indignamente el sacramento, coman y beban su propia condenación.',
        proofs: [
            {
                "ref": "1 Corintios 11:27-32",
                "text": "De manera que el que coma el pan o beba la copa del Señor indignamente, será culpable del cuerpo y de la sangre del Señor. Por tanto, examínese cada uno a sí mismo, y entonces coma del pan y beba de la copa. Porque el que come y bebe sin discernir correctamente el cuerpo del Señor, come y bebe juicio para sí. Por esta razón hay muchos débiles y enfermos entre vosotros, y muchos duermen. Pero si nos juzgáramos a nosotros mismos, no seríamos juzgados. Pero cuando somos juzgados, el Señor nos disciplina para que no seamos condenados con el mundo."
            }
        ]
    },
    {
        number: 98,
        question: '¿Qué es la oración?',
        answer: 'La oración es un acto por el cual manifestamos a Dios, en nombre de Cristo, nuestros deseos de obtener aquello que sea conforme a su voluntad, confesando al mismo tiempo nuestros pecados y reconociendo con gratitud sus beneficios.',
        proofs: [
            {
                "ref": "Salmos 10:17",
                "text": "Oh Señor, tú has oído el deseo de los humildes; tú fortalecerás su corazón e inclinarás tu oído"
            },
            {
                "ref": "Salmos 62:8",
                "text": "Confiad en Él en todo tiempo, oh pueblo; derramad vuestro corazón delante de Él; Dios es nuestro refugio."
            },
            {
                "ref": "Mateo 7:7–8",
                "text": "Pedid, y se os dará; buscad, y hallaréis; llamad, y se os abrirá. Porque todo el que pide, recibe; y el que busca, halla; y al que llama, se le abrirá."
            },
            {
                "ref": "1 Juan 5:14",
                "text": "Y esta es la confianza que tenemos delante de Él, que si pedimos cualquier cosa conforme a su voluntad, Él nos oye."
            },
            {
                "ref": "Juan 16:23–24",
                "text": "En aquel día no me preguntaréis nada. En verdad, en verdad os digo: si pedís algo al Padre, os lo dará en mi nombre. Hasta ahora nada habéis pedido en mi nombre; pedid y recibiréis, para que vuestro gozo sea completo."
            },
            {
                "ref": "Salmos 32:5–6",
                "text": "Te manifesté mi pecado, y no encubrí mi iniquidad. Dije: Confesaré mis transgresiones al Señor; y tú perdonaste la culpa de mi pecado.  Por eso, que todo santo ore a ti en el tiempo en que puedas ser hallado; ciertamente, en la inundación de muchas aguas, no llegarán estas a él."
            },
            {
                "ref": "Daniel 9:4–19",
                "text": "Y oré al Señor mi Dios e hice confesión y dije: Ay, Señor, el Dios grande y temible, que guarda el pacto y la misericordia para los que le aman y guardan sus mandamientos, hemos pecado, hemos cometido iniquidad, hemos hecho lo malo, nos hemos rebelado y nos hemos apartado de tus mandamientos y de tus ordenanzas. No hemos escuchado a tus siervos los profetas que hablaron en tu nombre a nuestros reyes, a nuestros príncipes, a nuestros padres y a todo el pueblo de la tierra. Tuya es la justicia, oh Señor, y nuestra la vergüenza en el rostro, como sucede hoy a los hombres de Judá, a los habitantes de Jerusalén y a todo Israel, a los que están cerca y a los que están lejos en todos los países adonde los has echado, a causa de las infidelidades que cometieron contra ti. Oh Señor, nuestra es la vergüenza del rostro, y de nuestros reyes, de nuestros príncipes y de nuestros padres, porque hemos pecado contra ti. Al Señor nuestro Dios pertenece la compasión y el perdón, porque nos hemos rebelado contra Él, y no hemos obedecido la voz del Señor nuestro Dios para andar en sus enseñanzas, que Él puso delante de nosotros por medio de sus siervos los profetas. Ciertamente todo Israel ha transgredido tu ley y se ha apartado, sin querer obedecer tu voz; por eso ha sido derramada sobre nosotros la maldición y el juramento que está escrito en la ley de Moisés, siervo de Dios, porque hemos pecado contra Él. Y Él ha confirmado las palabras que habló contra nosotros y contra nuestros jefes que nos gobernaron, trayendo sobre nosotros gran calamidad, pues nunca se ha hecho debajo del cielo nada como lo que se ha hecho contra Jerusalén. Como está escrito en la ley de Moisés, toda esta calamidad ha venido sobre nosotros, pero no hemos buscado el favor del Señor nuestro Dios, apartándonos de nuestra iniquidad y prestando atención a tu verdad. Por tanto, el Señor ha estado guardando esta calamidad y la ha traído sobre nosotros; porque el Señor nuestro Dios es justo en todas las obras que ha hecho, pero nosotros no hemos obedecido su voz. Y ahora, Señor Dios nuestro, que sacaste a tu pueblo de la tierra de Egipto con mano poderosa, y te has hecho un nombre, como hoy se ve, hemos pecado, hemos sido malos. Oh Señor, conforme a todos tus actos de justicia, apártese ahora tu ira y tu furor de tu ciudad, Jerusalén, tu santo monte; porque a causa de nuestros pecados y de las iniquidades de nuestros padres, Jerusalén y tu pueblo son el oprobio de todos los que nos rodean. Y ahora, Dios nuestro, escucha la oración de tu siervo y sus súplicas, y haz resplandecer tu rostro sobre tu santuario desolado, por amor de ti mismo, oh Señor. Inclina tu oído, Dios mío, y escucha. Abre tus ojos y mira nuestras desolaciones y la ciudad sobre la cual se invoca tu nombre; pues no es por nuestros propios méritos que presentamos nuestras súplicas delante de ti, sino por tu gran compasión. ¡Oh Señor, escucha! ¡Señor, perdona! ¡Señor, atiende y actúa! ¡No tardes, por amor de ti mismo, Dios mío! Porque tu nombre se invoca sobre tu ciudad y sobre tu pueblo."
            },
            {
                "ref": "1 Juan 1:9",
                "text": "Si confesamos nuestros pecados, Él es fiel y justo para perdonarnos los pecados y para limpiarnos de toda maldad."
            },
            {
                "ref": "Salmos 103:1–5",
                "text": "Bendice, alma mía, al Señor, y bendiga todo mi ser su santo nombre. Bendice, alma mía, al Señor, y no olvides ninguno de sus beneficios. Él es el que perdona todas tus iniquidades, el que sana todas tus enfermedades; el que rescata de la fosa tu vida, el que te corona de bondad y compasión; el que colma de bienes tus años, para que tu juventud se renueve como el águila."
            },
            {
                "ref": "Salmos 136",
                "text": "Dad gracias al Señor porque Él es bueno, porque para siempre es su misericordia. Dad gracias al Dios de dioses, porque para siempre es su misericordia. Dad gracias al Señor de señores, porque para siempre es su misericordia. Al único que hace grandes maravillas, porque para siempre es su misericordia. Al que con sabiduría hizo los cielos, porque para siempre es su misericordia. Al que extendió la tierra sobre las aguas, porque para siempre es su misericordia. Al que hizo las grandes lumbreras, porque para siempre es su misericordia: el sol para que reine de día, porque para siempre es su misericordia; la luna y las estrellas para que reinen de noche, porque para siempre es su misericordia. Al que hirió a Egipto en sus primogénitos, porque para siempre es su misericordia; y sacó a Israel de en medio de ellos, porque para siempre es su misericordia, con mano fuerte y brazo extendido, porque para siempre es su misericordia. Al que dividió en dos partes el mar Rojo, porque para siempre es su misericordia, e hizo pasar a Israel por en medio de él, porque para siempre es su misericordia; mas a Faraón y a su ejército destruyó en el mar Rojo, porque para siempre es su misericordia. Al que condujo a su pueblo por el desierto, porque para siempre es su misericordia; al que hirió a grandes reyes, porque para siempre es su misericordia; y mató a reyes poderosos, porque para siempre es su misericordia; a Sehón, rey de los amorreos, porque para siempre es su misericordia, y a Og, rey de Basán, porque para siempre es su misericordia; y dio la tierra de ellos en heredad, porque para siempre es su misericordia, en heredad a Israel su siervo, porque para siempre es su misericordia. El que se acordó de nosotros en nuestra humillación, porque para siempre es su misericordia, y nos rescató de nuestros adversarios, porque para siempre es su misericordia. El que da sustento a toda carne, porque para siempre es su misericordia. Dad gracias al Dios del cielo, porque para siempre es su misericordia."
            },
            {
                "ref": "Filipenses 4:6",
                "text": "Por nada estéis afanosos; antes bien, en todo, mediante oración y súplica con acción de gracias, sean dadas a conocer vuestras peticiones delante de Dios."
            }
        ]
    },
    {
        number: 99,
        question: '¿Qué regla nos ha dado Dios para dirigirnos en la oración?',
        answer: 'Toda la palabra de Dios es útil para dirigirnos en la oración, pero la regla especial es aquella oración que Cristo enseñó a sus discípulos y que comúnmente se llama "La Oración del Señor".',
        proofs: [
            {
                "ref": "1 Juan 5:14",
                "text": "Y esta es la confianza que tenemos delante de Él, que si pedimos cualquier cosa conforme a su voluntad, Él nos oye."
            },
            {
                "ref": "Mateo 6:9–13",
                "text": "Vosotros, pues, orad de esta manera: «Padre nuestro que estás en los cielos, santificado sea tu nombre. Venga tu reino. Hágase tu voluntad, así en la tierra como en el cielo. Danos hoy el pan nuestro de cada día. Y perdónanos nuestras deudas, como también nosotros hemos perdonado a nuestros deudores. Y no nos metas en tentación, mas líbranos del mal. Porque tuyo es el reino y el poder y la gloria para siempre jamás. Amén»."
            }
        ]
    },
    {
        number: 100,
        question: '¿Qué nos enseña el prefacio de la Oración del Señor?',
        answer: 'El prefacio de "La Oración del Señor", que dice: "Padre nuestro, que está en los cielos", nos enseña a acercarnos con santa reverencia y toda confianza a Dios como a un padre que puede y quiere socorrernos, y también a orar con otros y por otros.',
        proofs: [
            {
                "ref": "Salmos 95:6",
                "text": "Venid, adoremos y postrémonos; doblemos la rodilla ante el Señor nuestro Hacedor."
            },
            {
                "ref": "Efesios 3:12",
                "text": "en quien tenemos libertad y acceso a Dios con confianza por medio de la fe en Él."
            },
            {
                "ref": "Mateo 7:9–11",
                "text": "¿O qué hombre hay entre vosotros que si su hijo le pide pan, le dará una piedra, o si le pide un pescado, le dará una serpiente? Pues si vosotros, siendo malos, sabéis dar buenas dádivas a vuestros hijos, ¿cuánto más vuestro Padre que está en los cielos dará cosas buenas a los que le piden?"
            },
            {
                "ref": "Lucas 11:11–13",
                "text": "O suponed que a uno de vosotros que es padre, su hijo le pide pan; ¿acaso le dará una piedra? O si le pide un pescado; ¿acaso le dará una serpiente en lugar del pescado? O si le pide un huevo; ¿acaso le dará un escorpión? Pues si vosotros siendo malos, sabéis dar buenas dádivas a vuestros hijos, ¿cuánto más vuestro Padre celestial dará el Espíritu Santo a los que se lo pidan?"
            },
            {
                "ref": "Romanos 8:15",
                "text": "Pues no habéis recibido un espíritu de esclavitud para volver otra vez al temor, sino que habéis recibido un espíritu de adopción como hijos, por el cual clamamos: ¡Abba, Padre!"
            },
            {
                "ref": "Efesios 3:20",
                "text": "Y a aquel que es poderoso para hacer todo mucho más abundantemente de lo que pedimos o entendemos, según el poder que obra en nosotros,"
            },
            {
                "ref": "Efesios 6:18",
                "text": "Con toda oración y súplica orad en todo tiempo en el Espíritu, y así, velad con toda perseverancia y súplica por todos los santos;"
            },
            {
                "ref": "1 Timoteo 2:1–2",
                "text": "Exhorto, pues, ante todo que se hagan rogativas, oraciones, peticiones y acciones de gracias por todos los hombres; por los reyes y por todos los que están en autoridad, para que podamos vivir una vida tranquila y sosegada con toda piedad y dignidad."
            }
        ]
    },
    {
        number: 101,
        question: '¿Qué rogamos en la primera petición?',
        answer: 'En la primera petición, que dice: "Santificado sea tu nombre", rogamos que Dios nos ayude nosotros y a los demás hombres a  glorificarle en  todo aquello por lo cual se da a conocer, y también que él disponga todas las cosas para su propia gloria.',
        proofs: [
            {
                "ref": "Salmos 67:1–3",
                "text": "Dios tenga piedad de nosotros y nos bendiga, y haga resplandecer su rostro sobre nosotros; (Selah) para que sea conocido en la tierra tu camino, entre todas las naciones tu salvación. Te den gracias los pueblos, oh Dios, todos los pueblos te den gracias."
            },
            {
                "ref": "Salmos 99:3",
                "text": "Alaben tu nombre grande y temible; Él es santo."
            },
            {
                "ref": "Salmos 100:3–4",
                "text": "Sabed que Él, el Señor, es Dios; Él nos hizo, y no nosotros a nosotros mismos; pueblo suyo somos y ovejas de su prado. Entrad por sus puertas con acción de gracias, y a sus atrios con alabanza. Dadle gracias, bendecid su nombre."
            },
            {
                "ref": "Romanos 11:33–36",
                "text": "¡Oh, profundidad de las riquezas y de la sabiduría y del conocimiento de Dios! ¡Cuán insondables son sus juicios e inescrutables sus caminos! Pues, ¿quién ha conocido la mente del Señor?, ¿o quién llego a ser su consejero?, ¿o quién le ha dado a Él primero para que se le tenga que recompensar? Porque de Él, por Él y para Él son todas las cosas. A Él sea la gloria para siempre. Amén."
            },
            {
                "ref": "Apocalipsis 4:11",
                "text": "Digno eres, Señor y Dios nuestro, de recibir la gloria y el honor y el poder, porque tú creaste todas las cosas, y por tu voluntad existen y fueron creadas."
            }
        ]
    },
    {
        number: 102,
        question: '¿Qué rogamos en la segunda petición?',
        answer: 'En la segunda petición que dice: "Venga tu reino", rogamos la destrucción del reino de Satanás, el progreso del reino de gracia, que nosotros y los demás hombres seamos introducidos y  conservados en éste, y que venga pronto el reino de gloria.',
        proofs: [
            {
                "ref": "Mateo 12:25–28",
                "text": "Y conociendo Jesús sus pensamientos, les dijo: Todo reino dividido contra sí mismo es asolado, y toda ciudad o casa dividida contra sí misma no se mantendrá en pie. Y si Satanás expulsa a Satanás, está dividido contra sí mismo; ¿cómo puede entonces mantenerse en pie su reino? Y si yo expulso los demonios por Beelzebú, ¿por quién los expulsan vuestros hijos? Por tanto, ellos serán vuestros jueces. Pero si yo expulso los demonios por el Espíritu de Dios, entonces el reino de Dios ha llegado a vosotros."
            },
            {
                "ref": "Romanos 16:20",
                "text": "Y el Dios de paz aplastará pronto a Satanás debajo de vuestros pies. La gracia de nuestro Señor Jesucristo sea con vosotros."
            },
            {
                "ref": "1 Juan 3:8",
                "text": "El que practica el pecado es del diablo, porque el diablo ha pecado desde el principio. El Hijo de Dios se manifestó con este propósito: para destruir las obras del diablo."
            },
            {
                "ref": "Salmos 72:8–11",
                "text": "Domine él de mar a mar, y desde el río hasta los confines de la tierra. Dobléguense ante él los moradores del desierto, y sus enemigos laman el polvo. Los reyes de Tarsis y de las islas traigan presentes; los reyes de Sabá y de Seba ofrezcan tributo; y póstrense ante él todos los reyes de la tierra; sírvanle todas las naciones."
            },
            {
                "ref": "Mateo 24:14",
                "text": "Y este evangelio del reino se predicará en todo el mundo como testimonio a todas las naciones, y entonces vendrá el fin."
            },
            {
                "ref": "1 Corintios 15:24–25",
                "text": "entonces vendrá el fin, cuando Él entregue el reino al Dios y Padre, después que haya abolido todo dominio y toda autoridad y poder. Pues Cristo debe reinar hasta que haya puesto a todos sus enemigos debajo de sus pies."
            },
            {
                "ref": "Salmos 119:5",
                "text": "¡Ojalá mis caminos sean afirmados para guardar tus estatutos!"
            },
            {
                "ref": "2 Tesalonicenses 3:1–5",
                "text": "Finalmente , hermanos, orad por nosotros, para que la palabra del Señor se extienda rápidamente y sea glorificada, así como sucedió también con vosotros; y para que seamos librados de hombres perversos y malos, porque no todos tienen fe. Pero fiel es el Señor quien os fortalecerá y protegerá del maligno. Y tenemos confianza en el Señor respecto de vosotros, de que hacéis y haréis lo que ordenamos. Que el Señor dirija vuestros corazones hacia el amor de Dios y hacia la perseverancia de Cristo."
            },
            {
                "ref": "Apocalipsis 22:20",
                "text": "Él que testifica de estas cosas dice: Sí, vengo pronto. Amén. Ven, Señor Jesús."
            }
        ]
    },
    {
        number: 103,
        question: '¿Qué rogamos en la tercera petición?',
        answer: 'En la tercera petición, que dice: "Sea hecha tu voluntad como en el cielo así también en la tierra, rogamos que Dios, por su gracia nos dé facultad y buena disposición para conocer, obedece y someternos en todo a su santa voluntad, así como lo hacen los ángeles en el cielo.',
        proofs: [
            {
                "ref": "Mateo 6:10",
                "text": "Venga tu reino. Hágase tu voluntad, así en la tierra como en el cielo."
            },
            {
                "ref": "Salmo 67",
                "text": "Dios tenga piedad de nosotros y nos bendiga, y haga resplandecer su rostro sobre nosotros; (Selah) para que sea conocido en la tierra tu camino, entre todas las naciones tu salvación. Te den gracias los pueblos, oh Dios, todos los pueblos te den gracias. Alégrense y canten con júbilo las naciones, porque tú juzgarás a los pueblos con equidad, y guiarás a las naciones en la tierra.  Te den gracias los pueblos, oh Dios, todos los pueblos te den gracias. La tierra ha dado su fruto; Dios, nuestro Dios, nos bendice. Dios nos bendice, para que le teman todos los términos de la tierra."
            },
            {
                "ref": "Salmo 119:36",
                "text": "Inclina mi corazón a tus testimonios y no a la ganancia deshonesta."
            },
            {
                "ref": "Mateo 26:39",
                "text": "Y adelantándose un poco, cayó sobre su rostro, orando y diciendo: Padre mío, si es posible, que pase de mí esta copa; pero no sea como yo quiero, sino como tú quieras."
            },
            {
                "ref": "2 Samuel 15:25",
                "text": "Y el rey dijo a Sadoc: Haz volver el arca de Dios a la ciudad, que si hallo gracia ante los ojos del Señor, me hará volver y me mostrará tanto el arca como su morada."
            },
            {
                "ref": "Job 1:21",
                "text": "y dijo: Desnudo salí del vientre de mi madre y desnudo volveré allá. El Señor dio y el Señor quitó; bendito sea el nombre del Señor."
            },
            {
                "ref": "Salmo 103:20-21",
                "text": "Bendecid al Señor, vosotros sus ángeles, poderosos en fortaleza, que ejecutáis su mandato, obedeciendo la voz de su palabra. Bendecid al Señor, vosotros todos sus ejércitos, que le servís haciendo su voluntad."
            }
        ]
    },
    {
        number: 104,
        question: '¿Qué rogamos en la cuarta petición?',
        answer: 'En la cuarta petición que dice: "Danos hoy nuestro pan cotidiano" rogamos a Dios, el dador de todo lo bueno, que nos dé una porción suficiente de las cosas temporales, y que con ella nos conceda  el goce de su bendición.',
        proofs: [
            {
                "ref": "Proverbios 30:8–9",
                "text": "Aleja de mí la mentira y las palabras engañosas, no me des pobreza ni riqueza; dame a comer mi porción de pan, no sea que me sacie y te niegue, y diga: ¿Quién es el Señor?, o que sea menesteroso y robe, y profane el nombre de mi Dios."
            },
            {
                "ref": "Mateo 6:31–34",
                "text": "Por tanto, no os preocupéis, diciendo: «¿Qué comeremos?» o «¿qué beberemos?» o «¿con qué nos vestiremos?». Porque los gentiles buscan ansiosamente todas estas cosas; que vuestro Padre celestial sabe que necesitáis de todas estas cosas. Pero buscad primero su reino y su justicia, y todas estas cosas os serán añadidas. Por tanto, no os preocupéis por el día de mañana; porque el día de mañana se cuidará de sí mismo. Bástele a cada día sus propios problemas."
            },
            {
                "ref": "Filipenses 4:11",
                "text": "No que hable porque tenga escasez, pues he aprendido a contentarme cualquiera que sea mi situación."
            },
            {
                "ref": "Filipenses 4:19",
                "text": "Y mi Dios proveerá a todas vuestras necesidades, conforme a sus riquezas en gloria en Cristo Jesús."
            },
            {
                "ref": "1 Timoteo 6:6–8",
                "text": "Pero la piedad, en efecto, es un medio de gran ganancia cuando va acompañada de contentamiento. Porque nada hemos traído al mundo, así que nada podemos sacar de él. Y si tenemos qué comer y con qué cubrirnos, con eso estaremos contentos."
            }
        ]
    },
    {
        number: 105,
        question: '¿Qué rogamos en la quinta petición?',
        answer: 'En la quinta petición que dice: "Perdónanos nuestras deudas, como también nosotros perdonamos a nuestros deudores", rogamos que Dios, por amor a Cristo, perdone gratuitamente todos nuestros pecados, y somos estimulados a pedir esto, porque por su gracia, nos hallamos capaces de perdonar sinceramente a otros.',
        proofs: [
            {
                "ref": "Salmos 51:1–2",
                "text": "Ten piedad de mí, oh Dios, conforme a tu misericordia; conforme a lo inmenso de tu compasión, borra mis transgresiones. Lávame por completo de mi maldad, y límpiame de mi pecado."
            },
            {
                "ref": "Salmos 51:7",
                "text": "Purifícame con hisopo, y seré limpio; lávame, y seré más blanco que la nieve."
            },
            {
                "ref": "Salmos 51:9",
                "text": "Esconde tu rostro de mis pecados, y borra todas mis iniquidades."
            },
            {
                "ref": "Daniel 9:17–19",
                "text": "Y ahora, Dios nuestro, escucha la oración de tu siervo y sus súplicas, y haz resplandecer tu rostro sobre tu santuario desolado, por amor de ti mismo, oh Señor. Inclina tu oído, Dios mío, y escucha. Abre tus ojos y mira nuestras desolaciones y la ciudad sobre la cual se invoca tu nombre; pues no es por nuestros propios méritos que presentamos nuestras súplicas delante de ti, sino por tu gran compasión. ¡Oh Señor, escucha! ¡Señor, perdona! ¡Señor, atiende y actúa! ¡No tardes, por amor de ti mismo, Dios mío! Porque tu nombre se invoca sobre tu ciudad y sobre tu pueblo."
            },
            {
                "ref": "1 Juan 1:7",
                "text": "mas si andamos en la luz, como Él está en la luz, tenemos comunión los unos con los otros, y la sangre de Jesús su Hijo nos limpia de todo pecado."
            },
            {
                "ref": "Mateo 18:21–35",
                "text": "Entonces se le acercó Pedro, y le dijo: Señor, ¿cuántas veces pecará mi hermano contra mí que yo haya de perdonarlo? ¿Hasta siete veces? Jesús le dijo*: No te digo hasta siete veces, sino hasta setenta veces siete. Por eso, el reino de los cielos puede compararse a cierto rey que quiso ajustar cuentas con sus siervos. Y al comenzar a ajustarlas, le fue presentado uno que le debía diez mil talentos. Pero no teniendo él con qué pagar, su señor ordenó que lo vendieran, junto con su mujer e hijos y todo cuanto poseía, y así pagara la deuda. Entonces el siervo cayó postrado ante él, diciendo: «Ten paciencia conmigo y todo te lo pagaré». Y el señor de aquel siervo tuvo compasión, y lo soltó y le perdonó la deuda. Pero al salir aquel siervo, encontró a uno de sus consiervos que le debía cien denarios, y echándole mano, lo ahogaba, diciendo: «Paga lo que debes». Entonces su consiervo, cayendo a sus pies, le suplicaba, diciendo: «Ten paciencia conmigo y te pagaré». Sin embargo, él no quiso, sino que fue y lo echó en la cárcel hasta que pagara lo que debía. Así que cuando vieron sus consiervos lo que había pasado, se entristecieron mucho, y fueron y contaron a su señor todo lo que había sucedido. Entonces, llamándolo su señor, le dijo*: «Siervo malvado, te perdoné toda aquella deuda porque me suplicaste. ¿No deberías tú también haberte compadecido de tu consiervo, así como yo me compadecí de ti?». Y enfurecido su señor, lo entregó a los verdugos hasta que pagara todo lo que le debía. Así también mi Padre celestial hará con vosotros, si no perdonáis de corazón cada uno a su hermano."
            },
            {
                "ref": "Efesios 4:32",
                "text": "Sed más bien amables unos con otros, misericordiosos, perdonándoos unos a otros, así como también Dios os perdonó en Cristo."
            },
            {
                "ref": "Colosenses 3:13",
                "text": "soportándoos unos a otros y perdonándoos unos a otros, si alguno tiene queja contra otro; como Cristo os perdonó, así también hacedlo vosotros."
            }
        ]
    },
    {
        number: 106,
        question: '¿Qué rogamos en la sexta petición?',
        answer: 'En la sexta petición, que dice: "No nos metas en tentación más líbranos del mal", rogamos que Dios nos guarde de ser tentados a pecar, o que nos sostenga y nos libre cuando seamos tentados.',
        proofs: [
            {
                "ref": "Salmos 19:13",
                "text": "Guarda también a tu siervo de pecados de soberbia; que no se enseñoreen de mí. Entonces seré íntegro, y seré absuelto de gran transgresión."
            },
            {
                "ref": "Mateo 26:41",
                "text": "Velad y orad para que no entréis en tentación; el espíritu está dispuesto, pero la carne es débil."
            },
            {
                "ref": "Juan 17:15",
                "text": "No te ruego que los saques del mundo, sino que los guardes del maligno."
            },
            {
                "ref": "Lucas 22:31–32",
                "text": "Simón, Simón, mira que Satanás os ha reclamado para zarandearos como a trigo; pero yo he rogado por ti para que tu fe no falle; y tú, una vez que hayas regresado, fortalece a tus hermanos."
            },
            {
                "ref": "1 Corintios 10:13",
                "text": "No os ha sobrevenido ninguna tentación que no sea común a los hombres; y fiel es Dios, que no permitirá que vosotros seáis tentados más allá de lo que podéis soportar, sino que con la tentación proveerá también la vía de escape, a fin de que podáis resistirla."
            },
            {
                "ref": "2 Corintios 12:7–9",
                "text": "Y dada la extraordinaria grandeza de las revelaciones, por esta razón, para impedir que me enalteciera, me fue dada una espina en la carne, un mensajero de Satanás que me abofetee, para que no me enaltezca. Acerca de esto, tres veces he rogado al Señor para que lo quitara de mí. Y Él me ha dicho: Te basta mi gracia, pues mi poder se perfecciona en la debilidad. Por tanto, muy gustosamente me gloriaré más bien en mis debilidades, para que el poder de Cristo more en mí."
            },
            {
                "ref": "Hebreos 2:18",
                "text": "Pues por cuanto Él mismo fue tentado en el sufrimiento, es poderoso para socorrer a los que son tentados."
            }
        ]
    }
];

export default MenorItems;
